(() => {

    if (window.__digiNewConfigurator) return;
    window.__digiNewConfigurator = true;

    if (typeof digi__rawMaterialData === 'undefined' || !digi__rawMaterialData) return;
    if (typeof digi__rawMaterialGroupData === 'undefined' || !digi__rawMaterialGroupData) return;
    if (typeof digi__rawProductDimensionsAndSpec === 'undefined' || !digi__rawProductDimensionsAndSpec) return;
    if (typeof digi__translateData === 'undefined' || !digi__translateData) return;
    if (!document.querySelector('script#digi__mattress-data')) return;
    if (!document.querySelector('script#digi__total-width__custom-variants')) return;

    const WEB_LANG = document.documentElement?.lang?.trim() || navigator.language || 'en';
    const allowLangConfig = ['pl', 'de', 'cs'];
    if (!allowLangConfig.includes(WEB_LANG.toLowerCase())) return;


    const waitForElement = (selector, callback) => {
        const existingElement = document.querySelector(selector);

        if (existingElement) {
            callback(existingElement);
            return;
        }

        const observer = new MutationObserver(() => {
            const element = document.querySelector(selector);

            if (element) {
                observer.disconnect();
                callback(element);
            }
        });

        observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
        });
    };

    const returnMaterialsData = () => {
        const rawMaterialData = digi__rawMaterialData;
        const rawMaterialGroupData = digi__rawMaterialGroupData;

        document.querySelector('script#digi__material-data')?.remove();

        return {
            colors: rawMaterialData,
            groups: rawMaterialGroupData
        };
    };

    const returnProductData = () => {
        const rawProductData = digi__rawProductDimensionsAndSpec;
        document.querySelector('script#digi__product-dimensions-and-spec')?.remove();

        return rawProductData;
    };

    const returnTranslateData = () => {
        const translateData = digi__translateData;
        document.querySelector('script#digi__translate-data')?.remove();

        const translateObj = {
            "box__sleep_size": {
                "sleep_size": translateData.box__sleep_size.sleep_size,
                "size_table": translateData.box__sleep_size.size_table,
                "aside_panel_content": {
                    "dimensions_for_selected_sleeping_surface": translateData.box__sleep_size.aside_panel_content.dimensions_for_selected_sleeping_surface,
                    "dimensions": {
                        "sleeping_length": translateData.box__sleep_size.aside_panel_content.dimensions.sleeping_length,
                        "sleeping_width": translateData.box__sleep_size.aside_panel_content.dimensions.sleeping_width,
                        "total_length": translateData.box__sleep_size.aside_panel_content.dimensions.total_length,
                        "total_width": translateData.box__sleep_size.aside_panel_content.dimensions.total_width,
                        "total_height": translateData.box__sleep_size.aside_panel_content.dimensions.total_height,
                        "seat_depth": translateData.box__sleep_size.aside_panel_content.dimensions.seat_depth,
                        "seat_height": translateData.box__sleep_size.aside_panel_content.dimensions.seat_height,
                        "backrest_width": translateData.box__sleep_size.aside_panel_content.dimensions.backrest_width,
                        "side_width": translateData.box__sleep_size.aside_panel_content.dimensions.side_width,
                        "side_height": translateData.box__sleep_size.aside_panel_content.dimensions.side_height,
                        "depth": translateData.box__sleep_size.aside_panel_content.dimensions.depth
                    }
                }
            },
            "box__material": {
                "options": {
                    "one": translateData.box__material.options.one,
                    "few": translateData.box__material.options.few,
                    "many": translateData.box__material.options.many,
                    "other": translateData.box__material.options.other
                },
                "material_and_color": translateData.box__material.material_and_color,
                "more_about_this_material": translateData.box__material.more_about_this_material,
                "material": translateData.box__material.material,
                "color": translateData.box__material.color,
                "aside_panel_content": {
                    "specification": translateData.box__material.aside_panel_content.specification,
                    "choose_material_and_color": translateData.box__material.aside_panel_content.choose_material_and_color,
                    "free_fabric_samples__bar": {
                        "cta": translateData.box__material.aside_panel_content.free_fabric_samples__bar.cta
                    },
                    "material_box": {
                        "fabric": translateData.box__material.aside_panel_content.material_box.fabric,
                        "video_sampler__version": {
                            "desktop": translateData.box__material.aside_panel_content.material_box.video_sampler__version.desktop,
                            "mobile": translateData.box__material.aside_panel_content.material_box.video_sampler__version.mobile
                        }
                    },
                    "filters": {
                        "fabric_properties": {
                            "title": translateData.box__material.aside_panel_content.filters.fabric_properties.title,
                            "single_selected_filter": translateData.box__material.aside_panel_content.filters.fabric_properties.single_selected_filter
                        },
                        "colors": {
                            "title": translateData.box__material.aside_panel_content.filters.colors.title,
                            "single_selected_filter": translateData.box__material.aside_panel_content.filters.colors.single_selected_filter
                        },
                        "no_results": {
                            "title": translateData.box__material.aside_panel_content.filters.no_results.title,
                            "subtitle": translateData.box__material.aside_panel_content.filters.no_results.subtitle
                        },
                        "reset_filters": translateData.box__material.aside_panel_content.filters.reset_filters
                    },
                    "material_preview": {
                        "title": translateData.box__material.aside_panel_content.material_preview.title
                    }
                }
            },
            "box__sleep_function": {
                "yes": translateData.box__sleep_function.yes,
                "no": translateData.box__sleep_function.no,
                "sleep_function": translateData.box__sleep_function.sleep_function,
                "details": translateData.box__sleep_function.details,
                "aside_panel_content": {
                    "why_is_it_worth_it": {
                        "title": translateData.box__sleep_function.aside_panel_content.why_is_it_worth_it.title,
                        "content": {
                            "li_1": translateData.box__sleep_function.aside_panel_content.why_is_it_worth_it.content.li_1,
                            "li_2": translateData.box__sleep_function.aside_panel_content.why_is_it_worth_it.content.li_2,
                            "li_3": translateData.box__sleep_function.aside_panel_content.why_is_it_worth_it.content.li_3,
                            "li_4": translateData.box__sleep_function.aside_panel_content.why_is_it_worth_it.content.li_4
                        }
                    },
                    "sizes": translateData.box__sleep_function.aside_panel_content.sizes
                }
            },
            "box__layout": {
                "left": translateData.box__layout.left,
                "right": translateData.box__layout.right,
                "side": translateData.box__layout.side
            },
            "box__mattress": {
                "choose_mattress": translateData.box__mattress.choose_mattress,
                "change_mattress": translateData.box__mattress.change_mattress,
                "mattress": translateData.box__mattress.mattress,
                "from_PRICE_CURRENCY": translateData.box__mattress.from_PRICE_CURRENCY,
                "aside_panel_content": {
                    "how_to_choose_a_mattress_and_firmness": {
                        "cta": translateData.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.cta,
                        "description": {
                            "p1": translateData.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.description.p1,
                            "p2": translateData.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.description.p2
                        },
                        "legend": {
                            "firmness": {
                                "h2": translateData.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.legend.firmness.h2,
                                "h3": translateData.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.legend.firmness.h3,
                                "h4": translateData.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.legend.firmness.h4
                            }
                        },
                        "firmnessTable": {
                            "title": {
                                "female": translateData.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.firmnessTable.title.female,
                                "male": translateData.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.firmnessTable.title.male
                            }
                        }
                    },
                    "X_types_of_hardness_to_choose": {
                        "one": translateData.box__mattress.aside_panel_content.X_types_of_hardness_to_choose.one,
                        "few": translateData.box__mattress.aside_panel_content.X_types_of_hardness_to_choose.few,
                        "many": translateData.box__mattress.aside_panel_content.X_types_of_hardness_to_choose.many,
                        "other": translateData.box__mattress.aside_panel_content.X_types_of_hardness_to_choose.other
                    },
                    "X_cm_height": translateData.box__mattress.aside_panel_content.X_cm_height,
                    "read_more": translateData.box__mattress.aside_panel_content.read_more
                }
            },
            "box__pillow_filling": {
                "type_of_filling": translateData.box__pillow_filling.type_of_filling,
                "details": translateData.box__pillow_filling.details,
                "aside_panel_content": {
                    "title": translateData.box__pillow_filling.aside_panel_content.title,
                    "description": translateData.box__pillow_filling.aside_panel_content.description,
                    "option1": {
                        "title": translateData.box__pillow_filling.aside_panel_content.option1.title,
                        "description": translateData.box__pillow_filling.aside_panel_content.option1.description
                    },
                    "option2": {
                        "title": translateData.box__pillow_filling.aside_panel_content.option2.title,
                        "description": translateData.box__pillow_filling.aside_panel_content.option2.description
                    }
                }
            },
            "box__width": {
                "width": translateData.box__width.width,
                "full_size": translateData.box__width.full_size
            },
            "aside_panel": {
                "header": {
                    "close": translateData.aside_panel.header.close,
                    "save_and_close": translateData.aside_panel.header.save_and_close
                }
            },
            "save_configuration": {
                "button": {
                    "cta": translateData.save_configuration.button.cta
                },
                "popup": {
                    "content": {
                        "view_nr_1": {
                            "title": translateData.save_configuration.popup.content.view_nr_1.title,
                            "subtitle": translateData.save_configuration.popup.content.view_nr_1.subtitle,
                            "buttons": {
                                "send_to_email": translateData.save_configuration.popup.content.view_nr_1.buttons.send_to_email,
                                "download_pdf": translateData.save_configuration.popup.content.view_nr_1.buttons.download_pdf,
                                "copy_link": translateData.save_configuration.popup.content.view_nr_1.buttons.copy_link
                            }
                        },
                        "view_nr_2": {
                            "title": translateData.save_configuration.popup.content.view_nr_2.title,
                            "subtitle": translateData.save_configuration.popup.content.view_nr_2.subtitle,
                            "form": {
                                "input_email": {
                                    "name": translateData.save_configuration.popup.content.view_nr_2.form.input_email.name,
                                    "placeholder": translateData.save_configuration.popup.content.view_nr_2.form.input_email.placeholder,
                                    "desc": translateData.save_configuration.popup.content.view_nr_2.form.input_email.desc
                                },
                                "checkbox_for_email": {
                                    "text": translateData.save_configuration.popup.content.view_nr_2.form.checkbox_for_email.text
                                },
                                "buttons": {
                                    "submit": translateData.save_configuration.popup.content.view_nr_2.form.buttons.submit,
                                    "back": translateData.save_configuration.popup.content.view_nr_2.form.buttons.back,
                                    "sent": translateData.save_configuration.popup.content.view_nr_2.form.buttons.sent
                                }
                            }
                        }
                    }
                },
                "notifications": {
                    "email": translateData.save_configuration.notifications.email,
                    "copy_link": translateData.save_configuration.notifications.copy_link,
                    "download_pdf": translateData.save_configuration.notifications.download_pdf
                },
                "pdf": {
                    "title": translateData.save_configuration.pdf.title,
                    "file_name": translateData.save_configuration.pdf.file_name,
                    "configuration_button": {
                        "cta": translateData.save_configuration.pdf.configuration_button.cta
                    },
                    "question": translateData.save_configuration.pdf.question,
                    "contact_title": translateData.save_configuration.pdf.contact_title,
                    "contact_subtitle": translateData.save_configuration.pdf.contact_subtitle,
                    "final_price_label": translateData.save_configuration.pdf.final_price_label,
                    "summary_title": translateData.save_configuration.pdf.summary_title
                }
            }
        };

        return translateObj;
    };

    const retrunMattressData = () => {
        const mattressData = JSON.parse(document.querySelector('script#digi__mattress-data').textContent.trim());
        document.querySelector('script#digi__digi__mattress-data')?.remove();

        return mattressData;
    };

    const returnTotalWidth_CustomVariantsData = () => {
        if (!digi__MiniProduct && !digi__NormalProduct) return null;

        const customVariants = {
            mini: {
                product_data: null
            },
            normal: {
                product_data: null
            }
        };

        if (digi__MiniProduct) {
            customVariants.mini.product_data = digi__MiniProduct;
        };

        if (digi__NormalProduct) {
            customVariants.normal.product_data = digi__NormalProduct;
        };

        document.querySelector('script#digi__total-width__custom-variants')?.remove();

        return customVariants;
    };

    const returnConfigurationURL = () => {
        const url = new URL(window.location.href);
        const allowParams = ['variant', 'material', 'color', 'layout', 'mattress'];

        const filteredParams = new URLSearchParams();

        allowParams.forEach((param) => {
            if (url.searchParams.has(param)) {
                filteredParams.set(param, url.searchParams.get(param));
            }
        });

        url.search = filteredParams.toString();

        return url.toString();
    };

    const MATTRESS_DATA = retrunMattressData();
    const MATTRESS_TECH_NAME_MAP = {
        'brak-materaca': {
            'de': ['Keine Matratze'],
            'pl': ['Brak materaca'],
            'cs': ['Bez matrace']
        },
        'materac-classic': {
            'de': ['Matratze Classic', 'Klassische Matratze'],
            'pl': ['Materac Classic'],
            'cs': ['Klasická matrace']
        },
        'materac-coconut': {
            'de': ['Matratze Coconut', 'Kokosmatratze'],
            'pl': ['Materac Coconut'],
            'cs': ['Kokosová matrace']
        },
        'materac-comfort-visco': {
            'de': ['Komfort Visco Matratze'],
            'pl': ['Materac Comfort Visco'],
            'cs': ['Matrace Comfort Visco']
        },
        'materac-lateks': {
            'de': ['Latexmatratze'],
            'pl': ['Materac lateks'],
            'cs': ['Latexová matrace']
        }
    };
    const TRANSLATE = returnTranslateData();
    const CURRENCY = Shopify.currency.active;
    const CUSTOM_TOTAL_WIDTH = returnTotalWidth_CustomVariantsData();

    const attrKeys = {
        'sleepSize': ['powierzchnia-spania', 'schlafbereich', 'prostor-pro-spani'],
        'material': ['material'],
        'layout': ['layout'],
        'pillowFilling': ['rodzaj-wypelnienia-poduszek', 'art-der-kissenfullung', 'kissenfullungsart', 'typ-vyplne-polstare'],
        'sleepFunction': {
            'sectionName': ['funkcja-spania', 'schlaffunktion', 'funkce-spanku'],
            'yesOrNot': {
                'yes': ['Tak', 'Ja', 'Ano'],
                'not': ['Nie', 'Nein', 'Ne']
            }
        },
        'mattress': ['materac', 'matratze', 'matrace'],
        'hardness': ['mattress'],
        'width': ['szerokosc', 'breite']
    };

    const prodAttrKeys__forPdf = {
        'hardness': ['Twardość materaca', 'Matratzenhärte', 'Tvrdost matrace']
    };

    const materialCollection = {
        'storm': 'storm-85',
        'golden': 'golden-21',
        'legend': 'legend-2',
        'corbett': 'corbett-23',
        'find-me': 'find-me-2',
        'melody': 'melody-13',
        'landscape': 'landscape-3',
        'hartman': 'hartman-7'
    };

    const clickedAttr = {
        material: false,
        layout: false
    };

    const CURRENT_INPUTS_DATA = {};

    const findKeyPath = (obj, value, parentKey = '') => {
        for (const key in obj) {
            const currentPath = parentKey ? `${parentKey}.${key}` : key;

            if (Array.isArray(obj[key]) && obj[key].includes(value)) {
                return currentPath.split('.')[0];
            };

            if (typeof obj[key] === 'object') {
                const result = findKeyPath(obj[key], value, currentPath);
                if (result) return result;
            };
        };

        return null;
    };

    const returnLangRules = (number, options) => {
        const lang = WEB_LANG
        const safeLang = typeof lang === 'string' && lang.trim() ? lang.trim() : 'en';

        const hasPluralRules = typeof Intl !== 'undefined' && typeof Intl.PluralRules === 'function';

        if (!hasPluralRules) {
            if (number === 1 && options?.one) return options.one;

            return options?.other || options?.many || options?.few || '';
        };

        let pluralKey = 'other';

        try {
            pluralKey = new Intl.PluralRules(safeLang).select(number);
        } catch {
            pluralKey = new Intl.PluralRules('en').select(number);
        };

        return options?.[pluralKey] || options?.other || '';
    };

    const autoScrollToElement = (
        scrollContainer,
        selectedElement,
        axis = 'Y',
        offset = 100
    ) => {
        if (!scrollContainer || !selectedElement) return;

        const normalizedAxis = axis.toUpperCase();

        const isWindow =
            scrollContainer === window ||
            scrollContainer === document ||
            scrollContainer === document.documentElement ||
            scrollContainer === document.body;

        if (isWindow) {
            const elementRect = selectedElement.getBoundingClientRect();

            if (normalizedAxis === 'X') {
                const targetScrollLeft =
                    window.scrollX +
                    elementRect.left -
                    window.innerWidth / 2 +
                    selectedElement.offsetWidth / 2;

                window.scrollTo({
                    left: targetScrollLeft,
                    behavior: 'smooth',
                });

                return;
            }

            const targetScrollTop =
                window.scrollY +
                elementRect.top -
                window.innerHeight / 2 +
                selectedElement.offsetHeight / 2 -
                offset;

            window.scrollTo({
                top: targetScrollTop,
                behavior: 'smooth',
            });

            return;
        }

        const containerRect = scrollContainer.getBoundingClientRect();
        const elementRect = selectedElement.getBoundingClientRect();

        if (normalizedAxis === 'X') {
            const elementLeftRelativeToContainer =
                elementRect.left - containerRect.left + scrollContainer.scrollLeft;

            const targetScrollLeft =
                elementLeftRelativeToContainer -
                scrollContainer.clientWidth / 2 +
                selectedElement.offsetWidth / 2;

            scrollContainer.scrollTo({
                left: targetScrollLeft,
                behavior: 'smooth',
            });

            return;
        }

        const elementTopRelativeToContainer =
            elementRect.top - containerRect.top + scrollContainer.scrollTop;

        const targetScrollTop =
            elementTopRelativeToContainer -
            scrollContainer.clientHeight / 2 +
            selectedElement.offsetHeight / 2 -
            offset;

        scrollContainer.scrollTo({
            top: targetScrollTop,
            behavior: 'smooth',
        });
    };

    const initProductGallerySlider = (box) => {
        const gallery = box.querySelector('._product-gallery');
        if (!gallery) return;

        const slides = Array.from(gallery.querySelectorAll('._product-gallery__slide'));
        const slidesCount = slides.length;

        const track = gallery.querySelector('._product-gallery__track');
        const currentCounter = gallery.querySelector('._product-gallery__current');
        const prevButton = gallery.querySelector('._product-gallery__arrow--prev');
        const nextButton = gallery.querySelector('._product-gallery__arrow--next');

        if (!track || !slidesCount || !currentCounter || !prevButton || !nextButton) return;

        let currentIndex = 0;
        let scrollEndTimer = null;
        let isArrowScroll = false;

        const updateCounter = () => {
            currentCounter.textContent = currentIndex + 1;
        };

        const updateArrows = () => {
            const isFirstSlide = currentIndex === 0;
            const isLastSlide = currentIndex === slidesCount - 1;

            prevButton.classList.toggle('is-disabled', isFirstSlide);
            nextButton.classList.toggle('is-disabled', isLastSlide);

            prevButton.disabled = isFirstSlide;
            nextButton.disabled = isLastSlide;
        };

        const updateUI = () => {
            updateCounter();
            updateArrows();
        };

        const getClosestSlideIndex = () => {
            let closestIndex = 0;
            let closestDistance = Infinity;

            slides.forEach((slide, index) => {
                const distance = Math.abs(track.scrollLeft - slide.offsetLeft);

                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestIndex = index;
                }
            });

            return closestIndex;
        };

        const scrollToSlide = (index) => {
            const targetSlide = slides[index];

            if (!targetSlide) return;

            currentIndex = index;
            updateUI();

            isArrowScroll = true;

            track.scrollTo({
                left: targetSlide.offsetLeft,
                behavior: 'smooth'
            });

            window.clearTimeout(scrollEndTimer);

            scrollEndTimer = window.setTimeout(() => {
                isArrowScroll = false;
                currentIndex = getClosestSlideIndex();
                updateUI();
            }, 500);
        };

        prevButton.addEventListener('click', () => {
            if (currentIndex === 0) return;

            scrollToSlide(currentIndex - 1);
        });

        nextButton.addEventListener('click', () => {
            if (currentIndex === slidesCount - 1) return;

            scrollToSlide(currentIndex + 1);
        });

        track.addEventListener('scroll', () => {
            if (isArrowScroll) return;

            window.clearTimeout(scrollEndTimer);

            scrollEndTimer = window.setTimeout(() => {
                currentIndex = getClosestSlideIndex();
                updateUI();
            }, 20);
        });

        if (slidesCount <= 1) {
            prevButton.style.display = 'none';
            nextButton.style.display = 'none';
        };

        updateUI();
    };

    const formatPrice = (value) => {
        const price = Number(value);
        if (Number.isNaN(price)) return '';

        const lang = WEB_LANG?.toUpperCase().trim();

        const priceText = Number.isInteger(price)
            ? price.toFixed(0)
            : price.toFixed(2);

        const [whole, cents] = priceText.split('.');

        let thousandsSeparator = ',';
        let centsSeparator = '.';

        if (['PL', 'CS', 'CS'].includes(lang)) {
            thousandsSeparator = ' ';
            centsSeparator = ',';
        }

        if (['DE'].includes(lang)) {
            thousandsSeparator = '.';
            centsSeparator = ',';
        }

        const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

        return cents
            ? `${formattedWhole}${centsSeparator}${cents}`
            : formattedWhole;
    };

    const removeWords = (text, words) => {
        const escapedWords = words.map(word =>
            word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        );

        const regex = new RegExp(`\\b(${escapedWords.join('|')})\\b`, 'gi');

        return text
            .replace(regex, '')
            .replace(/\s+/g, ' ')
            .trim();
    };

    const isWideWindow = () => {
        if (window.innerWidth < 1920) {
            return false;
        } else {
            return true;
        };
    };

    const isMobile = (customRes) => {
        let res = customRes ? customRes : 990;
        if (window.innerWidth < res) {
            return true;
        } else {
            return false;
        };
    };

    const __webBadges = (hide) => {
        const badges = [
            {
                selector: `div[id*=trustbadge-container]`
            },
            {
                selector: `div.thulium-chat-wrapper`
            },
            {
                selector: `div#CookiebotWidget`
            }
        ];

        badges.forEach(badge => {
            if (hide) {
                if (document.querySelector(badge.selector)) {
                    document.querySelector(badge.selector).classList.add('__digi-hidden-badge');
                };
            } else {
                if (document.querySelector(badge.selector)) {
                    document.querySelector(badge.selector).classList.remove('__digi-hidden-badge');
                };
            };
        });
    };

    const stickyElement = (element) => {
        if (!element) return;

        const stickyEl = element;
        const STICKY_TOP = 0;

        const checkSticky = () => {
            const rect = stickyEl.getBoundingClientRect();
            const isSticky = rect.top <= STICKY_TOP;

            stickyEl.classList.toggle('__is-sticky', isSticky);
        };

        window.addEventListener('scroll', checkSticky, { passive: true });
        window.addEventListener('resize', checkSticky);

        checkSticky();
    };

    const MATERIALS_DATA = returnMaterialsData().colors;
    const MATERIALS_GROUP_DATA = returnMaterialsData().groups;

    const __getMaterialData = (params) => {
        const data = {
            basic: {},
            details: {},
            fullDescriptionHtml: {}
        };

        const materialName = params.name;
        const materialColor = params.color;

        if (materialName) {
            // BASIC
            data.basic = {
                name: materialName,
                image: document.querySelector(`.material-image[data-material='${materialName}']`)?.dataset?.image || null,
                video: document.querySelector(`.material-video[data-material='${materialName}']`)?.dataset?.video || null,
                attributes: document.querySelector(`.material-attrs[data-material='${materialName}']`)?.dataset?.text || null
            };

            if (params.returnAsNode) {
                if (data.basic.image) {
                    const template = document.createElement('template');
                    template.innerHTML = data.basic.image.trim();
                    const imgNode = template.content.firstElementChild;

                    data.basic.image = imgNode;
                };
            };

            const template = document.createElement('template');
            template.innerHTML = data.basic.video?.trim();

            const videoNode = template.content.firstElementChild;

            if (videoNode) {
                const oryginalPoster = videoNode.getAttribute('poster');

                if (oryginalPoster && oryginalPoster.includes('_small')) {
                    const newPoster = oryginalPoster.replace('_small', '_1240x');
                    videoNode.setAttribute('poster', newPoster);
                };

                data.basic.video = videoNode.outerHTML;
            };
        };

        if (materialColor) {
            // DETAILS
            const foundMaterial = MATERIALS_DATA.find(m => m.name.toLowerCase().trim().replaceAll('-', '').replaceAll(' ', '') === materialColor.toLowerCase().trim().replaceAll('-', '').replaceAll(' ', ''));

            if (foundMaterial) {
                const html = foundMaterial.description;
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const rows = doc.querySelectorAll('table tr');
                const specs = {};

                rows.forEach(row => {
                    const cells = row.querySelectorAll('td');

                    if (cells.length === 2) {
                        const key = cells[0].textContent.trim();
                        const value = cells[1].textContent.trim();

                        specs[key] = value;
                    };
                });

                data.details = specs;
                data.fullDescriptionHtml = html;
            };

            data.basic.color = {
                name: materialColor,
                image: document.querySelector(`.color-image[data-material='${materialColor}']`)?.dataset?.image || null,
                color: foundMaterial.colors[0]
            };

            if (params.returnAsNode) {
                const template = document.createElement('template');
                if (data.basic.color.image) {
                    template.innerHTML = data.basic.color.image.trim();
                    const imgNode = template.content.firstElementChild;

                    data.basic.color.image = imgNode;
                };
            };
        };

        return {
            basic: data.basic,
            details: data.details,
            fullDescriptionHtml: data.fullDescriptionHtml
        };
    };

    const PRODUCT_DATA = returnProductData();

    const __getProductData = () => {
        const text = PRODUCT_DATA.dimensions_and_spec;
        const rows = text
            .split('\n\n*')[0]
            .split('\n')
            .map(line => line.trim())
            .filter(Boolean)
            .map(line => {
                const [key, ...rest] = line.split(':');
                return {
                    key: key.trim(),
                    value: rest.join(':').trim()
                };
            });


        let totalWidthMap = {};
        if (PRODUCT_DATA.dimensions.digi_total_width_array) {
            PRODUCT_DATA.dimensions.digi_total_width_array.forEach(obj => {
                const splited = obj.value.split('-');

                totalWidthMap[splited[0].trim()] = splited[1].trim();
            });
        };

        return {
            dimensions_BACKUP: rows,
            dimensions: PRODUCT_DATA.dimensions,
            totalWidthMap: totalWidthMap,
            masks: PRODUCT_DATA.masks
        };
    };

    const __dataLayer_Push = (data) => {
        if (dataLayer) {
            dataLayer.push(data);
        };

        //console.log(data);
    };

    const __EVENTS = (eventData, sendImmediately) => {
        if (!eventData) return;

        const urlParams = new URLSearchParams(window.location.search);
        const currentVariantID = urlParams.get('variant');

        const itemData = {
            id: PRODUCT_DATA.id,
            name: PRODUCT_DATA.title,
            brand: "Mitto Home",
            category: "",
            price: __getCurrentProductPrice(),
            currency: CURRENCY,
            variant: currentVariantID,
            market: WEB_LANG.toUpperCase().trim()
        };

        const customEventData = {
            event: "konfigurator_click",
            market: WEB_LANG.toUpperCase().trim(),
            ecommerce: {
                value: itemData.price,
                currency: CURRENCY,
                items: [itemData]
            }
        };

        if (eventData?.ecommerce) {
            customEventData.ecommerce = {
                ...customEventData.ecommerce,
                ...eventData.ecommerce
            };
        };

        const delay = sendImmediately ? 0 : 500;

        setTimeout(() => {
            __dataLayer_Push(customEventData);
        }, delay);
    };

    const __getCurrentProductPrice = () => {
        if (typeof product_price_value !== 'undefined') {
            return product_price_value / 100;
        } else {
            return null;
        };
    };

    const __customCSS = () => {
        const style = document.createElement('style');

        if (document.querySelector(`#digi-custom-css`)) return;
        style.id = `digi-custom-css`;
        style.textContent = `
            @media screen and (min-width: 990px) {
                section .page-width > .product {
                    position: relative;
                }
    
                section .page-width > .product product-info.product__info-container {
                    max-width: 100%;
                }
    
                section .page-width > .product > .column.xlarge-offset-1 {
                    margin-right: 0;
                    width: 43%;
                }
            }

            .product__params.digi-hidden {
                display: none !important;
            }

            .product__media-wrapper {
                border-right: none !important;
            }

            :root {
                --digi_config_global_gap: 8px;
            }

        	#digi-new-configurator {
            	width: 100%;
              	background: #FFF;
              	padding: 24px 16px;
              	display: flex;
              	flex-direction: column;
              	border-radius: 8px;
              	box-shadow: 0 0 50px 0 rgba(0,0,0,0.10);
                gap: 24px;
                position: relative;
                z-index: 1;
            }
            
            #digi-new-configurator .digi-config__box {
            	display: flex;
  				flex-direction: column;
                gap: 16px;
            }
            
            #digi-new-configurator .digi-config__box .box-title {
            	display: flex;
  				justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                column-gap 16px;
                row-gap: 4px;
            }

            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box  .box-title {
                flex-wrap: nowrap;
            }

            #digi-new-configurator .digi-config__box[box-name] .digi-checked,
            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress.digi-checked,
            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box.digi-checked ._img {
                --digi-check-size: 18px;
                position: relative;
            }
                
            #digi-new-configurator .digi-config__box[box-name] .digi-checked {
                overflow: hidden;
            }

            #digi-new-configurator .digi-config__box[box-name] .digi-checked::before,
            #digi-new-configurator .digi-config__box[box-name] .digi-checked::after,
            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress.digi-checked::before,
            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress.digi-checked::after,
            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box.digi-checked ._img::before,
            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box.digi-checked ._img::after {
                content: '';
                width: var(--digi-check-size);
                height: var(--digi-check-size);
                position: absolute;
                bottom: 0;
                right: 0;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box.digi-checked ._img::before, 
            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box.digi-checked ._img::after {
                bottom: -3px;
                right: -3px;
            }
                
            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box.digi-checked ._img::before {
                border-radius: 0 0 6px 0;
            }

            #digi-new-configurator .digi-config__box[box-name] .digi-checked::before,
            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress.digi-checked::before,
            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box.digi-checked ._img::before {
                background: #000;
            }

            #digi-new-configurator .digi-config__box[box-name] .digi-checked::after,
            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress.digi-checked::after,
            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box.digi-checked ._img::after {
                border-left: 1px solid #FFF;
                border-bottom: 1px solid #FFF;
                transform: rotate(-45deg) translate(25%, -140%);
                width: calc(var(--digi-check-size) * 0.6);
                height: calc(var(--digi-check-size) * 0.3);
            }
            
            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box {
            	padding: 8px 14px;
                border: 1px solid #DEDEDE;
                border-radius: 4px;
                width: 100%;
                display: flex;
                align-items: center;
            }

            #digi-new-configurator .digi-config__box[box-name="mattress"] .box-content {
                flex-wrap: nowrap;
            }

            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box.no-mattress-option.digi-checked {
                cursor: default;
            }

            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box.digi-checked {
                border-color: #000;
            }
            
            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box .box-title {
            	gap: 10px;
                justify-content: flex-start;
                width: 100%;
            }
            
            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box .box-title ._title {
            	width: 100%;
                display: flex;
                flex-direction: column;
            }

            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box .box-title ._title ._mattress-name {
                font-size: 16px;
                font-weight: 400;
            }

            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box .box-title ._title ._mattress-price {
                font-size: 12px;
                color: #656363;
                text-align: left;
            }
            
            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box .box-title .img {
            	display: flex;
                justify-content: center;
                align-items: center;
            }
            
            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box .box-title .img img {
            	height: 56px;
                width: auto;
            }

            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box .box-title .icon {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box.no-mattress-option {
                justify-content: center;
                cursor: pointer;
            }

            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box.no-mattress-option .box-title {
                width: auto;
            }

            #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box.no-mattress-option .box-title .icon {
                display: none;
            }
            
            #digi-new-configurator .digi-config__box .box-title strong {
            	font-size: 18px;
                font-weight: 700;
            }
            
            .digi-config__aside-panel-open {
            	font-size: 16px;
                font-weight: 400;
                text-decoration: underline;
                cursor: pointer;
            }

            #digi-new-configurator .more.digi-config__aside-panel-open,
            #digi-new-configurator .digi-config__aside-panel-open[for='mattress']:not(.digi-border) {
                text-decoration: none;
            }
            
            #digi-new-configurator .digi-config__box .box-content {
            	display: flex;
                gap: var(--digi_config_global_gap);
                flex-wrap: wrap;
            }
            
            #digi-new-configurator .digi-config__box .box-content .digi-box-label {
            	border-radius: 4px;
                border: 1px solid #DEDEDE;
                padding: 1px calc(18px + 4px);
                height: 52px;
                display: flex;
                flex: 1 0 0;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
            
            #digi-new-configurator .digi-config__box .box-content .digi-box-label .value {
            	width: 100%;
                height: auto;
                max-height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 14px;
            }
            
            #digi-new-configurator .digi-config__box[box-name="sleepSize"] .box-content .digi-box-label,
            #digi-new-configurator .digi-config__box[box-name="width"] .box-content .digi-box-label {
            	flex-direction: column;
            }
            
            #digi-new-configurator .digi-config__box[box-name="sleepSize"] .box-content .digi-box-label .value {
            	height: auto;
            }
            
            #digi-new-configurator .digi-config__box .box-content .digi-box-label .price-difference,
            #digi-new-configurator .digi-config__box .box-content .digi-box-label > .desc {
            	font-size: 12px;
                color: #656565;
                text-align: center;
            }

            #digi-new-configurator .digi-config__box .box-content .digi-box-label .price-difference {
                min-width: 60px;
            }
            
            #digi-new-configurator .digi-config__box .box-content .digi-box-label input {
            	display: none;
            }
            
            #digi-new-configurator .digi-config__box .box-content .digi-box-label.digi-checked {
            	border-color: #000;
                cursor: default;
            }
            
            #digi-new-configurator .digi-config__box[box-name="material"] .box-content {
            	display: grid;
  				grid-template-columns: var(--digiContentTemplateColumns);
            }
            
            #digi-new-configurator .digi-config__box[box-name="material"] .box-content .digi-box-label {
            	width: 100%;
                height: auto;
                flex-shrink: 0;
                aspect-ratio: 1/1;
                border-radius: 4px;
                padding: 0;
                border: 1px solid transparent;
                transition: .2s ease;
            }
                
            #digi-new-configurator .digi-config__box[box-name="material"] .box-content .digi-box-label:not(.more) {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                color: #DEDEDE;
            }
             
            #digi-new-configurator .digi-config__box[box-name="material"] .box-content .digi-box-label.more {
            	outline: 1px solid #D3D3D3;
                outline-offset: -2px;
                padding: 4px;
            }
            
            #digi-new-configurator .digi-config__box[box-name="material"] .box-content .digi-box-label.more .value {
            	font-size: 14px;
                font-weight: 400;
                text-align: center;
                flex-wrap: wrap;
            }
            
            #digi-new-configurator .digi-config__box[box-name="material"] .box-content .digi-box-label.digi-checked {
            	border: 1px solid #000;
                padding: 3px;
            }
            
            #digi-new-configurator .digi-config__box[box-name="material"] .box-content .digi-box-label .value img {
            	height: 100%;
                width: 100%;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            
            #digi-new-configurator .digi-config__box[box-name="material"] .box-summary-content {
            	display: flex;
                justify-content: space-between;
                gap: 16px;
            }
            
            #digi-new-configurator .digi-config__box[box-name="material"] .box-summary-content .box-summary {
                --digi-sEl-gap: 24px;
            	display: flex;
                gap: var(--digi-sEl-gap);
            }

            #digi-new-configurator .digi-config__box[box-name="material"] .box-summary-content .box-summary .s-el {
                position: relative;
            }

            #digi-new-configurator .digi-config__box[box-name="material"] .box-summary-content .box-summary .s-el:nth-child(1)::after {
                content: '';
                width: 1px;
                height: 70%;
                top: calc(30% / 2);
                background: #DEDEDE;
                position: absolute;
                right: calc(-1 * (var(--digi-sEl-gap) * 0.5));
            }
            
            #digi-new-configurator .digi-config__box[box-name="material"] .box-summary-content .box-summary .s-el span.s-n {
            	font-size: 16px;
                font-weight: 500;
            }
            
            #digi-new-configurator .digi-config__box[box-name="material"] .box-summary-content .box-summary .s-el span.s-v {
            	font-size: 16px;
                font-weight: 400;
            }
            
            #digi-new-configurator .digi-config__box[box-name="pillowFilling"] .box-content .digi-box-label {
            	flex-direction: column;
            }
            
            #digi-new-configurator .digi-config__box[box-name="pillowFilling"] .box-content .digi-box-label .value {
             	height: auto;
            }
            
            #digi-new-configurator .digi-config__box[box-name="sleepFunction"] .box-content .digi-box-label,
            #digi-new-configurator .digi-config__box[box-name="layout"] .box-content .digi-box-label,
            #digi-new-configurator .digi-config__box[box-name="pillowFilling"] .box-content .digi-box-label,
            #digi-new-configurator .digi-config__box[box-name="custom-total-width"] .box-content .digi-box-label {
            	min-width: 154px;
                gap: 8px;
                flex: 0 1 auto;
            }

            #digi-new-configurator .digi-config__box[box-name="width"] .box-content,
            #digi-new-configurator .digi-config__box[box-name="sleepSize"] .box-content {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(128px, 1fr));
                gap: var(--digi_config_global_gap);
            }

            #digi-new-configurator .digi-config__box[box-name="width"] .box-content .digi-box-label,
            #digi-new-configurator .digi-config__box[box-name="sleepSize"] .box-content .digi-box-label {
                // max-width: 120px;
                // min-width: 100px;
                width: 100%;
            }
            
            #digi-new-configurator .digi-config__box[box-name="pillowFilling"] .box-content .digi-box-label {
            	gap: 0;
            }
            
            #digi-new-configurator .digi-config__box[box-name="sleepFunction"] .box-content .digi-box-label .icon,
            #digi-new-configurator .digi-config__box[box-name="layout"] .box-content .digi-box-label .icon,
            #digi-new-configurator .digi-config__box[box-name="custom-total-width"] .box-content .digi-box-label .icon {
            	display: flex;
                justify-content: center;
                align-items: center;
            }

            /* ASIDE PANEL */
            .digi-configurator__aside-panel {
                --digiAsidePanelPadding: 25px;

                width: 100%;
                //max-width: 620px;
                max-width: calc(43% - calc(2 * 1.2rem));
                height: 100%;
                position: absolute;
                top: 0;
                right: 1.2rem;
                z-index: 3;
                background: #FFF;
                box-shadow: 0 0 50px 0 rgba(0,0,0,.10);
                padding: 30px var(--digiAsidePanelPadding);
                padding-right: calc(var(--digiAsidePanelPadding) / 2);
                padding-bottom: 0 !important;
                display: flex;
                flex-direction: column;
                gap: 16px;
                transition: .4s ease;
                opacity: 1;
                border-radius: 8px;
            }

            .digi-configurator__aside-panel.move {
            	right: -100px;
                opacity: 0;
            }

            .digi-configurator__aside-panel-overlay {
                width: 100%;
                height: 100%;
                position: fixed;
                top: 0;
                left: 0;
                z-index: 9998;
                //background: rgba(0,0,0,0.300);
                display: none;
                transition: .4s ease;
                opacity: 1;
            }

            .digi-configurator__aside-panel-overlay.fade {
                opacity: 0;
            }

            #digi-new-configurator .digi-hidden,
            .digi-configurator__aside-panel .digi-hidden {
                display: none !important;
            }
            
            .digi-configurator__aside-panel .digi-header {
            	width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-right: calc(var(--digiAsidePanelPadding) / 2);
            }
            
            .digi-configurator__aside-panel .digi-header .digi-title {
          		font-size: 24px;
                font-weight: 500;
            }
            
            .digi-configurator__aside-panel .digi-header .digi-close-btn {
 				display: flex;
                justify-content: center;
                align-items: center;
 				gap: 8px;
                cursor: pointer;
                user-select: none;
                font-size: 14px;
                font-weight: 500;
                flex-shrink: 0;
            }
            
            .digi-configurator__aside-panel .digi-header .digi-close-btn .icon,
            ._digi-bottom-sheet ._header ._btn-close {
            	width: 20px;
                height: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #9B9B9B;
                border-radius: 150px;
                cursor: pointer;
            }
            
            .digi-configurator__aside-panel .digi-header .digi-close-btn .icon svg path,
            ._digi-bottom-sheet ._header ._btn-close svg path {
            	fill: #9B9B9B;
            }
            
            .digi-configurator__aside-panel .digi-content {
            	height: 100%;
                width: 100%;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                gap: var(--digi_config_global_gap);
                padding-bottom: 30px;
                overflow-x: hidden;
                padding-right: calc(var(--digiAsidePanelPadding) / 2);
            }
            
            .digi-configurator__aside-panel .digi-content .img-mask {
            	display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: auto;
                position: relative;
                overflow: hidden;
                flex-shrink: 0;
            }
            
            .digi-configurator__aside-panel .digi-content .img-mask img.background-img {
            	filter: grayscale(1);
                position: relative;
                width: 100%;
                height: auto;
                z-index: 0;
            }

            .digi-configurator__aside-panel .digi-content .img-mask img.sizeMask-img {
                position: absolute;
                width: 100%;
                z-index: 1;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-table {
            	display: flex;
                flex-direction: column;
            }
            
            .digi-configurator__aside-panel .digi-content table[style] {
            	height: auto !important;
                box-shadow: none;
            }
            
            .digi-configurator__aside-panel .digi-content table[style] * {
            	border: none;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-table .digi-row,
            .digi-configurator__aside-panel .digi-content table[style] tr {
            	display: flex;
                align-items: center;
                padding: 12px 16px !important;
                height: auto !important;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-table .digi-row:nth-child(odd),
            .digi-configurator__aside-panel .digi-content table[style] tr:nth-child(odd) {
            	background: #F4F4F4;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-table .digi-row .digi-col,
            .digi-configurator__aside-panel .digi-content table[style] tr td {
            	display: flex;
                align-items: center;
                font-size: 14px;
                padding: 0;
                height: auto !important;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-table .digi-row .digi-col:nth-child(1),
            .digi-configurator__aside-panel .digi-content table[style] tr td:nth-child(1) {
           		justify-content: flex-start;
                width: 100%;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-table .digi-row .digi-col:nth-child(2),
            .digi-configurator__aside-panel .digi-content table[style] tr td:nth-child(2) {
           		justify-content: flex-end;
                width: auto;
                flex-shrink: 0;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-select {
            	display: flex;
                flex-direction: column;
                gap: 16px;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-select .digi-size-select-title {
            	font-size: 20px;
                font-weight: 500;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-select .digi-size-select-content {
            	display: flex;
                gap: var(--digi_config_global_gap);
                overflow-x: auto;
                
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-select .digi-size-select-content .digi-box-label {
            	flex: 1 0 0;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 5px 8px;
                cursor: pointer;
                border: 1px solid #DEE1E9;
                border-radius: 4px;
                height: 40px;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-select .digi-size-select-content .digi-box-label.digi-checked {
                color: #000;
                border-color: #000;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-size-select .digi-size-select-content .digi-box-label input[type] {
            	display: none;
            }

            .digi-configurator__aside-panel .digi-content p {
                margin: 0;
                padding: 0;
            }

            .digi-configurator__aside-panel .digi-content .digi-title, 
            .digi-configurator__aside-panel .digi-content h3 {
                font-size: 20px;
                font-weight: 500;
                margin: var(--digi_config_global_gap) 0;
                padding: 0;
            }
            
            .digi-configurator__aside-panel .digi-content table[style] {
            	margin-bottom: 24px;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__more-about-this-material .digi-content .images {
            	display: grid;
                grid-template-columns: 1fr 1fr;
                gap: var(--digi_config_global_gap);
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__more-about-this-material .digi-content .images > * {
            	width: 100%;
                height: auto;
                border-radius: 4px;
            }
            
            .digi-configurator__aside-panel .digi-content ul {
            	margin: 0;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__more-about-this-material .digi-content ul.digi-ul {
            	padding: 0;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__more-about-this-material .digi-content ul.digi-ul li {
            	display: flex;
                align-items: center;
                gap: 6px;
                margin-bottom: 4px;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__more-about-this-material .digi-content ul.digi-ul li:last-child {
            	margin-bottom: 0;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__more-about-this-material .digi-content ul.digi-ul li .icon,
            .digi-configurator__aside-panel#digi-aside-panel__more-about-this-material .digi-content ul.digi-ul li .name {
            	display: flex;
                align-items: center;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__more-about-this-material .digi-content ul.digi-ul li::marker {
            	content: unset;	
            }
            
            .digi-configurator__aside-panel .digi-content .digi-free-fabric-samples {
            	display: flex;
              	align-items: center;
              	justify-content: flex-start;
              	background: #F4F4F4;
              	padding: 12px;
              	border-radius: 4px;
              	gap: 10px;
              	color: unset;
              	text-decoration: unset;
                cursor: pointer;
            }
            
            .digi-configurator__aside-panel .digi-content .digi-free-fabric-samples > div {
            	display: flex;
                justify-content: center;
                align-items: center;
            }
                
            .digi-configurator__aside-panel .digi-content .digi-free-fabric-samples > div.text {
                font-size: 16px;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__pillow_filling .digi-content .desc-content {
            	display: flex;
                flex-direction: column;
                gap: 16px;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__pillow_filling .digi-content .desc-content .el {
            	display: flex;
                gap: 12px;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__pillow_filling .digi-content .desc-content .el .details {
            	display: flex;
                flex-direction: column;
                gap: 4px;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__pillow_filling .digi-content .desc-content .el .details .d-title {
            	font-size: 16px;
                font-weight: 500;
            }


            .digi-configurator__aside-panel#digi-aside-panel__sleep_details video.digi-video,
            .digi-configurator__aside-panel#digi-aside-panel__sleep_details ._sleep-function--size img {
                width: 100%;
                height: auto;
            }


            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .mattress-help-bar {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .mattress-help-bar ._title {
                font-size: 20px;
                font-weight: 500;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress {
                width: 100%;
                height: auto;
                display: flex;
                border: 1px solid #DEDEDE;
                border-radius: 4px;
                padding: 16px;
                cursor: pointer;
                gap: var(--digi_config_global_gap);
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress[data-tech-name='brak-materaca'] {
                padding: 8px 16px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress input[type='radio'] {
                display: none !important;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress.digi-checked {
                border-color: #000;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._image {
                display: flex;
                align-items: flex-start;
                justify-content: center;
                max-width: 200px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._image img {
                width: 100%;
                height: auto;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details {
                display: flex;
                flex-direction: column;
                gap: var(--digi_config_global_gap);
                width: 100%;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._name {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                font-size: 14px;
                font-weight: 500;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._name ._price {
                padding: 2px 8px;
                background: #F1F1F1;
                border-radius: 150px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._spec-options {
                display: flex;
                flex-direction: column;
                gap: 4px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._spec-options ._spec-single-option {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                gap: 12px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._spec-options ._spec-single-option ._icon {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 24px;
                width: 24px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._spec-options ._spec-single-option ._icon svg path,
            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._spec-options ._spec-single-option ._icon svg line {
                stroke: #000;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._spec-options ._spec-single-option ._icon svg circle {
                fill: #000;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._spec-options ._spec-single-option ._name {
                font-size: 12px;
            }

            .digi-configurator__aside-panel .digi-content select,
            .digi-configurator__aside-panel .digi-content ._digi-select {
                --digi__selectLRPadding: 12px;

                background: transparent;
                border: 1px solid #DEE1E9;
                padding: 8px var(--digi__selectLRPadding);
                border-radius: 20px;
                font-size: 12px;
                cursor: pointer;
                z-index: 5;
                user-select: none;
            }

            .digi-configurator__aside-panel .digi-content select {
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;

                background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23222' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                background-position: right var(--digi__selectLRPadding) center;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select {
                --digiSelectHeight: 43px;

                display: flex;
                flex-direction: column;
                padding: 0;
                cursor: default;
                position: relative;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select._digi-open {
                border-radius: 20px 20px 0 0;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select._digi-open ._select-name ._arrow {
                transform: rotate(180deg);
            }

            .digi-configurator__aside-panel .digi-content ._digi-select._digi-open ._select-list {
                display: flex;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select ._select-name {
                padding: 0 12px;
                height: var(--digiSelectHeight);
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
                font-size: 16px;
                font-weight: 500;
                cursor: pointer;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select ._select-name ._arrow {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select ._select-name ._number {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                width: 16px;
                height: 16px;
                font-size: 10px;
                font-weight: 500;
                background: #000;
                color: #FFF;
                border-radius: 40px;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select ._select-name ._number:empty {
                display: none;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select ._select-list {
                display: none;
                flex-direction: column;
                gap: 6px;
                padding: 8px 12px;
                background: #FFF;
                position: absolute;
                width: calc(100% + (2 * 1px));
                top: calc(var(--digiSelectHeight) + 1px);
                left: -1px;
                border: 1px solid #DEE1E9;
                border-top: none;
                border-radius: 0 0 20px 20px;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select ._select-list label {
                display: flex;
                align-items: center;
                font-size: 16px;
                cursor: pointer;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select ._select-list label input {
                display: none !important;
            }

            .digi-configurator__aside-panel .digi-content ._digi-select ._select-list label:has(input:checked) {
                font-weight: 500;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._short-description {
                font-size: 14px;
                color: #353535;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._details ._read-more {
                all: unset;
                font-size: 14px;
                color: #353535;
                font-weight: 400;
                text-decoration: underline;
                cursor: pointer;
            }

            .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 45px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs ._image {
                max-width: 40%;
            }

            .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs ._image img {
                width: 100%;
                height: auto;
            }

            .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs ._attrs {
                display: flex;
                flex-direction: column;
                gap: 20px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs ._attrs ._attr {
                display: flex;
                gap: 12px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs ._attrs ._attr ._icon {
                width: 24px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-shrink: 0;
            }

            .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs ._attrs ._attr ._icon img {
                width: 100%;
                height: auto;
            }

            .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs ._attrs ._attr ._details {
                display: flex;
                flex-direction: column;
                gap: 4px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs ._attrs ._attr ._details ._name {
                font-size: 16px;
                font-weight: 500;
            }

            .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs ._attrs ._attr ._details ._desc {
                font-size: 14px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._legend {
                display: flex;
                justify-content: center;
                gap: var(--digi_config_global_gap);
                margin-top: var(--digi_config_global_gap);
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._legend ._firmness {
                width: 100%;
                max-width: 128px;
                min-height: 30px;
                padding: 5px 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                font-size: 12px;
                border-radius: 2px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content {
                --digi_firmness_max_width: 360px;
                --digi_firmness_h2-color: #F1F3F6;
                --digi_firmness_h3-color: #98A6BD;
                --digi_firmness_h4-color: #2C2D50;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._legend ._firmness[firmness="H2"] {
                background: var(--digi_firmness_h2-color);
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._legend ._firmness[firmness="H3"] {
                background: var(--digi_firmness_h3-color);
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._legend ._firmness[firmness="H4"] {
                background: var(--digi_firmness_h4-color);
                color: #FFF;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table {
                display: flex;
                flex-direction: column;
                gap: var(--digi_config_global_gap);
                justify-content: center;
                align-items: center;
                margin-top: var(--digi_config_global_gap);
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table ._name {
                background: #F0F0F0;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 2px 8px;
                max-width: var(--digi_firmness_max_width);
                width: 100%;
                margin-top: var(--digi_config_global_gap);
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table ._table {
                width: 100%;
                max-width: var(--digi_firmness_max_width);
                border-collapse: collapse;
                border-spacing: 0;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table ._table * {
                margin: 0;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table ._table tr th,
            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table ._table tr td {
                font-size: 12px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table ._table tr th {
                font-weight: 700;
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table ._table td[firmness] {
                padding: 5px 10px;
                text-align: center;
            }
            
            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table ._table td[firmness="h2"] {
                background: var(--digi_firmness_h2-color);
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table ._table td[firmness="h3"] {
                background: var(--digi_firmness_h3-color);
            }

            .digi-configurator__aside-panel#digi-aside-panel__mattress-help .digi-content ._firmness-table ._table td[firmness="h4"] {
                background: var(--digi_firmness_h4-color);
                color: #FFF;
            }


            // .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box {
            //     display: flex;
            //     flex-direction: column;
            //     height: 100%;
            // }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box:first-child {
                padding-top: 0 !important;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box:nth-last-child(1 of ._material-box:not(.digi-hidden)) {
                border-bottom: none !important;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box {
                --digiInnerPadding: 20px;

                width: 100%;
                height: auto;
                display: flex;
                padding: var(--digiInnerPadding) 0;
                padding-bottom: calc(var(--digiInnerPadding) / 2);
                border-bottom: 1px solid #D6D6D6;
                display: flex;
                flex-direction: column;
                gap: 8px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-details {
                display: flex;
                flex-direction: column;
                gap: 6px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-name ._title {
                flex-shrink: 0;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-name {
                display: flex;
                gap: 10px;
                align-items: center;
                font-size: 18px;
                font-weight: 500;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-name ._spec {
                display: flex;
                gap: 4px;
                align-items: center;
                justify-content: flex-start;
                width: 100%;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-name ._spec li {
                list-style-type: none;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-name ._spec li .icon {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-name ._spec li .name {
                display: none;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-properties {
                display: flex;
                flex-direction: column;
                gap: 2px;
                margin-bottom: 2px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-properties ._properties {
                display: flex;
                align-items: center;
                gap: 6px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list {
                --digiVGap: 0px;
                --digiListItems: 5.5;

                gap: var(--digiVGap);
                width: 100%;
                overflow-x: auto;
                overflow-y: hidden;
                display: grid;
                grid-auto-flow: column;
                grid-auto-columns: calc((100% - 1 * var(--digiVGap)) / var(--digiListItems));
                padding-bottom: calc(var(--digiInnerPadding) / 2);

                scroll-snap-type: x mandatory;
                scroll-padding-inline: 0;
                -webkit-overflow-scrolling: touch;
                scroll-behavior: smooth
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box {
                width: 100%;
                max-width: 150px;
                height: auto;
                display: flex;
                flex-direction: column;
                scroll-snap-align: start;
                padding: 6px;
                border-radius: 4px;
                gap: 4px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box ._img {
                width: 100%;
                height: auto;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box.digi-checked ._img {
                outline: 1px solid #000;
                outline-offset: 3px;
                border-radius: 4px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box ._img img {
                width: 100%;
                height: auto;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #DEDEDE;
                overflow: hidden;
                border-radius: 4px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box ._img .digi-config__aside-panel-open[for='material-preview'] {
                all: unset;

                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #ECECEC;
                border-radius: 150px;
                width: 24px;
                height: 24px;
                background: #FFF;
                position: absolute;
                top: 4px;
                right: 4px;
                cursor: pointer;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._filters {
                display: flex;
                flex-direction: column;
                gap: 16px;
                position: sticky;
                top: 0;
                background: #FFF;
                z-index: 2;
                padding-bottom: 16px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._filters ._selects {
                display: flex;
                gap: var(--digi_config_global_gap);
                align-items: start;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._selected-filters {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._selected-filters:not(:has(button)) {
                display: none;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._selected-filters ._selected-filter-chip,
            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._selected-filters ._clear-selected-filters {
                all: unset;
                display: flex;
                align-items: center;
                gap: 4px;
                background: #F4F4F4;
                padding: 6px 12px;
                border-radius: 50px;
                font-size: 12px;
                cursor: pointer;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._selected-filters ._selected-filter-chip span[aria-hidden] {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._selected-filters ._clear-selected-filters {
                background: transparent;
                color: #787878;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._no-results-wrapper ._title {
                font-size: 20px;
                font-weight: 500;
                line-height: 25px;
                margin-bottom: 8px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._no-results-wrapper ._subtitle {
                font-size: 16px;
                font-weight: 400;
                margin-bottom: 24px;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._no-results-wrapper ._clear_all_filters {
                background: transparent;
                font-size: 15px;
                color: #353535;
                border: 1px solid #353535;
                padding: 13px 28px;
                font-weight: 700;
                cursor: pointer;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box input[type='radio'] {
                display: none !important;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list ._color-box ._name {
                font-size: 14px;
                text-align: left;
            }

            .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-name .digi-config__aside-panel-open[for='material-video-sampler'] {
                text-decoration: none;
                display: flex;
                align-items: center;
                gap: 8px;
                flex-shrink: 0;
            }

            .digi-configurator__aside-panel#digi-aside-panel__material-preview .digi-content ._material-preview img {
                width: 100%;
                height: auto;
                border-radius: 4px;
            }

            .digi-configurator__aside-panel .digi-content video {
                border-radius: 4px;
            }



            .digi-configurator__aside-panel ._product-gallery {
                width: 100%;
                max-width: 900px;
                margin: 0 auto;
                display: none;
                transition: .3s ease;
            }

            .digi-configurator__aside-panel ._product-gallery.digi-pg-loading {
                opacity: 0.5;
                filter: grayscale(1);
            }

            .digi-configurator__aside-panel ._product-gallery.__is-sticky {

            }

            .digi-configurator__aside-panel ._product-gallery__track {
                display: flex;
                overflow-x: auto;
                scroll-snap-type: x mandatory;
                scroll-behavior: smooth;

                scrollbar-width: none;
                -ms-overflow-style: none;
            }

            .digi-configurator__aside-panel ._product-gallery__track::-webkit-scrollbar {
                display: none;
            }

            .digi-configurator__aside-panel ._product-gallery__slide {
                flex: 0 0 100%;
                width: 100%;
                scroll-snap-align: start;

                display: flex;
                justify-content: center;
                align-items: center;
            }

            .digi-configurator__aside-panel ._product-gallery__image {
                display: block;
                width: 100%;
                height: auto;
                object-fit: contain;
            }

            .digi-configurator__aside-panel ._product-gallery__controls {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 24px;
            }

            .digi-configurator__aside-panel ._product-gallery__arrow {
                border: 0;
                background: transparent;
                padding: 0;
                font-size: 56px;
                line-height: 1;
                font-weight: 300;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            ._product-gallery__arrow.is-disabled,
            ._product-gallery__arrow:disabled {
                opacity: .3;
                cursor: default;
                pointer-events: none;
            }

            .digi-configurator__aside-panel ._product-gallery__counter {
                font-size: 12px;
                line-height: 1;
            }

            ._digi-bottom-sheet {
                --digiInnerPadding: 16px;

                width: 100%;
                height: auto;
                max-height: 100%;
                position: fixed;
                bottom: 0;
                left: 0;
                z-index: 9999999;
                background: #FFF;
                padding: 0 var(--digiInnerPadding) calc(2 * var(--digiInnerPadding)) var(--digiInnerPadding);
                display: flex;
                flex-direction: column;

                touch-action: none;

                transform: translate3d(0, 100%, 0);
                transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
                will-change: transform;
            }

            ._digi-bottom-sheet.is-open {
                transform: translate3d(0, 0, 0);
            }

            ._digi-bottom-sheet span.__digi-bs-drag-el {
                --digiDragElPadding: 15px;

                width: 100%;
                height: auto;
                max-height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                padding: calc(var(--digiDragElPadding) * 1) 0 var(--digiDragElPadding) 0;
                top: calc(-2 * var(--digiDragElPadding));
                left: 50%;
                transform: translateX(-50%);
                background: #FFF;
                border-radius: 8px 8px 0 0;
            }

            ._digi-bottom-sheet span.__digi-bs-drag-el::after {
                content: '';
                width: 100%;
                max-width: 50px;
                height: 3px;
                background: #9B9B9B;
                border-radius: 15px;
                user-select: none;
            }


            ._digi-bottom-sheet ._header,
            ._digi-bottom-sheet .__digi-bs-drag-el {
                cursor: grab;
                touch-action: none;
                user-select: none;
            }

            ._digi-bottom-sheet ._header:active,
            ._digi-bottom-sheet .__digi-bs-drag-el:active {
                cursor: grabbing;
            }


            ._digi-bottom-sheet ._header {
                padding-top: 0;
                width: 100%;
                height: auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #DEDEDE;
                padding-bottom: var(--digiInnerPadding);
            }

            ._digi-bottom-sheet ._header ._title {
                font-size: 16px;
                font-weight: 500;
            }

            ._digi-bottom-sheet ._header ._btn-close {
                display: none !important;
            }

            ._digi-bottom-sheet ._content {
                display: flex;
                flex-direction: column;
                height: auto;
                width: 100%;
                gap: calc(var(--digiInnerPadding) / 2);
                padding-top: var(--digiInnerPadding);
            }

            ._digi-bottom-sheet ._content label {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                gap: 8px;
                accent-color: #000;
                font-size: 16px;
                user-select: none;
                cursor: pointer;
            }

            ._digi-bottom-sheet ._content label input {
                width: 20px;
                height: 20px;
            }

            .__digi-bottom-sheet-overlay {
                position: fixed;
                width: 100%;
                height: 100dvh;
                top: 0;
                left: 0;
                z-index: 9999998;
                background: rgba(0,0,0,0.1);
                opacity: 0;
                pointer-events: auto;
                transition: opacity 0.25s ease;
            }

            .__digi-bottom-sheet-overlay.is-open {
                opacity: 1;
            }

            .__digi-bottom-sheet-overlay:empty {
                display: block;
            }


            @media screen and (max-width: 1920px) {
                .digi-configurator__aside-panel {
                    position: fixed;
                    top: 0;
                    right: 0;
                    z-index: 99999;
                    border-radius: 0;
                    height: 100dvh !important;
                    max-width: 43%;
                    min-width: calc(531px + (2 * 2rem));
                }

                .digi-configurator__aside-panel-overlay {
                    display: block !important;
                }

                .__digi-hidden-badge {
                    display: none !important;
                }
            }

            @media screen and (max-width: 990px) {
                body.__digi-configurator__fixed-view {
                    overflow: hidden;
                }

                #digi-new-configurator {
                    padding: 16px 8px;
                }

                #digi-new-configurator .digi-config__box[box-name="material"] .box-content .digi-box-label.more .value ._t-o {
                    display: none;
                }


                #digi-new-configurator .digi-config__box[box-name="mattress"] .box-content {
                    flex-wrap: wrap;
                }

                #digi-new-configurator .digi-config__box[box-name="mattress"] .box-content .digi-mattress-box {
                    min-height: 74px;
                }

                #digi-new-configurator .digi-config__box[box-name="mattress"] .box-content .digi-mattress-box .box-title {
                    justify-content: center;
                }

                #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box .box-title ._title {
                    width: auto;
                    min-width: 130px;
                }

                #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box .box-title .img {
                    min-width: 86px;
                }

                #digi-new-configurator .digi-config__box[box-name="mattress"] .digi-mattress-box.no-mattress-option .box-title .icon {
                    display: flex;
                    opacity: 0;
                    z-index: -1;
                    position: relative;
                    user-select: none;
                }


                .digi-configurator__aside-panel {
                    --digiAsidePanelPadding: 16px;
                    padding-top: var(--digiAsidePanelPadding);
                    padding-bottom: var(--digiAsidePanelPadding);
                }

                .digi-configurator__aside-panel {
                    min-width: unset;
                    max-width: 100%;
                }

                .digi-configurator__aside-panel .digi-content .digi-free-fabric-samples {
                    padding: 8px 12px;
                }

                .digi-configurator__aside-panel ._product-gallery {
                    display: block;
                }

                .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._filters._pg-top-cut {
                    top: -50px;
                }

                .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list {
                    --digiListItems: 4.5;
                }

                .digi-configurator__aside-panel .digi-header .digi-title {
                    font-size: 20px;
                }

                .digi-configurator__aside-panel .digi-content .digi-size-select .digi-size-select-title {
                    font-size: 16px;
                }

                .digi-configurator__aside-panel .digi-content ._digi-select {
                    --digiSelectHeight: 35px;
                }
            }

            @media screen and (max-width: 550px) {
                .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .mattress-help-bar ._title {
                    display: none;
                }

                .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress {
                    flex-direction: column;
                }

                .digi-configurator__aside-panel#digi-aside-panel__mattress .digi-content .digi__mattress ._image,
                .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs ._image {
                    max-width: 80%;
                }

                .digi-configurator__aside-panel#digi-aside-panel__more-about-mattress .digi-content ._image-and-attrs {
                    flex-direction: column;
                    gap 16px;
                    align-items: flex-start;
                }

                .digi-configurator__aside-panel#digi-aside-panel__all-materials .digi-content ._material-content ._material-box ._material-colors-list {
                    --digiListItems: 3.5;
                }
            }

            @media screen and (max-width: 420px) {
                #digi-new-configurator .digi-config__box[box-name="sleepFunction"] .box-content .digi-box-label,
                #digi-new-configurator .digi-config__box[box-name="layout"] .box-content .digi-box-label, #digi-new-configurator .digi-config__box[box-name="pillowFilling"] .box-content .digi-box-label,
                #digi-new-configurator .digi-config__box[box-name="custom-total-width"] .box-content .digi-box-label {
                    min-width: calc(50% - calc(8px / 2));
                }
            }

            @media screen and (max-width: 362px) {
                #digi-new-configurator .digi-config__box[box-name="sleepFunction"] .box-content .digi-box-label,
                #digi-new-configurator .digi-config__box[box-name="layout"] .box-content .digi-box-label, #digi-new-configurator .digi-config__box[box-name="pillowFilling"] .box-content .digi-box-label,
                #digi-new-configurator .digi-config__box[box-name="custom-total-width"] .box-content .digi-box-label {
                    min-width: 100%;
                }
            }
        `;

        document.head.appendChild(style);
    };

    const __saveConfiguration = (node) => {
        const webButton_addToCart = node;
        if (!webButton_addToCart) return;

        if (document.querySelector('._digi-save-config-button')) return;

        const __customCSS_saveConfig = () => {
            const style = document.createElement('style');

            if (document.querySelector(`#digi-save-config`)) return;
            style.id = `digi-save-config`;
            style.textContent = `
                body._digi-fixed-view {
                    overflow: hidden;
                }

                .product-form__input.product-form__quantity[id] {
                    display: none !important;
                }

                .product-form__buy-buttons {
                    width: 100% !important;
                }

                .product-form__buy-buttons .product-form__buttons {
                    --digiButtonsWrapperGap: 8px;

                    display: flex;
                    align-items: center;
                    gap: var(--digiButtonsWrapperGap);
                    margin-bottom: 16px;
                    flex-wrap: wrap-reverse;
                }

                .product-form__buy-buttons .product-form__buttons button {
                    margin-bottom: 0;
                }

                .product-form__buy-buttons .product-form__buttons ._digi-save-config-button {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: var(--digiButtonsWrapperGap);
                    background: transparent;
                    outline: 1px solid #000;
                    outline-offset: -1px;
                }

                .product-form__buy-buttons .product-form__buttons ._digi-save-config-button ._icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .product-form__buy-buttons .product-form__buttons ._digi-save-config-button,
                .product-form__buy-buttons .product-form__buttons button {
                    min-width: 220px;
                    flex: 1 0 0;
                    flex-shrink: 0;
                }


                #digi__save-config__wrapper {
                    display: none;
                    justify-content: center;
                    align-items: center;
                    position: fixed;
                    top: 0;
                    left: 0;
                    z-index: 999;
                    width: 100%;
                    height: 100%;
                    padding: 20px;
                }

                #digi__save-config__wrapper.digi-active {
                    display: flex;
                }

                #digi__save-config__wrapper .digi__save-config__popup {
                    --digiPopupPadding: 28px;

                    width: 100%;
                    max-width: 886px;
                    height: auto;
                    max-height: 100%;
                    min-height: 515px;
                    background: #FFF;
                    position: relative;
                    z-index: 2;
                    gap: 16px;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__close-btn {
                    width: 36px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 2px;
                    background: #F1F1F1;
                    flex-shrink: 0;
                    cursor: pointer;
                    position: absolute;
                    z-index: 10;
                    top: var(--digiPopupPadding);
                    right: var(--digiPopupPadding);
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    position: relative;
                    //padding: var(--digiPopupPadding);
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view {
                    height: 100%;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    position: relative;
                    transition: .3s ease;
                    background: #FFF;
                    padding: var(--digiPopupPadding);
                    opacity: 0;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='1'] {
                    z-index: 2;
                    bottom: 100%;
                    position: absolute;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] {
                    z-index: 1;
                    bottom: -100%;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='1']._digi-visible,
                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2']._digi-visible {
                    bottom: 0;
                    opacity: 1;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._title {
                    font-size: 24px;
                    font-weight: 500;
                    margin-bottom: 16px;
                    max-width: calc(100% - 36px - 8px);
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._subtitle {
                    font-size: 16px;
                    font-weight: 400;
                    margin-bottom: 32px;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                    margin-top: var(--digi_config_global_gap);
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons span._separator {
                    flex-shrink: 0;
                    color: #212121;
                    opacity: 0.2;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons ._row {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 24px;
                    width: 100%;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons ._row._short-row {
                    width: 100%;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons .digi-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 15px 24px;
                    width: 100%;
                    cursor: pointer;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons .digi-btn._send-to-email--btn,
                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons .digi-btn._send-config--btn,
                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons .digi-btn._back--btn {
                    background: #000;
                    color: #FFF;
                    font-size: 15px;
                    font-weight: 700;
                    border: 1px solid #000;
                    line-height: normal;
                    min-height: 52px;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons .digi-btn._back--btn {
                    color: #000;
                    background: transparent;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons .digi-btn._send-config--btn {
                    outline: none;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons .digi-btn._send-config--btn._success {
                    cursor: default; 
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons .digi-btn._download-pdf--btn,
                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons .digi-btn._copy-link--btn {
                    color: #000;
                    padding-left: 0;
                    padding-right: 0;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view ._buttons .digi-btn svg {
                    flex-shrink: 0;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] form {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] form ._name {
                    font-size: 14px;
                    font-weight: 500;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] form input[type='email'] {
                    all: unset;
                    width: 100%;
                    padding: 0 12px;
                    border: 1px solid #DEE1E9;
                    height: 42px;
                    box-sizing: border-box;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] form input[type='email'].digi-valid-error {
                    border-color: #f14546;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] form ._desc {
                    font-size: 12px;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] form ._agree-checkbox {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    cursor: pointer;
                    margin-top: 4px;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] form ._agree-checkbox input[type='checkbox'] {
                    accent-color: #000;
                    margin-left: 0;
                    margin-right: 0;
                    flex-shrink: 0;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] form ._agree-checkbox.digi-valid-error ._text {
                    color: #f14546;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] form ._agree-checkbox ._text {
                    font-size: 14px;
                    color: #656363;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] ._buttons {
                    margin-top: 32px;
                }

                #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view='2'] ._buttons ._row {
                    flex-wrap: wrap;
                    gap: 12px;
                }
                    
                #digi__save-config__wrapper .digi__save-config__popup ._image {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #F4F4F4;
                }

                #digi__save-config__wrapper .digi__save-config__popup ._image img {
                    width: 100%;
                    height: auto;
                    mix-blend-mode: multiply;
                }

                #digi__save-config__wrapper .digi__save-config__overlay {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    z-index: 1;
                    background: rgba(0,0,0,0.4);
                    display: flex;
                }


                #_digi-notification-wrapper {
                    --digiMargin: 64px;

                    position: fixed;
                    top: 50px;
                    right: var(--digiMargin);
                    width: auto;
                    max-width: calc(100% - (2 * var(--digiMargin)));
                    z-index: 999;
                    gap: 8px;
                    display: flex;
                    flex-direction: column;
                    height: auto;
                    transition: .3s ease;
                }

                #_digi-notification-wrapper ._digi-notification {
                    width: auto;
                    max-width: 100%;
                    max-height: 250px;
                    height: auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                    padding: 12px;
                    border-radius: 8px;
                    background: #FFF;
                    box-shadow: 0 4px 40px 0 rgba(0, 0, 0, 0.15);
                    font-size: 16px;
                    user-select: none;
                    transition: .3s ease;
                    opacity: 1;
                    position: relative;
                }

                #_digi-notification-wrapper ._digi-notification._fade-in {
                    margin-top: calc(-8px - (2 * 12px));
                }

                #_digi-notification-wrapper ._digi-notification._fade-in,
                #_digi-notification-wrapper ._digi-notification._fade-out  {
                    opacity: 0;
                    max-height: 0;
                }

                #_digi-notification-wrapper ._digi-notification._fade-out {
                    margin-right: -100%;
                }

                #_digi-notification-wrapper ._digi-notification ._icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                @media screen and (max-width: 750px) {
                    #digi__save-config__wrapper {
                        padding: 0;
                    }

                    #digi__save-config__wrapper .digi__save-config__popup {
                        --digiPopupPadding: 16px;

                        height: 100dvh;
                        max-height: 100%;
                        min-height: unset;
                        position: absolute;
                        bottom: 0;
                        grid-template-columns: 1fr;
                    }

                    #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view="2"] ._buttons {
                        margin-top: 16px;
                    }

                    #digi__save-config__wrapper .digi__save-config__popup .__content ._view[data-view="2"] ._buttons ._row {
                        gap: 8px;
                    }

                    #_digi-notification-wrapper {
                        --digiMargin: 1.5rem;
                        top: calc(59px + 1.5rem);
                    }
                }

                @media screen and (max-height: 850px) and (min-width: 750px) {
                    #digi__save-config__wrapper .digi__save-config__popup {
                        transform: scale(0.9);
                        max-height: 100%;
                    }
                }
            `;

            document.head.appendChild(style);
        };

        const __getProductData__API = () => {
            const handle = window.location.pathname.split('/products/')[1]?.split('/')[0];

            return fetch(`/products/${handle}.js`)
                .then(response => response.json())
                .then(product => {
                    const selectedVariantId = Number(
                        new URLSearchParams(window.location.search).get('variant')
                    );

                    const variant =
                        product.variants.find(v => v.id === selectedVariantId) ||
                        product.variants[0];

                    return {
                        price: variant.price,
                        title: product.title
                    };
                });
        };

        const __createSaveConfig__Popup = () => {
            if (document.querySelector('#digi__save-config__wrapper')) return;

            const popupData = {
                currentImage: document.querySelector('product-modal .product-media-modal__item .digi-replaced-img img[src]')?.src
            };

            let imageDesktop = '';
            let imageMobile = '';

            if (isMobile(750)) {
                imageMobile = `
                    <div class='_image'>
                        <img src='${popupData.currentImage}' alt=''>
                    </div>
                `;

                __webBadges(true);
            } else {
                imageDesktop = `
                    <div class='_image'>
                        <img src='${popupData.currentImage}' alt=''>
                    </div>
                `;
            };

            const saveConfigPopupTemp = `
                <div id='digi__save-config__wrapper' class='digi-active'>
                    <div class='digi__save-config__popup'>
                        ${imageDesktop}

                        <div class='__content'>
                            <span class='__close-btn'>
                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.5 0.5L0.5 10.5M0.5 0.5L10.5 10.5" stroke="#121212" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>

                            <div class='_view _digi-visible' data-view='1'>
                                <div class='_title'>${TRANSLATE.save_configuration.popup.content.view_nr_1.title}</div>
                                <div class='_subtitle'>${TRANSLATE.save_configuration.popup.content.view_nr_1.subtitle}</div>
                                ${imageMobile}
                                <div class='_buttons'>
                                    <div class='_row'>
                                        <div class='_send-to-email--btn digi-btn'>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.66634 2.66699H13.333C14.0664 2.66699 14.6664 3.26699 14.6664 4.00033V12.0003C14.6664 12.7336 14.0664 13.3336 13.333 13.3336H2.66634C1.93301 13.3336 1.33301 12.7336 1.33301 12.0003V4.00033C1.33301 3.26699 1.93301 2.66699 2.66634 2.66699Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M14.6664 4L7.99967 8.66664L1.33301 4" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>

                                            ${TRANSLATE.save_configuration.popup.content.view_nr_1.buttons.send_to_email}
                                        </div>
                                    </div>
                                    <div class='_row _short-row'>
                                        <div class='_download-pdf--btn digi-btn'>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_2884_5764)">
                                                    <path d="M6.45312 4.85898V9.7207L5.00937 8.27695L3.56836 6.83594L3.17734 7.22695L2.78906 7.61523L4.89453 9.7207L7 11.8262L9.10547 9.7207L11.2109 7.61523L10.8227 7.22695L10.4316 6.83594L8.99062 8.27695L7.54688 9.7207V4.85898V0H7H6.45312V4.85898Z" fill="black"/>
                                                    <path d="M0 13.4531V14H7H14V13.4531V12.9062H7H0V13.4531Z" fill="black"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_2884_5764">
                                                    <rect width="14" height="14" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                            ${TRANSLATE.save_configuration.popup.content.view_nr_1.buttons.download_pdf}
                                        </div>

                                        <span class='_separator'>|</span>

                                        <div class='_copy-link--btn digi-btn'>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="5" y="5" width="9" height="9" stroke="black"/>
                                                <path d="M2 12V2H11.75" stroke="black"/>
                                            </svg>

                                            ${TRANSLATE.save_configuration.popup.content.view_nr_1.buttons.copy_link}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class='_view' data-view='2'>
                                <div class='_title'>${TRANSLATE.save_configuration.popup.content.view_nr_2.title}</div>
                                <div class='_subtitle'>${TRANSLATE.save_configuration.popup.content.view_nr_2.subtitle}</div>
                                ${imageMobile}
                                <form action='' method='POST' novalidate>
                                    <div class='_name'>${TRANSLATE.save_configuration.popup.content.view_nr_2.form.input_email.name}</div>
                                    <input type='email' name='digi-save-config--email' placeholder='${TRANSLATE.save_configuration.popup.content.view_nr_2.form.input_email.placeholder}' autocomplete='off'>
                                    <div class='_desc'>${TRANSLATE.save_configuration.popup.content.view_nr_2.form.input_email.desc}</div>
                                    <label class='_agree-checkbox'>
                                        <input type='checkbox' name='digi-save-config--agree'>
                                        <div class='_text'>${TRANSLATE.save_configuration.popup.content.view_nr_2.form.checkbox_for_email.text}</div>
                                    </label>

                                    <div class='_buttons'>
                                        <div class='_row'>
                                            <button class='_send-config--btn digi-btn' type='submit'>
                                                ${TRANSLATE.save_configuration.popup.content.view_nr_2.form.buttons.submit}
                                            </button>

                                            <div class='_back--btn digi-btn'>
                                                ${TRANSLATE.save_configuration.popup.content.view_nr_2.form.buttons.back}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class='digi__save-config__overlay'></div>
                </div>
            `;

            document.body.insertAdjacentHTML('beforeend', saveConfigPopupTemp);

            const saveConfigPopupWrapper = document.querySelector('#digi__save-config__wrapper');
            if (!saveConfigPopupWrapper) return;

            const popup = saveConfigPopupWrapper.querySelector('.digi__save-config__popup');
            const overlay = saveConfigPopupWrapper.querySelector('.digi__save-config__overlay');
            const closeBtn = popup.querySelector('.__close-btn');

            document.body.classList.add('_digi-fixed-view');

            closeBtn?.addEventListener('click', function () {
                __closePopup();
            });

            overlay?.addEventListener('click', function () {
                __closePopup();
            });

            const __closePopup = () => {
                saveConfigPopupWrapper.classList.remove('digi-active');
                document.body.classList.remove('_digi-fixed-view');
                setTimeout(() => {
                    saveConfigPopupWrapper?.remove();
                    __webBadges();
                }, 300);
            };

            const __createNotificationWrapper = () => {
                if (document.querySelector('#_digi-notification-wrapper')) return;

                const notificationWrapperTemp = `
                    <div id='_digi-notification-wrapper'></div>
                `;

                document.body.insertAdjacentHTML('afterbegin', notificationWrapperTemp);
            };

            const __newNotification = (data) => {
                if (!data?.copy) return;

                const notificationNode = document.createElement('div');
                notificationNode.classList.add('_digi-notification');
                notificationNode.classList.add('_fade-in');
                notificationNode.innerHTML = `
                     <div class='_icon'>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.88117 10.0394L10.856 5.0645L10.3056 4.51403L5.88117 8.93842L3.6645 6.72175L3.11403 7.27222L5.88117 10.0394ZM7.00253 14C6.03458 14 5.12452 13.8163 4.27233 13.4489C3.42028 13.0816 2.67906 12.583 2.04867 11.9533C1.41828 11.3235 0.919268 10.583 0.551639 9.73155C0.18388 8.88028 0 7.9706 0 7.00253C0 6.03458 0.183685 5.12452 0.551055 4.27233C0.918426 3.42028 1.41698 2.67906 2.04672 2.04867C2.67646 1.41828 3.41704 0.919268 4.26844 0.551639C5.11972 0.18388 6.0294 0 6.99747 0C7.96542 0 8.87548 0.183686 9.72767 0.551056C10.5797 0.918426 11.3209 1.41698 11.9513 2.04672C12.5817 2.67646 13.0807 3.41704 13.4484 4.26844C13.8161 5.11972 14 6.0294 14 6.99747C14 7.96542 13.8163 8.87548 13.4489 9.72767C13.0816 10.5797 12.583 11.3209 11.9533 11.9513C11.3235 12.5817 10.583 13.0807 9.73155 13.4484C8.88028 13.8161 7.9706 14 7.00253 14ZM7 13.2222C8.73704 13.2222 10.2083 12.6194 11.4139 11.4139C12.6194 10.2083 13.2222 8.73704 13.2222 7C13.2222 5.26296 12.6194 3.79167 11.4139 2.58611C10.2083 1.38056 8.73704 0.777778 7 0.777778C5.26296 0.777778 3.79167 1.38056 2.58611 2.58611C1.38056 3.79167 0.777778 5.26296 0.777778 7C0.777778 8.73704 1.38056 10.2083 2.58611 11.4139C3.79167 12.6194 5.26296 13.2222 7 13.2222Z" fill="#AD864D"/>
                        </svg>
                    </div>
                    <div class='_copy'>${data.copy}</div>
                `;


                const notificationWrapper = document.querySelector('#_digi-notification-wrapper');
                if (!notificationWrapper) return;

                notificationWrapper.insertAdjacentElement('afterbegin', notificationNode);
                setTimeout(() => {
                    notificationNode.classList.remove('_fade-in');
                }, 10);

                setTimeout(() => {
                    notificationNode.classList.add('_fade-out');

                    setTimeout(() => {
                        notificationNode.remove();
                    }, 300);
                }, 5000);
            };

            const sanitizePdfText = (text) => {
                return text;
            };

            const returnConfigurationData = async () => {
                const formHiddenInputs = Array.from(document.querySelectorAll('.product-form__buy-buttons form[data-type="add-to-cart-form"] input[type=hidden][data-value][name*="properties"]'));
                if (!formHiddenInputs.length) return {};

                const prodData = {
                    configurationURL: returnConfigurationURL(),
                    variantImage: popupData.currentImage,
                    name: PRODUCT_DATA.title,
                    params: []
                };


                // Mattress
                if (CURRENT_INPUTS_DATA['mattress']) {
                    if (MATTRESS_TECH_NAME_MAP['brak-materaca'][WEB_LANG.toLowerCase()][0] === CURRENT_INPUTS_DATA['mattress']) {
                        prodData.params.push({
                            label: TRANSLATE.box__mattress.mattress,
                            value: MATTRESS_TECH_NAME_MAP['brak-materaca'][WEB_LANG.toLowerCase()][0]
                        });
                    } else {
                        prodData.params.push({
                            label: TRANSLATE.box__mattress.mattress,
                            value: CURRENT_INPUTS_DATA['mattress']
                        });
                    };
                };


                // SleepSize
                if (CURRENT_INPUTS_DATA['sleepSize']) {
                    prodData.params.push({
                        label: TRANSLATE.box__sleep_size.sleep_size,
                        value: CURRENT_INPUTS_DATA['sleepSize']
                    });
                };


                // Sleep Function
                if (CURRENT_INPUTS_DATA['sleepFunction']) {
                    prodData.params.push({
                        label: TRANSLATE.box__sleep_function.sleep_function,
                        value: CURRENT_INPUTS_DATA['sleepFunction']
                    });
                };


                // Pillow filling
                if (CURRENT_INPUTS_DATA['pillowFilling']) {
                    prodData.params.push({
                        label: TRANSLATE.box__pillow_filling.type_of_filling,
                        value: CURRENT_INPUTS_DATA['pillowFilling']
                    });
                };


                // Width
                if (CURRENT_INPUTS_DATA['width']) {
                    if( !CURRENT_INPUTS_DATA['width'].includes('cm') ) {
                        CURRENT_INPUTS_DATA['width'] = CURRENT_INPUTS_DATA['width'] + ' cm';
                    };

                    prodData.params.push({
                        label: TRANSLATE.box__width.width,
                        value: CURRENT_INPUTS_DATA['width']
                    });
                };


                // Price
                if (typeof product_price_value !== 'undefined') {
                    prodData.price = product_price_value / 100;
                } else {
                    const productData_api = await __getProductData__API();

                    if (productData_api) {
                        prodData.price = productData_api.price;
                    };
                };


                formHiddenInputs.forEach(hiddenInput => {
                    let inputName = hiddenInput.name.replace('properties', '').replace('[', '').replace(']', '').trim();
                    let inputValue = hiddenInput.value.trim();

                    if (inputValue !== '') {
                        prodData.params.push({
                            label: inputName,
                            value: inputValue
                        });
                    };
                });

                return prodData;
            };

            const __viewNr1_Logic = () => {
                const sendConfigButton = popup.querySelector('._view[data-view="1"] ._send-to-email--btn');
                const downloadPdfButton = popup.querySelector('._view[data-view="1"] ._download-pdf--btn');
                const copyLinkButton = popup.querySelector('._view[data-view="1"] ._copy-link--btn');

                const PDF_FONT = {
                    regularFileName: 'new-config-font-only-for-pdf-file.ttf',
                    mediumFileName: 'new-config-font-only-for-pdf-file-medium.ttf',
                    boldFileName: 'new-config-font-only-for-pdf-file-bold.ttf',

                    fontName: 'DigiPdfFont',

                    regularStyle: 'normal',
                    mediumStyle: 'medium',
                    boldStyle: 'bold',

                    registeredStyles: {
                        normal: false,
                        medium: false,
                        bold: false,
                    },
                };

                let PDF_LOGO_URL = '';
                let PDF_EMAIL = '';
                let PDF_PHONE_NUMBER = '';
                let PDF_WEB_URL = '';

                if (window.NEW_CONFIG_PDF?.logoUrl) {
                    PDF_LOGO_URL = window.NEW_CONFIG_PDF.logoUrl;
                } else {
                    const logoImg = document.querySelector('a.header__heading-link .header__heading-logo-wrapper:not(.logo-alternate) img[src]');

                    if (logoImg) {
                        PDF_LOGO_URL = logoImg.src;
                    }
                }

                if (window.NEW_CONFIG_PDF?.email) {
                    PDF_EMAIL = window.NEW_CONFIG_PDF.email;
                } else {
                    const webEmail = document.querySelector('footer a[href*="mailto:"]');

                    if (webEmail) {
                        PDF_EMAIL = webEmail.textContent.trim();
                    }
                }

                if (window.NEW_CONFIG_PDF?.phone) {
                    PDF_PHONE_NUMBER = window.NEW_CONFIG_PDF.phone;
                } else {
                    const webPhone = document.querySelector('footer a[href*="tel:"]');

                    if (webPhone) {
                        PDF_PHONE_NUMBER = webPhone.textContent.trim();
                    }
                }

                if (window.NEW_CONFIG_PDF?.shopUrl) {
                    PDF_WEB_URL = window.NEW_CONFIG_PDF.shopUrl;
                } else {
                    PDF_WEB_URL = window.location.origin;
                }

                const normalizeWebUrlLabel = (url) => {
                    if (!url) {
                        return '';
                    }

                    try {
                        return new URL(url).hostname.replace(/^www\./, '');
                    } catch (error) {
                        return String(url)
                            .replace(/^https?:\/\//, '')
                            .replace(/^www\./, '')
                            .replace(/\/$/, '');
                    }
                };

                const getPhonePdfText = (phone) => {
                    /**
                     * U+2060 WORD JOINER rozbija numer dla auto-detekcji macOS Preview.
                     * Wizualnie numer nadal wygląda jak zwykły tekst.
                     */
                    return sanitizePdfText(phone)
                        .split(' ')
                        .filter(Boolean)
                        .join('\u2060 ');
                };

                const arrayBufferToBase64 = (buffer) => {
                    let binary = '';
                    const bytes = new Uint8Array(buffer);
                    const chunkSize = 0x8000;

                    for (let i = 0; i < bytes.length; i += chunkSize) {
                        const chunk = bytes.subarray(i, i + chunkSize);
                        binary += String.fromCharCode.apply(null, chunk);
                    }

                    return btoa(binary);
                };

                const registerPdfFont = async (doc) => {
                    const fonts = [
                        {
                            url: window.NEW_CONFIG_PDF?.fontUrl__regular || window.NEW_CONFIG_PDF?.fontUrl,
                            fileName: PDF_FONT.regularFileName,
                            style: PDF_FONT.regularStyle,
                            errorName: 'regular',
                            required: true,
                        },
                        {
                            url: window.NEW_CONFIG_PDF?.fontUrl__medium,
                            fileName: PDF_FONT.mediumFileName,
                            style: PDF_FONT.mediumStyle,
                            errorName: 'medium',
                            required: false,
                        },
                        {
                            url: window.NEW_CONFIG_PDF?.fontUrl__bold,
                            fileName: PDF_FONT.boldFileName,
                            style: PDF_FONT.boldStyle,
                            errorName: 'bold',
                            required: false,
                        },
                    ];

                    for (const font of fonts) {
                        if (!font.url) {
                            if (font.required) {
                                throw new Error(`Brak URL fontu PDF: ${font.errorName}`);
                            }

                            continue;
                        }

                        try {
                            const response = await fetch(font.url);

                            if (!response.ok) {
                                if (font.required) {
                                    throw new Error(`Nie udalo sie pobrac fontu PDF ${font.errorName}: ${response.status}`);
                                }

                                console.warn(`Nie udalo sie pobrac opcjonalnego fontu PDF ${font.errorName}: ${response.status}`);
                                continue;
                            }

                            const buffer = await response.arrayBuffer();
                            const base64 = arrayBufferToBase64(buffer);

                            doc.addFileToVFS(font.fileName, base64);
                            doc.addFont(font.fileName, PDF_FONT.fontName, font.style);

                            PDF_FONT.registeredStyles[font.style] = true;
                        } catch (error) {
                            if (font.required) {
                                throw error;
                            }

                            console.warn(`Nie udalo sie zarejestrowac opcjonalnego fontu PDF ${font.errorName}:`, error);
                        }
                    }

                    doc.setFont(PDF_FONT.fontName, PDF_FONT.regularStyle);
                };

                const setPdfFont = (doc, style = PDF_FONT.regularStyle) => {
                    if (style === PDF_FONT.boldStyle && PDF_FONT.registeredStyles.bold) {
                        doc.setFont(PDF_FONT.fontName, PDF_FONT.boldStyle);
                        return;
                    }

                    if (style === PDF_FONT.mediumStyle && PDF_FONT.registeredStyles.medium) {
                        doc.setFont(PDF_FONT.fontName, PDF_FONT.mediumStyle);
                        return;
                    }

                    doc.setFont(PDF_FONT.fontName, PDF_FONT.regularStyle);
                };

                const loadScript = (src) => {
                    return new Promise((resolve, reject) => {
                        const existingScript = document.querySelector(`script[src="${src}"]`);

                        if (existingScript) {
                            resolve();
                            return;
                        }

                        const script = document.createElement('script');
                        script.src = src;
                        script.onload = resolve;
                        script.onerror = reject;

                        document.head.appendChild(script);
                    });
                };

                const loadJsPDF = async () => {
                    const src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/3.0.3/jspdf.umd.min.js';

                    await loadScript(src);

                    if (!window.jspdf?.jsPDF) {
                        throw new Error('jsPDF nie zostal poprawnie zaladowany');
                    }

                    return window.jspdf.jsPDF;
                };

                const loadImageAsDataURL = (src, outputType = 'image/jpeg') => {
                    return new Promise((resolve, reject) => {
                        if (!src) {
                            reject(new Error('Brak src obrazka'));
                            return;
                        }

                        const img = new Image();

                        img.crossOrigin = 'anonymous';

                        img.onload = () => {
                            const canvas = document.createElement('canvas');
                            canvas.width = img.naturalWidth;
                            canvas.height = img.naturalHeight;

                            const ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0);

                            resolve({
                                dataUrl: canvas.toDataURL(outputType, 0.92),
                                width: img.naturalWidth,
                                height: img.naturalHeight,
                            });
                        };

                        img.onerror = reject;
                        img.src = src;
                    });
                };

                const addImageFit = async (doc, imageUrl, boxX, boxY, boxW, boxH, options = {}) => {
                    const {
                        align = 'center',
                        valign = 'middle',
                        format = 'JPEG',
                        contain = true,
                    } = options;

                    const image = await loadImageAsDataURL(
                        imageUrl,
                        format === 'PNG' ? 'image/png' : 'image/jpeg'
                    );

                    const imageRatio = image.width / image.height;
                    const boxRatio = boxW / boxH;

                    let drawW;
                    let drawH;

                    if (contain) {
                        if (imageRatio > boxRatio) {
                            drawW = boxW;
                            drawH = boxW / imageRatio;
                        } else {
                            drawH = boxH;
                            drawW = boxH * imageRatio;
                        }
                    } else {
                        if (imageRatio > boxRatio) {
                            drawH = boxH;
                            drawW = boxH * imageRatio;
                        } else {
                            drawW = boxW;
                            drawH = boxW / imageRatio;
                        }
                    }

                    let drawX = boxX;
                    let drawY = boxY;

                    if (align === 'center') {
                        drawX = boxX + (boxW - drawW) / 2;
                    }

                    if (align === 'right') {
                        drawX = boxX + boxW - drawW;
                    }

                    if (valign === 'middle') {
                        drawY = boxY + (boxH - drawH) / 2;
                    }

                    if (valign === 'bottom') {
                        drawY = boxY + boxH - drawH;
                    }

                    doc.addImage(image.dataUrl, format, drawX, drawY, drawW, drawH);

                    return {
                        x: drawX,
                        y: drawY,
                        width: drawW,
                        height: drawH,
                        nextY: drawY + drawH,
                    };
                };

                const drawCenteredText = (doc, text, y, fontSize = 24, color = [55, 55, 55], fontStyle = PDF_FONT.regularStyle) => {
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const safeText = sanitizePdfText(text);

                    setPdfFont(doc, fontStyle);
                    doc.setFontSize(fontSize);
                    doc.setTextColor(...color);

                    doc.text(safeText, pageWidth / 2, y, {
                        align: 'center',
                    });

                    setPdfFont(doc, PDF_FONT.regularStyle);
                };

                const drawLogoOrFallback = async (doc, x, y, w, h, fallbackSize = 11) => {
                    if (PDF_LOGO_URL) {
                        try {
                            await addImageFit(doc, PDF_LOGO_URL, x, y, w, h, {
                                format: 'PNG',
                                contain: true,
                            });

                            return;
                        } catch (error) {
                            console.warn('Nie udalo sie dodac logo do PDF:', error);
                        }
                    }

                    setPdfFont(doc, PDF_FONT.mediumStyle);
                    doc.setFontSize(fallbackSize);
                    doc.setTextColor(55, 55, 55);

                    const fallback = 'MITTO HOME';

                    doc.text(fallback, x + w / 2, y + h - 1, {
                        align: 'center',
                    });

                    setPdfFont(doc, PDF_FONT.regularStyle);
                };

                const drawCenteredLogo = async (doc, y, w, h, fallbackSize = 11) => {
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const x = (pageWidth - w) / 2;

                    await drawLogoOrFallback(doc, x, y, w, h, fallbackSize);
                };

                const normalizePdfParams = (configurationData) => {
                    return Array.isArray(configurationData.params)
                        ? configurationData.params.filter(({ value }) => {
                            return value !== undefined && value !== null && String(value).trim() !== '';
                        })
                        : [];
                };

                const getTextLines = (doc, text, maxWidth) => {
                    const safeText = sanitizePdfText(text);

                    if (!safeText) {
                        return [''];
                    }

                    return doc.splitTextToSize(safeText, maxWidth);
                };

                const drawTextLines = (doc, lines, x, y, lineHeight) => {
                    lines.forEach((line, index) => {
                        doc.text(line, x, y + index * lineHeight);
                    });
                };

                const getUpperLabel = (label) => {
                    return sanitizePdfText(label)
                        .replace(':', '')
                        .toUpperCase();
                };

                const getParamRows = (params) => {
                    const rows = [];

                    for (let i = 0; i < params.length; i += 2) {
                        rows.push([
                            params[i] || null,
                            params[i + 1] || null,
                        ]);
                    }

                    return rows;
                };

                const measureStackedParam = (doc, param, columnW) => {
                    if (!param) {
                        return 0;
                    }

                    const labelLineHeight = 3.3;
                    const valueLineHeight = 4.2;
                    const labelToValueGap = 2.5;

                    setPdfFont(doc, PDF_FONT.regularStyle);

                    doc.setFontSize(6.7);
                    const labelLines = getTextLines(doc, getUpperLabel(param.label), columnW);

                    setPdfFont(doc, PDF_FONT.mediumStyle);
                    doc.setFontSize(8.8);
                    const valueLines = getTextLines(doc, param.value, columnW);

                    setPdfFont(doc, PDF_FONT.regularStyle);

                    return (
                        labelLines.length * labelLineHeight +
                        labelToValueGap +
                        valueLines.length * valueLineHeight
                    );
                };

                const measureStackedRowsHeight = (doc, rows, columnW) => {
                    const rowGap = 3.2;

                    let height = 0;

                    rows.forEach((row) => {
                        const leftHeight = measureStackedParam(doc, row[0], columnW);
                        const rightHeight = measureStackedParam(doc, row[1], columnW);
                        const rowHeight = Math.max(leftHeight, rightHeight, 9.5);

                        height += rowHeight + rowGap;
                    });

                    return Math.max(0, height - rowGap);
                };

                const drawStackedParam = (doc, param, x, y, columnW) => {
                    if (!param) {
                        return 0;
                    }

                    const labelLineHeight = 3.3;
                    const valueLineHeight = 4.2;
                    const labelToValueGap = 2.5;

                    setPdfFont(doc, PDF_FONT.regularStyle);
                    doc.setFontSize(6.7);
                    doc.setTextColor(110, 110, 110);

                    const labelLines = getTextLines(doc, getUpperLabel(param.label), columnW);
                    drawTextLines(doc, labelLines, x, y, labelLineHeight);

                    const valueY = y + labelLines.length * labelLineHeight + labelToValueGap;

                    setPdfFont(doc, PDF_FONT.mediumStyle);
                    doc.setFontSize(8.8);
                    doc.setTextColor(64, 64, 64);

                    const valueLines = getTextLines(doc, param.value, columnW);
                    drawTextLines(doc, valueLines, x, valueY, valueLineHeight);

                    setPdfFont(doc, PDF_FONT.regularStyle);

                    return (
                        labelLines.length * labelLineHeight +
                        labelToValueGap +
                        valueLines.length * valueLineHeight
                    );
                };

                const drawSummaryCard = (doc, configurationData, startY) => {
                    const pageWidth = doc.internal.pageSize.getWidth();

                    const cardX = 25;
                    const cardY = startY;
                    const cardW = pageWidth - 50;

                    const headerH = 22;
                    const priceH = 18;

                    const border = [222, 222, 222];
                    const text = [64, 64, 64];
                    const lightText = [88, 88, 88];

                    const params = normalizePdfParams(configurationData);
                    const rows = getParamRows(params);

                    const innerPadX = 8;
                    const paramsTopPad = 7;
                    const paramsBottomPad = 7;
                    const columnGap = 18;

                    const middleX = cardX + cardW / 2;
                    const leftColumnX = cardX + innerPadX;
                    const rightColumnX = middleX + columnGap / 2;
                    const columnW = (cardW - innerPadX * 2 - columnGap) / 2;

                    setPdfFont(doc, PDF_FONT.regularStyle);

                    const paramsContentH = Math.max(measureStackedRowsHeight(doc, rows, columnW), 30);
                    const paramsH = paramsTopPad + paramsContentH + paramsBottomPad;

                    const cardH = headerH + paramsH + priceH;

                    doc.setDrawColor(...border);
                    doc.setLineWidth(0.25);
                    doc.roundedRect(cardX, cardY, cardW, cardH, 1.5, 1.5, 'S');

                    setPdfFont(doc, PDF_FONT.boldStyle);
                    doc.setFontSize(18);
                    doc.setTextColor(...text);

                    const headerText = sanitizePdfText(
                        TRANSLATE?.save_configuration?.pdf?.summary_title
                    );

                    doc.text(headerText, cardX + cardW / 2, cardY + 14.2, {
                        align: 'center',
                    });

                    setPdfFont(doc, PDF_FONT.regularStyle);

                    doc.setDrawColor(...border);
                    doc.line(cardX, cardY + headerH, cardX + cardW, cardY + headerH);
                    doc.line(cardX, cardY + headerH + paramsH, cardX + cardW, cardY + headerH + paramsH);

                    doc.line(
                        middleX,
                        cardY + headerH + 6,
                        middleX,
                        cardY + headerH + paramsH - 6
                    );

                    const rowGap = 3.2;
                    let currentY = cardY + headerH + paramsTopPad;

                    rows.forEach((row) => {
                        const leftHeight = drawStackedParam(doc, row[0], leftColumnX, currentY, columnW);
                        const rightHeight = drawStackedParam(doc, row[1], rightColumnX, currentY, columnW);
                        const rowHeight = Math.max(leftHeight, rightHeight, 9.5);

                        currentY += rowHeight + rowGap;
                    });

                    const priceLabel = sanitizePdfText(
                        TRANSLATE?.save_configuration?.pdf?.final_price_label
                    );

                    const priceValue = sanitizePdfText(`${formatPrice(configurationData.price)} ${CURRENCY}`);

                    const priceY = cardY + headerH + paramsH + 10.8;

                    setPdfFont(doc, PDF_FONT.regularStyle);
                    doc.setFontSize(9);
                    doc.setTextColor(...lightText);
                    doc.text(priceLabel, cardX + innerPadX, priceY);

                    setPdfFont(doc, PDF_FONT.boldStyle);
                    doc.setFontSize(10);
                    doc.setTextColor(...text);

                    const priceWidth = doc.getTextWidth(priceValue);
                    doc.text(priceValue, cardX + cardW - innerPadX - priceWidth, priceY);

                    setPdfFont(doc, PDF_FONT.regularStyle);

                    return {
                        x: cardX,
                        y: cardY,
                        width: cardW,
                        height: cardH,
                        nextY: cardY + cardH,
                    };
                };

                const addUnderlinedLinkText = (doc, text, url, y) => {
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const centerX = pageWidth / 2;
                    const safeText = sanitizePdfText(text);

                    setPdfFont(doc, PDF_FONT.mediumStyle);
                    doc.setFontSize(10);
                    doc.setTextColor(64, 64, 64);

                    doc.text(safeText, centerX, y, {
                        align: 'center',
                    });

                    const textWidth = doc.getTextWidth(safeText);
                    const x = centerX - textWidth / 2;

                    doc.setDrawColor(64, 64, 64);
                    doc.setLineWidth(0.2);
                    doc.line(x, y + 0.8, x + textWidth, y + 0.8);

                    if (url) {
                        doc.link(x, y - 4, textWidth, 6, {
                            url,
                        });
                    }

                    setPdfFont(doc, PDF_FONT.regularStyle);
                };

                const drawFooterTextSegments = (doc, text, x, y) => {
                    const safeText = getPhonePdfText(text);
                    const segments = safeText.split(' ').filter(Boolean);
                    const visualSpaceW = doc.getTextWidth(' ') * 0.9;

                    let currentX = x;

                    segments.forEach((segment, index) => {
                        doc.text(segment, currentX, y);
                        currentX += doc.getTextWidth(segment);

                        if (index < segments.length - 1) {
                            currentX += visualSpaceW;
                        }
                    });
                };

                const getFooterSegmentedTextWidth = (doc, text) => {
                    const safeText = getPhonePdfText(text);
                    const segments = safeText.split(' ').filter(Boolean);

                    if (!segments.length) {
                        return 0;
                    }

                    const visualSpaceW = doc.getTextWidth(' ') * 0.9;

                    return segments.reduce((sum, segment, index) => {
                        return sum + doc.getTextWidth(segment) + (index < segments.length - 1 ? visualSpaceW : 0);
                    }, 0);
                };

                const drawFooter = async (doc, footerTopY = 264) => {
                    const pageWidth = doc.internal.pageSize.getWidth();

                    const innerX = 25;
                    const innerW = pageWidth - innerX * 2;

                    const logoW = 32;
                    const logoH = 7;

                    const rowCenterY = footerTopY + 12;
                    const logoY = rowCenterY - logoH / 2;
                    const textY = rowCenterY + 1.45;

                    await drawLogoOrFallback(doc, innerX, logoY, logoW, logoH, 8.5);

                    setPdfFont(doc, PDF_FONT.regularStyle);
                    doc.setFontSize(8);
                    doc.setTextColor(75, 75, 75);

                    const footerItems = [
                        {
                            value: PDF_EMAIL,
                            type: 'email',
                        },
                        {
                            value: PDF_PHONE_NUMBER,
                            type: 'phone',
                        },
                        {
                            value: normalizeWebUrlLabel(PDF_WEB_URL),
                            type: 'web',
                        },
                    ].filter((item) => item.value);

                    if (!footerItems.length) {
                        return;
                    }

                    const gap = 8;

                    const itemWidths = footerItems.map((item) => {
                        if (item.type === 'phone') {
                            return getFooterSegmentedTextWidth(doc, item.value);
                        }

                        return doc.getTextWidth(sanitizePdfText(item.value));
                    });

                    const totalItemsW = itemWidths.reduce((sum, width) => sum + width, 0);
                    const totalGapsW = gap * 2 * (footerItems.length - 1);
                    const groupW = totalItemsW + totalGapsW;

                    let x = innerX + innerW - groupW;

                    footerItems.forEach((item, index) => {
                        const safeItem = sanitizePdfText(item.value);
                        const itemW = itemWidths[index];

                        doc.setTextColor(75, 75, 75);

                        if (item.type === 'phone') {
                            drawFooterTextSegments(doc, safeItem, x, textY);
                        } else {
                            doc.text(safeItem, x, textY);

                            if (item.type === 'email' && PDF_EMAIL) {
                                doc.link(x, rowCenterY - 3, itemW, 6, {
                                    url: `mailto:${PDF_EMAIL}`,
                                });
                            }

                            if (item.type === 'web' && PDF_WEB_URL) {
                                doc.link(x, rowCenterY - 3, itemW, 6, {
                                    url: PDF_WEB_URL,
                                });
                            }
                        }

                        x += itemW;

                        if (index < footerItems.length - 1) {
                            x += gap;

                            doc.setDrawColor(210, 210, 210);
                            doc.line(x, rowCenterY - 4, x, rowCenterY + 4);

                            x += gap;
                        }
                    });
                };

                const downloadConfigurationPDF = async () => {
                    try {
                        const jsPDF = await loadJsPDF();

                        const doc = new jsPDF({
                            orientation: 'portrait',
                            unit: 'mm',
                            format: 'a4',
                        });

                        await registerPdfFont(doc);

                        const configurationData = await returnConfigurationData();

                        if (!configurationData) {
                            return;
                        }

                        const pageWidth = doc.internal.pageSize.getWidth();
                        const pageHeight = doc.internal.pageSize.getHeight();

                        setPdfFont(doc, PDF_FONT.regularStyle);

                        doc.setFillColor(246, 246, 246);
                        doc.rect(0, 0, pageWidth, pageHeight, 'F');

                        doc.setFillColor(255, 255, 255);
                        doc.rect(7, 10, pageWidth - 14, pageHeight - 20, 'F');

                        setPdfFont(doc, PDF_FONT.regularStyle);
                        doc.setFontSize(7);
                        doc.setTextColor(175, 175, 175);
                        doc.text('PDF - ' + TRANSLATE?.save_configuration?.pdf?.title, 7, 8);

                        await drawCenteredLogo(doc, 23, 50, 7.5, 10);

                        drawCenteredText(
                            doc,
                            TRANSLATE?.save_configuration?.pdf?.title,
                            39,
                            15,
                            [55, 55, 55],
                            PDF_FONT.mediumStyle
                        );

                        let imageBottomY = 108;

                        if (configurationData.variantImage) {
                            try {
                                const imageBox = {
                                    x: 25,
                                    y: 44,
                                    w: pageWidth - 50,
                                    h: 60,
                                };

                                const imageResult = await addImageFit(
                                    doc,
                                    configurationData.variantImage,
                                    imageBox.x,
                                    imageBox.y,
                                    imageBox.w,
                                    imageBox.h,
                                    {
                                        format: 'JPEG',
                                        contain: true,
                                    }
                                );

                                imageBottomY = imageResult.y + imageResult.height + 5;
                            } catch (error) {
                                console.warn('Nie udalo sie dodac zdjecia produktu do PDF:', error);
                            }
                        }

                        const summaryCard = drawSummaryCard(
                            doc,
                            configurationData,
                            Math.max(imageBottomY, 108)
                        );

                        const ctaY = summaryCard.nextY + 9;
                        const linkY = ctaY + 7;

                        drawCenteredText(
                            doc,
                            TRANSLATE?.save_configuration?.pdf?.question,
                            ctaY,
                            10,
                            [64, 64, 64],
                            PDF_FONT.regularStyle
                        );

                        addUnderlinedLinkText(
                            doc,
                            TRANSLATE?.save_configuration?.pdf?.configuration_button?.cta,
                            configurationData.configurationURL,
                            linkY
                        );

                        const contactLineY = linkY + 11;
                        const contactTitleY = contactLineY + 8;
                        const contactSubtitleY = contactTitleY + 7;
                        const footerTopY = 264;

                        doc.setDrawColor(220, 220, 220);
                        doc.setLineWidth(0.25);
                        doc.line(25, contactLineY, pageWidth - 25, contactLineY);

                        drawCenteredText(
                            doc,
                            TRANSLATE?.save_configuration?.pdf?.contact_title,
                            contactTitleY,
                            9,
                            [55, 55, 55],
                            PDF_FONT.mediumStyle
                        );

                        drawCenteredText(
                            doc,
                            TRANSLATE?.save_configuration?.pdf?.contact_subtitle,
                            contactSubtitleY,
                            8,
                            [90, 90, 90],
                            PDF_FONT.regularStyle
                        );

                        await drawFooter(doc, footerTopY);

                        doc.save(`${TRANSLATE.save_configuration.pdf.file_name}.pdf`);

                        __newNotification({
                            copy: TRANSLATE.save_configuration.notifications.download_pdf,
                        });

                        __closePopup();
                    } catch (error) {
                        console.error(error);
                    }
                };

                sendConfigButton?.addEventListener('click', function () {
                    popup.querySelector('._view[data-view="1"]').classList.remove('_digi-visible');
                    popup.querySelector('._view[data-view="2"]').classList.add('_digi-visible');
                });

                downloadPdfButton?.addEventListener('click', function () {
                    downloadConfigurationPDF();
                });

                copyLinkButton?.addEventListener('click', async function () {
                    const configURL = returnConfigurationURL();

                    try {
                        await navigator.clipboard.writeText(configURL);

                        __newNotification({
                            copy: TRANSLATE.save_configuration.notifications.copy_link,
                        });

                        __closePopup();
                    } catch (error) {
                        console.error(error);
                    }
                });
            };

            const __viewNr2_Logic = () => {
                const form = popup.querySelector('form');
                const backButton = form.querySelector('._back--btn');
                const submitButton = form.querySelector('button._send-config--btn[type="submit"]');
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                let isFormBlocked = false;

                const emailInput = form.querySelector('input[type="email"][name="digi-save-config--email"]');
                const agreeCheckbox = form.querySelector('input[type="checkbox"][name="digi-save-config--agree"]');

                // === Wysyłka konfiguracji do klienta przez Klaviyo (client-side, Klaviyo client/events API) ===
                // Wysyła zdarzenie "Saved Configuration" z pełnymi danymi konfiguracji.
                // Maila do klienta wysyła Flow w Klaviyo uruchamiany tym zdarzeniem.
                const __sendConfigurationToKlaviyo = async (data) => {
                    try {
                        const configurationData = await returnConfigurationData();

                        const params = Array.isArray(configurationData?.params) ? configurationData.params : [];
                        const parametersText = params
                            .map(({ label, value }) => `${label}: ${value}`)
                            .join('\n');

                        const eventProperties = {
                            ProductName: configurationData?.name || PRODUCT_DATA?.title || '',
                            Price: typeof configurationData?.price === 'number' ? configurationData.price : null,
                            Currency: CURRENCY,
                            ConfigurationURL: configurationData?.configurationURL || window.location.href,
                            ImageUrl: configurationData?.variantImage || '',
                            Language: WEB_LANG,
                            Consent: !!data.agree,
                            PageUrl: window.location.href,
                            Parameters: params,            // [{ label, value }, ...]
                            ParametersText: parametersText // "Label: Value" w kolejnych liniach
                        };

                        // Publiczny Site ID Klaviyo (bezpieczny po stronie front-endu)
                        const KLAVIYO_COMPANY_ID = 'W54UUv';

                        const payload = {
                            data: {
                                type: 'event',
                                attributes: {
                                    properties: eventProperties,
                                    metric: { data: { type: 'metric', attributes: { name: 'Saved Configuration' } } },
                                    profile: { data: { type: 'profile', attributes: { email: data.email } } }
                                }
                            }
                        };

                        // Oficjalny endpoint client-side Klaviyo (Create Client Event) — używa publicznego Site ID
                        const response = await fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'revision': '2024-10-15'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!response.ok) {
                            const errText = await response.text().catch(() => '');
                            console.error('[Konfigurator] Klaviyo odrzuciło zdarzenie — HTTP ' + response.status, errText);
                        }
                    } catch (error) {
                        console.error('[Konfigurator] Błąd wysyłki do Klaviyo (możliwe blokowanie żądania przez rozszerzenie przeglądarki / baner cookies / adblocker):', error);
                    }
                };

                // === Zapis zgody marketingowej (tylko gdy zaznaczony checkbox zgody) ===
                // Subskrybuje profil do listy newslettera zależnie od języka strony.
                const __subscribeToMarketing = async (email) => {
                    const KLAVIYO_COMPANY_ID = 'W54UUv';
                    const LIST_BY_LANG = {
                        pl: 'Sw3p9g', // Email subscribers list (PL)
                        de: 'VPKiWu', // Email subscribers list DE
                        cs: 'R5t3Fc'  // Email subscribers list CZ
                    };

                    const listId = LIST_BY_LANG[(WEB_LANG || '').toLowerCase()];
                    if (!listId) return;

                    try {
                        const payload = {
                            data: {
                                type: 'subscription',
                                attributes: {
                                    custom_source: 'Konfigurator - zapis konfiguracji',
                                    profile: { data: { type: 'profile', attributes: { email: email } } }
                                },
                                relationships: { list: { data: { type: 'list', id: listId } } }
                            }
                        };

                        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO_COMPANY_ID, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'revision': '2024-10-15'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!response.ok) {
                            const errText = await response.text().catch(() => '');
                            console.error('[Konfigurator] Subskrypcja marketingowa odrzucona — HTTP ' + response.status, errText);
                        }
                    } catch (error) {
                        console.error('[Konfigurator] Błąd subskrypcji marketingowej:', error);
                    }
                };

                backButton?.addEventListener('click', function () {
                    popup.querySelector('._view[data-view="2"]').classList.remove('_digi-visible');
                    popup.querySelector('._view[data-view="1"]').classList.add('_digi-visible');
                });

                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                    if (isFormBlocked) return;

                    const formData = {
                        email: null,
                        agree: false
                    };

                    let validStatus = true;

                    emailInput.classList.remove('digi-valid-error');
                    agreeCheckbox.classList.remove('digi-valid-error');


                    if (!emailRegex.test(emailInput.value.trim())) {
                        validStatus = false;
                        emailInput.classList.add('digi-valid-error');
                        //console.log('Niepoprawny email');
                    };



                    if (validStatus) {
                        isFormBlocked = true;

                        formData.email = emailInput.value;

                        if (agreeCheckbox.checked) {
                            formData.agree = true;
                        };

                        // Wysyłka konfiguracji do klienta przez Klaviyo (zdarzenie -> Flow -> e-mail)
                        __sendConfigurationToKlaviyo(formData);

                        // Zgoda marketingowa: zapis do newslettera tylko gdy zaznaczono checkbox
                        if (formData.agree) {
                            __subscribeToMarketing(formData.email);
                        }

                        __newNotification({
                            copy: TRANSLATE.save_configuration.notifications.email
                        });

                        __closePopup();

                        // submitButton.innerHTML = `
                        //     <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        //         <path d="M5.88117 10.0394L10.856 5.0645L10.3056 4.51403L5.88117 8.93842L3.6645 6.72175L3.11403 7.27222L5.88117 10.0394ZM7.00253 14C6.03458 14 5.12452 13.8163 4.27233 13.4489C3.42028 13.0816 2.67906 12.583 2.04867 11.9533C1.41828 11.3235 0.919268 10.583 0.551639 9.73155C0.18388 8.88028 0 7.9706 0 7.00253C0 6.03458 0.183685 5.12452 0.551055 4.27233C0.918426 3.42028 1.41698 2.67906 2.04672 2.04867C2.67646 1.41828 3.41704 0.919268 4.26844 0.551639C5.11972 0.18388 6.0294 0 6.99747 0C7.96542 0 8.87548 0.183686 9.72767 0.551056C10.5797 0.918426 11.3209 1.41698 11.9513 2.04672C12.5817 2.67646 13.0807 3.41704 13.4484 4.26844C13.8161 5.11972 14 6.0294 14 6.99747C14 7.96542 13.8163 8.87548 13.4489 9.72767C13.0816 10.5797 12.583 11.3209 11.9533 11.9513C11.3235 12.5817 10.583 13.0807 9.73155 13.4484C8.88028 13.8161 7.9706 14 7.00253 14ZM7 13.2222C8.73704 13.2222 10.2083 12.6194 11.4139 11.4139C12.6194 10.2083 13.2222 8.73704 13.2222 7C13.2222 5.26296 12.6194 3.79167 11.4139 2.58611C10.2083 1.38056 8.73704 0.777778 7 0.777778C5.26296 0.777778 3.79167 1.38056 2.58611 2.58611C1.38056 3.79167 0.777778 5.26296 0.777778 7C0.777778 8.73704 1.38056 10.2083 2.58611 11.4139C3.79167 12.6194 5.26296 13.2222 7 13.2222Z" fill="#FFFFFF"/>
                        //     </svg>

                        //     ${TRANSLATE.save_configuration.popup.content.view_nr_2.form.buttons.sent}
                        // `;
                        // submitButton.classList.add('_success');
                        // setTimeout(() => {
                        //     isFormBlocked = false;
                        //     submitButton.innerHTML = TRANSLATE.save_configuration.popup.content.view_nr_2.form.buttons.submit;
                        //     submitButton.classList.remove('_success');
                        // }, 5000);
                    } else {
                        //console.log('NOT SUBMIT')
                    };
                });

                emailInput.addEventListener('focus', function () {
                    emailInput.classList.remove('digi-valid-error');
                });

                agreeCheckbox.addEventListener('change', function () {
                    agreeCheckbox.parentNode.classList.remove('digi-valid-error');
                });
            };

            __createNotificationWrapper();
            __viewNr1_Logic();
            __viewNr2_Logic();
        };

        const __createSaveConfig__Button = () => {
            const saveConfigButtonTemp = `
                <div class='button button--secondary _digi-save-config-button'>
                    <span class='_icon'>
                        <svg width="18" height="18" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.82142 16L7.79642 15.0757C6.25714 13.6749 4.98423 12.4711 3.97767 11.4644C2.97113 10.4577 2.17352 9.5617 1.58484 8.7765C0.99614 7.9913 0.58483 7.2751 0.3509 6.6279C0.11696 5.98059 0 5.32378 0 4.65741C0 3.33543 0.44434 2.2287 1.33303 1.33722C2.22172 0.44574 3.32499 0 4.64283 0C5.45355 0 6.21962 0.19019 6.94102 0.57056C7.66242 0.95092 8.28922 1.49637 8.82142 2.20692C9.35352 1.49637 9.98032 0.95092 10.7017 0.57056C11.4232 0.19019 12.1892 0 13 0C14.3178 0 15.4211 0.44574 16.3098 1.33722C17.1984 2.2287 17.6428 3.33543 17.6428 4.65741C17.6428 5.32378 17.5258 5.98059 17.2919 6.6279C17.058 7.2751 16.6467 7.9913 16.058 8.7765C15.4693 9.5617 14.6731 10.4577 13.6696 11.4644C12.666 12.4711 11.3916 13.6749 9.84642 15.0757L8.82142 16ZM8.82142 14.112C10.3071 12.7709 11.5297 11.6215 12.4892 10.6637C13.4488 9.7059 14.2071 8.8739 14.7642 8.1675C15.3214 7.4611 15.7083 6.8339 15.925 6.2857C16.1416 5.73757 16.25 5.1948 16.25 4.65741C16.25 3.72592 15.9404 2.94968 15.3214 2.32869C14.7023 1.7077 13.9285 1.39721 13 1.39721C12.2666 1.39721 11.5889 1.6059 10.9669 2.02328C10.3449 2.44065 9.85232 3.02134 9.48922 3.76535H8.15352C7.78452 3.01538 7.29042 2.43319 6.67141 2.01879C6.05236 1.6044 5.37617 1.39721 4.64283 1.39721C3.72022 1.39721 2.94789 1.7077 2.32586 2.32869C1.70384 2.94968 1.39283 3.72592 1.39283 4.65741C1.39283 5.1948 1.50116 5.73757 1.71783 6.2857C1.9345 6.8339 2.3214 7.4611 2.87854 8.1675C3.43569 8.8739 4.19402 9.7045 5.15354 10.6592C6.11307 11.614 7.33572 12.7649 8.82142 14.112Z" fill="#353535"/>
                        </svg>
                    </span>
                    <span class='_cta'>${TRANSLATE.save_configuration.button.cta}</span>
                </div>
            `;

            webButton_addToCart.insertAdjacentHTML('afterbegin', saveConfigButtonTemp);

            const saveConfigButton = webButton_addToCart.querySelector('._digi-save-config-button');
            if (!saveConfigButton) return;

            saveConfigButton.addEventListener('click', function () {
                __createSaveConfig__Popup();
            });
        };

        __customCSS_saveConfig();
        __createSaveConfig__Button();
    };

    const __newConfigurator = (webConfig) => {
        const webConfigurator = webConfig;
        if (!webConfigurator) return;

        const configPanel = webConfigurator.querySelector('.product-configurator__right');
        if (!configPanel) return;

        const configElements = Array.from(configPanel.querySelectorAll('.product-configurator__accordion.accordion[data-type]'));
        if (!configElements?.length) return;

        const productParams = document.querySelector('product-info .product__params');
        if (!productParams) return;

        const FRONT_PANEL = {
            attributes: []
        };

        const MATERIAL_GROUPS = {};
        const AVAILABLE_MATERIALS = {};

        configElements.forEach(configEl => {
            const attrKey = configEl.dataset.type;
            const contentValueData = Array.from(configEl.querySelectorAll('fieldset.product-configurator__fieldset input[type="radio"][value]'));

            FRONT_PANEL.attributes.push({
                [attrKey]: contentValueData
            });
        });

        if (!FRONT_PANEL.attributes?.length) return;

        const FRONT_CONTENT_DATA = [];
        const keysForEvents = [];
        const colorAttr = FRONT_PANEL.attributes.find(el => Object.keys(el)[0] === 'color');
        const layoutAttr = FRONT_PANEL.attributes.find(el => Object.keys(el)[0] === 'layout');

        let isTotalWidthSection = false;
        const _custom_handle = {
            current: null,
            new: null,
        };
        let newVariantID = null;

        FRONT_PANEL.attributes.forEach(attr => {
            let box = ``;
            let content = ``;
            const key = Object.keys(attr)[0];
            let order = 0;
            const boxKeyName = findKeyPath(attrKeys, key);


            if (attrKeys.sleepSize.includes(key)) {
                order = 0;
                isTotalWidthSection = true;

                attr[key].forEach(el => {
                    content += `
                        <label class='digi-box-label ${el.checked ? "digi-checked" : ""}' data-value='${el.value}' data-name='${el.name}'>
                            <input type='${el.type}' value='${el.value}' name='${el.name}'>
                            <div class='value'>${el.value}</div>
                            <div class='price-difference'></div>
                        </label>
                    `;

                    if (el.checked) {
                        CURRENT_INPUTS_DATA['sleepSize'] = el.value;
                    };
                });

                box = `
                	<div class='digi-config__box' box-name='${boxKeyName}'>
                    	<div class='box-title'>
                        	<strong>${TRANSLATE.box__sleep_size.sleep_size} (cm)</strong>
                            <span class='digi-config__aside-panel-open' for='size-table'>${TRANSLATE.box__sleep_size.size_table}</span>
                        </div>
                        
                        <div class='box-content'>
                        	${content}
                        </div>
                    </div>
                `;
            } else if (attrKeys.material.includes(key)) {
                order = 1;

                let len = {
                    length: 0,
                    limit: 7,
                    more: 0,
                    firstViewLength: 0
                };

                if (window.innerWidth > 1920) {
                    len.limit = 7;
                } else if (window.innerWidth > 1520) {
                    len.limit = 6;
                } else if (window.innerWidth > 1200) {
                    len.limit = 5;
                } else {
                    len.limit = 4;
                };

                len.max = len.limit;

                let materialData = {
                    name: '',
                    color: ''
                };

                attr[key].forEach((el, index) => {
                    const foundColors = colorAttr.color.filter(inputColor => inputColor.dataset.group.toLowerCase().trim().replaceAll(' ', '-') === el.dataset.techName.toLowerCase().trim().replaceAll(' ', '-'));
                    let selectedColor = '';

                    len.more += foundColors.length;
                    len.firstViewLength++;

                    if (el.checked) {
                        materialData.name = el.value.charAt(0).toUpperCase() + el.value.slice(1);

                        if (colorAttr) {
                            const checked = colorAttr?.color?.find(input => input.dataset.group === el.value.toLowerCase().trim().replaceAll(' ', '-') && input.checked);

                            if (checked) {
                                // materialData.color = checked.value.charAt(0).toUpperCase() + checked.value.slice(1);
                                // CURRENT_INPUTS_DATA['color'] = checked.value;

                                // selectedColor = checked.value; 
                            };
                        };

                        CURRENT_INPUTS_DATA['material'] = el.value;
                    };

                    const firstColor = foundColors.find(inputObj => materialCollection[inputObj.dataset.group.toLowerCase().trim().replaceAll(' ', '-')] === inputObj.dataset.techName);

                    let isLabelChecked = false;

                    if (len.limit > index) {
                        len.length++;
                        // ${el.checked ? "digi-checked" : ""}

                        content += `
                            <label class='digi-box-label open-mobile-only' custom-for='all-materials' data-value='${el.value}' data-name='${el.name}' data-color='${firstColor.dataset.techName}'>
                                <input type='${el.type}' value='${el.value}' name='${el.name}'>
                                <div class='value'>
                                    ${__getMaterialData({ name: el.value }).basic.image}
                                </div>
                            </label>
                        `;
                    };

                    MATERIAL_GROUPS[el.dataset.techName] = el.dataset.group;
                    AVAILABLE_MATERIALS[el.value] = foundColors;
                });

                if (len.more - len.length > 0) {
                    const langRules = returnLangRules(len.more - len.length, TRANSLATE.box__material.options);

                    content += `
                    	<label class='digi-box-label more digi-config__aside-panel-open' for='all-materials'>
                        	<div class='value'>
                            	<span class='_t-n'>+${len.more - len.length}</span>
                                <span class='_t-o'>&nbsp;${langRules}</span>
                            </div>
                        </label>
                    `;
                };

                if (len.limit - len.firstViewLength === 1 || len.limit - len.firstViewLength === 2) {
                    len.max = len.limit - (len.limit - len.firstViewLength);
                };

                box = `
                	<div class='digi-config__box' for='all-materials' box-name='${boxKeyName}' box-static-name='material'>
                    	<div class='box-title'>
                        	<strong>${TRANSLATE.box__material.material_and_color}</strong>
                            <div class='digi-config__aside-panel-open' for='more-about-this-material'>${TRANSLATE.box__material.more_about_this_material}</div>
                        </div>
                        
                        <div class='box-content' style='--digiContentTemplateColumns: repeat(${len.max + 1}, 1fr)'>
                        	${content}
                        </div>
                        
                        <div class='box-summary-content'>
                        	<div class='box-summary'>
                            	<div class='s-el' summary-name='material'>
                                	<span class='s-n'>${TRANSLATE.box__material.material}</span>: <span class='s-v'>${materialData.name}</span>
                                </div>
                                
                                <div class='s-el' summary-name='color'>
                                	<span class='s-n'>${TRANSLATE.box__material.color}</span>: <span class='s-v'>${materialData.color}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            } else if (attrKeys.sleepFunction.sectionName.includes(key)) {
                order = 3;

                const langMap = {
                    'yes': attrKeys.sleepFunction.yesOrNot.yes,
                    'no': attrKeys.sleepFunction.yesOrNot.not
                };

                const normalize = v => v?.toLowerCase().trim();
                const yesEl = attr[key].find(input => langMap.yes.map(normalize).includes(normalize(input.value)));
                const noEl = attr[key].find(input => langMap.no.map(normalize).includes(normalize(input.value)));


                content = `
                	<label class='digi-box-label ${yesEl.checked ? "digi-checked" : ""}' data-value='${yesEl.value}' data-name='${yesEl.name}'>
                    	<input type='radio' value='${yesEl.value}' name='${yesEl.name}'>
                        <div class='icon'>
							<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.0564 7.02979H3.61499V16.7563H2.0564C1.6036 16.7563 1.23618 16.3888 1.23608 15.936V7.8501C1.23612 7.39726 1.60356 7.02982 2.0564 7.02979Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M29.9219 7.02979H28.3633V16.7563H29.9219C30.3747 16.7563 30.7421 16.3888 30.7422 15.936V7.8501C30.7422 7.39726 30.3747 7.02982 29.9219 7.02979Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M16.0339 7.02979V23.2563C16.0338 23.709 15.6673 24.0765 15.2146 24.0767H4.44214C3.98934 24.0766 3.62192 23.7091 3.62183 23.2563V7.02979H16.0339Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M28.3997 7.02979V23.2534C28.3995 23.7079 28.0309 24.0767 27.5764 24.0767H16.8782C16.4254 24.0766 16.058 23.7091 16.0579 23.2563V7.02979H28.3997Z" stroke="black" stroke-width="0.727273"/>
                              <line x1="4" y1="10.2465" x2="28.6667" y2="10.2465" stroke="black" stroke-width="0.84"/>
                            </svg>
                        </div>
                        <div class='details'>
                        	<div class='value'>${TRANSLATE.box__sleep_function.yes}</div>
                            <div class='price-difference'></div>
                        </div>
                    </label>
                    
                    <label class='digi-box-label ${noEl.checked ? "digi-checked" : ""}' data-value='${noEl.value}' data-name='${noEl.name}'>
                    	<input type='radio' value='${noEl.value}' name='${noEl.name}'>
                        <div class='icon'>
							<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.0564 11.0298H3.61499V20.7563H2.0564C1.6036 20.7563 1.23618 20.3888 1.23608 19.936V11.8501C1.23612 11.3973 1.60356 11.0298 2.0564 11.0298Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M29.9219 11.0298H28.3633V20.7563H29.9219C30.3747 20.7563 30.7421 20.3888 30.7422 19.936V11.8501C30.7422 11.3973 30.3747 11.0298 29.9219 11.0298Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M16.0339 11.0298V20.5933C16.0339 21.046 15.6673 21.4134 15.2146 21.4136H4.44214C3.98928 21.4135 3.62183 21.0461 3.62183 20.5933V11.0298H16.0339Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M28.3997 11.0298V20.5903C28.3996 21.0448 28.0309 21.4136 27.5764 21.4136H16.8782C16.4253 21.4135 16.0579 21.0461 16.0579 20.5933V11.0298H28.3997Z" stroke="black" stroke-width="0.727273"/>
                              <line x1="4" y1="14.2465" x2="28.6667" y2="14.2465" stroke="black" stroke-width="0.84"/>
                            </svg>
                        </div>
                        <div class='details'>
                        	<div class='value'>${TRANSLATE.box__sleep_function.no}</div>
                            <div class='price-difference'></div>
                        </div>
                    </label>
                `;

                box = `
                	<div class='digi-config__box' box-name='${boxKeyName}'>
                    	<div class='box-title'>
                        	<strong>${TRANSLATE.box__sleep_function.sleep_function}</strong>
                            <span class='digi-config__aside-panel-open' for='sleep_details'>${TRANSLATE.box__sleep_function.details}</span>
                        </div>
                        
                        <div class='box-content'>
                        	${content}
                        </div>
                    </div>
                `;

                if (yesEl.checked) {
                    CURRENT_INPUTS_DATA['sleepFunction'] = yesEl.value;
                } else if (noEl.checked) {
                    CURRENT_INPUTS_DATA['sleepFunction'] = noEl.value;
                };
            } else if (attrKeys.layout.includes(key)) {
                order = 4;

                const langMap = {
                    'left': ['lewa'],
                    'right': ['prawa']
                };

                const normalize = v => v?.toLowerCase().trim();
                const leftEl = attr[key].find(input => langMap.left.map(normalize).includes(normalize(input.dataset.techName)));
                const rightEl = attr[key].find(input => langMap.right.map(normalize).includes(normalize(input.dataset.techName)));

                // leftEl.checked ? "digi-checked" : ""
                // rightEl.checked ? "digi-checked" : ""

                content = `
                	<label class='digi-box-label' data-value='${leftEl.value}' data-name='${leftEl.name}'>
                    	<input type='radio' value='${leftEl.value}' name='${leftEl.name}'>
                        <div class='icon'>
							<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.05664 5.70898C1.60378 5.70898 1.23636 6.07644 1.23633 6.5293V24.6689C1.23633 25.1228 1.60472 25.4912 2.05859 25.4912H3.56348V5.70898H2.05664Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M29.98 5.7085H28.4214V15.4351H29.98C30.4328 15.435 30.8002 15.0675 30.8003 14.6147V6.52881C30.8003 6.07597 30.4328 5.70853 29.98 5.7085Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M12.6794 16.1089H3.573V25.4692C3.573 25.9231 3.94139 26.2915 4.39526 26.2915H12.6794C13.1322 26.2915 13.4997 25.924 13.4998 25.4712V16.9292C13.4997 16.4764 13.1323 16.1089 12.6794 16.1089Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M16.0024 5.70898V15.2725C16.0024 15.7252 16.369 16.0926 16.8218 16.0928H27.5942C28.0471 16.0927 28.4146 15.7253 28.4146 15.2725V5.70898H16.0024Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M3.63672 5.70898V16.0928H15.1582C15.6111 16.0927 15.9785 15.7253 15.9785 15.2725V5.70898H3.63672Z" stroke="black" stroke-width="0.727273"/>
                              <line x1="4.00024" y1="8.1801" x2="28.6669" y2="8.1801" stroke="black" stroke-width="0.84"/>
                            </svg>
                        </div>
                        <div class='details'>
                        	<div class='value'>${TRANSLATE.box__layout.left}</div>
                            <div class='price-difference'></div>
                        </div>
                    </label>
                    
                    <label class='digi-box-label' data-value='${rightEl.value}' data-name='${rightEl.name}'>
                    	<input type='radio' value='${rightEl.value}' name='${rightEl.name}'>
                        <div class='icon'>
							<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M29.9797 5.70898C30.4326 5.70898 30.8 6.07644 30.8 6.5293V24.6689C30.8 25.1228 30.4317 25.4912 29.9778 25.4912H28.4729V5.70898H29.9797Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M2.0564 5.7085H3.61499V15.4351H2.0564C1.6036 15.435 1.23618 15.0675 1.23608 14.6147V6.52881C1.23612 6.07597 1.60356 5.70853 2.0564 5.7085Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M19.3569 16.1089H28.4634V25.4692C28.4634 25.9231 28.095 26.2915 27.6411 26.2915H19.3569C18.9041 26.2915 18.5367 25.924 18.5366 25.4712V16.9292C18.5367 16.4764 18.9041 16.1089 19.3569 16.1089Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M16.0339 5.70898V15.2725C16.0339 15.7252 15.6673 16.0926 15.2146 16.0928H4.44214C3.98928 16.0927 3.62183 15.7253 3.62183 15.2725V5.70898H16.0339Z" stroke="black" stroke-width="0.727273"/>
                              <path d="M28.3997 5.70898V16.0928H16.8782C16.4253 16.0927 16.0579 15.7253 16.0579 15.2725V5.70898H28.3997Z" stroke="black" stroke-width="0.727273"/>
                              <line x1="3.3335" y1="8.1801" x2="28.6668" y2="8.1801" stroke="black" stroke-width="0.84"/>
                            </svg>
                        </div>
                        <div class='details'>
                        	<div class='value'>${TRANSLATE.box__layout.right}</div>
                            <div class='price-difference'></div>
                        </div>
                    </label>
                `;

                box = `
                	<div class='digi-config__box' box-name='${boxKeyName}'>
                    	<div class='box-title'>
                        	<strong>${TRANSLATE.box__layout.side}</strong>
                        </div>
                        
                        <div class='box-content'>
                        	${content}
                        </div>
                    </div>
                `;

                if (leftEl.checked) {
                    CURRENT_INPUTS_DATA['layout'] = leftEl.value;
                } else if (rightEl.checked) {
                    CURRENT_INPUTS_DATA['layout'] = rightEl.value;
                };
            } else if (attrKeys.mattress.includes(key)) {
                order = 5;
                let existNoMattressOption = false;
                let noMattressOptionValue = '';
                let isNoMattressOptionSelected = false;
                let isRegularMattressOptionSelected = false;

                const firstKey = Object.keys(MATTRESS_TECH_NAME_MAP)[0];
                let mattressPrices = [];

                attr[key].forEach(el => {
                    const foundMattress = MATTRESS_DATA.find(m =>
                        MATTRESS_TECH_NAME_MAP[m.handle][WEB_LANG].includes(el.value)
                    );

                    if (MATTRESS_TECH_NAME_MAP[firstKey][WEB_LANG]) {
                        const matchedKey = Object.keys(MATTRESS_TECH_NAME_MAP).find(key =>
                            MATTRESS_TECH_NAME_MAP[key][WEB_LANG].includes(el.value)
                        );

                        if (matchedKey && matchedKey === 'brak-materaca') {
                            existNoMattressOption = true;
                            noMattressOptionValue = el.value;

                            if (el.checked) {
                                isNoMattressOptionSelected = true;
                            };
                        };
                    } else {
                        //console.log('NO DATA');
                    };


                    let price = foundMattress ? foundMattress.price : null;
                    const parsedPrice = price ? parseFloat(price) : null;
                    if (parsedPrice && parsedPrice > 0) {
                        mattressPrices.push({
                            mattressName: el.value,
                            price: parsedPrice
                        });
                    };

                    if (el.checked) {
                        CURRENT_INPUTS_DATA['mattress'] = el.value;
                        CURRENT_INPUTS_DATA['mattress-price'] = parsedPrice;
                    };
                });

                const lowestMattressPrice = Math.min(
                    ...mattressPrices.map(mattress => mattress.price)
                );
                const chooseMattressBoxData = {
                    name: null,
                    price: null,
                    imageSrc: null
                };

                let noMatressBox = ``;
                if (existNoMattressOption) {
                    noMatressBox = `
                        <div class='digi-mattress-box no-mattress-option ${isNoMattressOptionSelected ? "digi-checked" : ""}' box-name='${boxKeyName}' data-value='${noMattressOptionValue}'>
                            <div class='box-title'>
                                <div class='img'>
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.5" d="M14.0038 24.5C12.5519 24.5 11.1868 24.2245 9.9085 23.6734C8.63042 23.1224 7.51858 22.3745 6.573 21.4299C5.62742 20.4853 4.8789 19.3744 4.32746 18.0973C3.77582 16.8204 3.5 15.4559 3.5 14.0038C3.5 12.5519 3.77553 11.1868 4.32658 9.9085C4.87764 8.63042 5.62547 7.51858 6.57008 6.573C7.51469 5.62742 8.62556 4.8789 9.90267 4.32746C11.1796 3.77582 12.5441 3.5 13.9962 3.5C15.4481 3.5 16.8132 3.77553 18.0915 4.32658C19.3696 4.87764 20.4814 5.62547 21.427 6.57008C22.3726 7.51469 23.1211 8.62556 23.6725 9.90267C24.2242 11.1796 24.5 12.5441 24.5 13.9962C24.5 15.4481 24.2245 16.8132 23.6734 18.0915C23.1224 19.3696 22.3745 20.4814 21.4299 21.427C20.4853 22.3726 19.3744 23.1211 18.0973 23.6725C16.8204 24.2242 15.4559 24.5 14.0038 24.5ZM14 23.3333C15.1392 23.3333 16.2362 23.1332 17.2909 22.7331C18.3457 22.3331 19.3039 21.7524 20.1653 20.991L7.00904 7.83475C6.26257 8.69614 5.68556 9.65426 5.278 10.7091C4.87044 11.7638 4.66667 12.8608 4.66667 14C4.66667 16.6056 5.57083 18.8125 7.37917 20.6208C9.1875 22.4292 11.3944 23.3333 14 23.3333ZM20.991 20.1653C21.7524 19.3039 22.3331 18.3457 22.7331 17.2909C23.1332 16.2362 23.3333 15.1392 23.3333 14C23.3333 11.3944 22.4292 9.1875 20.6208 7.37917C18.8125 5.57083 16.6056 4.66667 14 4.66667C12.8555 4.66667 11.7535 4.86296 10.694 5.25554C9.63424 5.64813 8.68117 6.23263 7.83475 7.00904L20.991 20.1653Z" fill="#787878"/>
                                    </svg>
                                </div>
                                <div class='_title'>
                                    <div class='_mattress-name'>${MATTRESS_TECH_NAME_MAP['brak-materaca'][WEB_LANG][0]}</div>
                                    <div class='_mattress-price'>+0 ${CURRENCY}</div>
                                </div>

                                <div class='icon'>
                                    <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.146893 12.8546C0.10033 12.8081 0.0633873 12.7529 0.0381808 12.6922C0.0129744 12.6315 -1.902e-08 12.5663 -2.18948e-08 12.5006C-2.47695e-08 12.4348 0.0129744 12.3697 0.0381808 12.3089C0.0633872 12.2482 0.10033 12.193 0.146893 12.1466L5.79389 6.50057L0.146893 0.854571C0.100405 0.808084 0.0635287 0.752894 0.0383696 0.692155C0.0132105 0.631415 0.00026124 0.566315 0.000261237 0.500571C0.000261234 0.434828 0.0132105 0.369727 0.0383696 0.308988C0.0635287 0.248248 0.100405 0.193059 0.146893 0.146571C0.193381 0.100083 0.24857 0.0632067 0.309309 0.0380478C0.370049 0.0128889 0.435149 -6.01005e-05 0.500893 -6.01034e-05C0.566637 -6.01063e-05 0.631737 0.0128889 0.692477 0.0380478C0.753216 0.0632066 0.808405 0.100083 0.854893 0.146571L6.85489 6.14657C6.90146 6.19302 6.9384 6.24819 6.96361 6.30894C6.98881 6.36968 7.00179 6.4348 7.00179 6.50057C7.00179 6.56634 6.98881 6.63146 6.96361 6.6922C6.9384 6.75295 6.90146 6.80813 6.85489 6.85457L0.854894 12.8546C0.808448 12.9011 0.753272 12.9381 0.692527 12.9633C0.631782 12.9885 0.566661 13.0015 0.500894 13.0015C0.435126 13.0015 0.370005 12.9885 0.30926 12.9633C0.248515 12.9381 0.193339 12.9011 0.146893 12.8546Z" fill="#353535"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    `;

                };

                const defaultMattressImgSrc = 'https://cdn.shopify.com/s/files/1/0639/3495/5671/files/configurator_mattress_icon_a8297b97-b68e-4534-b453-98ac205e7745.jpg?v=1774609367';

                if (isNoMattressOptionSelected) {
                    chooseMattressBoxData.name = TRANSLATE.box__mattress.choose_mattress;
                    chooseMattressBoxData.price = TRANSLATE.box__mattress.from_PRICE_CURRENCY
                        .replace('{price}', lowestMattressPrice)
                        .replace('{currency}', CURRENCY);
                    chooseMattressBoxData.imageSrc = defaultMattressImgSrc;
                    isRegularMattressOptionSelected = false;
                } else {
                    const selectedMattress = mattressPrices.find(mattress => {
                        return mattress.mattressName === CURRENT_INPUTS_DATA['mattress'];
                    });



                    selectedMattress['imageSrc'] = MATTRESS_DATA.find(m => m.handle.toLowerCase().trim().replaceAll(' ', '-') === CURRENT_INPUTS_DATA['mattress'].toLowerCase().trim().replaceAll(' ', '-')).image;

                    const newMattressName = removeWords(CURRENT_INPUTS_DATA['mattress'], attrKeys.mattress).trim();
                    chooseMattressBoxData.name = newMattressName.charAt(0).toUpperCase() + newMattressName.slice(1);
                    chooseMattressBoxData.price = `+${selectedMattress.price} ${CURRENCY}`;
                    chooseMattressBoxData.imageSrc = selectedMattress.imageSrc;
                    isRegularMattressOptionSelected = true;
                };


                box = `
                    <div class='digi-config__box' box-name='${boxKeyName}'>
                        <div class='box-title'>
                            <strong>
                                ${TRANSLATE.box__mattress.choose_mattress}
                            </strong>
                            <div class='digi-config__aside-panel-open digi-border ${!isRegularMattressOptionSelected ? "digi-hidden" : ""}' for="mattress" custom-open=''>${TRANSLATE.box__mattress.change_mattress}</div>
                        </div>

                        <div class='box-content'>
                            ${noMatressBox}

                            <div class='digi-mattress-box digi-config__aside-panel-open ${isRegularMattressOptionSelected ? "digi-checked" : ""}' for='mattress'>
                                <div class='box-title'>
                                    <div class='img'>
                                        <img src='${chooseMattressBoxData.imageSrc}' data-default-value='${defaultMattressImgSrc}' alt=''>
                                    </div>
                                    <div class='_title'>
                                        <div class='_mattress-name' data-default-value='${TRANSLATE.box__mattress.choose_mattress}'>
                                            ${chooseMattressBoxData.name}
                                        </div>
                                        <div class='_mattress-price' data-default-value='${TRANSLATE.box__mattress.from_PRICE_CURRENCY.replace('{price}', lowestMattressPrice).replace('{currency}', CURRENCY)}'>
                                            ${chooseMattressBoxData.price}
                                        </div>
                                    </div>
                                    <div class='icon'>
                                        <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.146893 12.8546C0.10033 12.8081 0.0633873 12.7529 0.0381808 12.6922C0.0129744 12.6315 -1.902e-08 12.5663 -2.18948e-08 12.5006C-2.47695e-08 12.4348 0.0129744 12.3697 0.0381808 12.3089C0.0633872 12.2482 0.10033 12.193 0.146893 12.1466L5.79389 6.50057L0.146893 0.854571C0.100405 0.808084 0.0635287 0.752894 0.0383696 0.692155C0.0132105 0.631415 0.00026124 0.566315 0.000261237 0.500571C0.000261234 0.434828 0.0132105 0.369727 0.0383696 0.308988C0.0635287 0.248248 0.100405 0.193059 0.146893 0.146571C0.193381 0.100083 0.24857 0.0632067 0.309309 0.0380478C0.370049 0.0128889 0.435149 -6.01005e-05 0.500893 -6.01034e-05C0.566637 -6.01063e-05 0.631737 0.0128889 0.692477 0.0380478C0.753216 0.0632066 0.808405 0.100083 0.854893 0.146571L6.85489 6.14657C6.90146 6.19302 6.9384 6.24819 6.96361 6.30894C6.98881 6.36968 7.00179 6.4348 7.00179 6.50057C7.00179 6.56634 6.98881 6.63146 6.96361 6.6922C6.9384 6.75295 6.90146 6.80813 6.85489 6.85457L0.854894 12.8546C0.808448 12.9011 0.753272 12.9381 0.692527 12.9633C0.631782 12.9885 0.566661 13.0015 0.500894 13.0015C0.435126 13.0015 0.370005 12.9885 0.30926 12.9633C0.248515 12.9381 0.193339 12.9011 0.146893 12.8546Z" fill="#353535"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            } else if (attrKeys.hardness.includes(key)) {
                attr[key].forEach(el => {
                    if (el.checked) {
                        CURRENT_INPUTS_DATA['hardness'] = el.dataset.techName;
                    }
                });
            } else if (attrKeys.pillowFilling.includes(key)) {
                order = 2;

                attr[key].forEach(el => {
                    const valueParts = el.value.split('-');

                    content += `
                        <label class='digi-box-label ${el.checked ? "digi-checked" : ""}' data-value='${el.value}' data-name='${el.name}'>
                            <input type='${el.type}' value='${el.value}' name='${el.name}'>
                            <div class='value'>${valueParts[0].trim()}</div>
                            <div class='desc'>${valueParts[1].trim()}</div>
                        </label>
                    `;

                    if (el.checked) {
                        CURRENT_INPUTS_DATA['pillowFilling'] = el.value;
                    };
                });

                box = `
                	<div class='digi-config__box' box-name='${boxKeyName}'>
                    	<div class='box-title'>
                        	<strong>${TRANSLATE.box__pillow_filling.type_of_filling}</strong>
                            <span class='digi-config__aside-panel-open' for='pillow_filling'>${TRANSLATE.box__pillow_filling.details}</span>
                        </div>
                        
                        <div class='box-content'>
                        	${content}
                        </div>
                    </div>
                `;
            } else if (attrKeys.width.includes(key)) {
                order = 0;
                isTotalWidthSection = true;

                attr[key].forEach(el => {
                    content += `
                        <label class='digi-box-label ${el.checked ? "digi-checked" : ""}' data-value='${el.value}' data-name='${el.name}'>
                            <input type='${el.type}' value='${el.value}' name='${el.name}'>
                            <div class='value'>${el.value} cm</div>
                            <div class='price-difference'></div>
                        </label>
                    `;

                    if (el.checked) {
                        CURRENT_INPUTS_DATA['width'] = el.value;
                    };
                });

                box = `
                	<div class='digi-config__box' box-name='${boxKeyName}'>
                    	<div class='box-title'>
                        	<strong>${TRANSLATE.box__width.width}</strong>
                            <span class='digi-config__aside-panel-open' for='width'>${TRANSLATE.box__width.full_size}</span>
                        </div>
                        
                        <div class='box-content'>
                        	${content}
                        </div>
                    </div>
                `;
            };

            keysForEvents.push(key);
            FRONT_CONTENT_DATA.push({
                order: order,
                content: box
            });
        });

        const __customSections = (CSname) => {
            let box = ``;
            let content = ``;

            if (CSname === 'total-width') {
                if (isTotalWidthSection) return;

                const normalProductData = CUSTOM_TOTAL_WIDTH?.normal?.product_data || null;
                const miniProductData = CUSTOM_TOTAL_WIDTH?.mini?.product_data || null;

                const customIcons = {
                    'default': {
                        src: ``
                    },
                    'sofa-mellven': {
                        src: `
                            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.56055 17.0537H4.32715V26.8496H3.56055C2.65187 26.8496 1.91504 26.1128 1.91504 25.2041V18.6992C1.91504 17.7905 2.65187 17.0537 3.56055 17.0537Z" stroke="black" stroke-width="0.709381"/>
            <path d="M41.7207 17.0537H40.9541V26.8496H41.7207C42.6294 26.8496 43.3662 26.1128 43.3662 25.2041V18.6992C43.3662 17.7905 42.6294 17.0537 41.7207 17.0537Z" stroke="black" stroke-width="0.709381"/>
            <mask id="path-3-inside-1_2340_2423" fill="white">
                <path d="M4 17.1992C4 16.9231 4.22386 16.6992 4.5 16.6992H12V26.5097C12 27.1666 11.4674 27.6992 10.8105 27.6992H5.18954C4.53257 27.6992 4 27.1666 4 26.5097V17.1992Z"/>
            </mask>
            <path d="M4 17.1992C4 16.9231 4.22386 16.6992 4.5 16.6992H12V26.5097C12 27.1666 11.4674 27.6992 10.8105 27.6992H5.18954C4.53257 27.6992 4 27.1666 4 26.5097V17.1992Z" stroke="black" stroke-width="1.41876" mask="url(#path-3-inside-1_2340_2423)"/>
            <mask id="path-4-inside-2_2340_2423" fill="white">
                <path d="M11.2998 17.1992C11.2998 16.9231 11.5237 16.6992 11.7998 16.6992H19.2998V26.5097C19.2998 27.1666 18.7672 27.6992 18.1103 27.6992H12.4893C11.8324 27.6992 11.2998 27.1666 11.2998 26.5097V17.1992Z"/>
            </mask>
            <path d="M11.2998 17.1992C11.2998 16.9231 11.5237 16.6992 11.7998 16.6992H19.2998V26.5097C19.2998 27.1666 18.7672 27.6992 18.1103 27.6992H12.4893C11.8324 27.6992 11.2998 27.1666 11.2998 26.5097V17.1992Z" stroke="black" stroke-width="1.41876" mask="url(#path-4-inside-2_2340_2423)"/>
            <mask id="path-5-inside-3_2340_2423" fill="white">
                <path d="M18.6001 17.1992C18.6001 16.9231 18.824 16.6992 19.1001 16.6992H26.6001V26.5097C26.6001 27.1666 26.0675 27.6992 25.4106 27.6992H19.7896C19.1327 27.6992 18.6001 27.1666 18.6001 26.5097V17.1992Z"/>
            </mask>
            <path d="M18.6001 17.1992C18.6001 16.9231 18.824 16.6992 19.1001 16.6992H26.6001V26.5097C26.6001 27.1666 26.0675 27.6992 25.4106 27.6992H19.7896C19.1327 27.6992 18.6001 27.1666 18.6001 26.5097V17.1992Z" stroke="black" stroke-width="1.41876" mask="url(#path-5-inside-3_2340_2423)"/>
            <mask id="path-6-inside-4_2340_2423" fill="white">
                <path d="M25.8999 17.1992C25.8999 16.9231 26.1238 16.6992 26.3999 16.6992H33.8999V26.5097C33.8999 27.1666 33.3673 27.6992 32.7104 27.6992H27.0894C26.4325 27.6992 25.8999 27.1666 25.8999 26.5097V17.1992Z"/>
            </mask>
            <path d="M25.8999 17.1992C25.8999 16.9231 26.1238 16.6992 26.3999 16.6992H33.8999V26.5097C33.8999 27.1666 33.3673 27.6992 32.7104 27.6992H27.0894C26.4325 27.6992 25.8999 27.1666 25.8999 26.5097V17.1992Z" stroke="black" stroke-width="1.41876" mask="url(#path-6-inside-4_2340_2423)"/>
            <mask id="path-7-inside-5_2340_2423" fill="white">
                <path d="M33.2002 17.1992C33.2002 16.9231 33.4241 16.6992 33.7002 16.6992H41.2002V26.5097C41.2002 27.1666 40.6676 27.6992 40.0107 27.6992H34.3897C33.7328 27.6992 33.2002 27.1666 33.2002 26.5097V17.1992Z"/>
            </mask>
            <path d="M33.2002 17.1992C33.2002 16.9231 33.4241 16.6992 33.7002 16.6992H41.2002V26.5097C41.2002 27.1666 40.6676 27.6992 40.0107 27.6992H34.3897C33.7328 27.6992 33.2002 27.1666 33.2002 26.5097V17.1992Z" stroke="black" stroke-width="1.41876" mask="url(#path-7-inside-5_2340_2423)"/>
            <line x1="4.5" y1="21.1453" x2="40.5" y2="21.1453" stroke="black" stroke-width="0.709381"/>
            </svg>
                        `
                    },
                    'sofa-mini-mellven': {
                        src: `
                            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.2002 17.0537H7.9668V26.8496H7.2002C6.29152 26.8496 5.55469 26.1128 5.55469 25.2041V18.6992C5.55469 17.7905 6.29152 17.0537 7.2002 17.0537Z" stroke="black" stroke-width="0.709381"/>
            <path d="M37.9609 17.0537H37.1943V26.8496H37.9609C38.8696 26.8496 39.6064 26.1128 39.6064 25.2041V18.6992C39.6064 17.7905 38.8696 17.0537 37.9609 17.0537Z" stroke="black" stroke-width="0.709381"/>
            <mask id="path-3-inside-1_2340_2440" fill="white">
                <path d="M7.63965 17.1992C7.63965 16.9231 7.86351 16.6992 8.13965 16.6992H15.6396V26.5097C15.6396 27.1666 15.1071 27.6992 14.4501 27.6992H8.82919C8.17222 27.6992 7.63965 27.1666 7.63965 26.5097V17.1992Z"/>
            </mask>
            <path d="M7.63965 17.1992C7.63965 16.9231 7.86351 16.6992 8.13965 16.6992H15.6396V26.5097C15.6396 27.1666 15.1071 27.6992 14.4501 27.6992H8.82919C8.17222 27.6992 7.63965 27.1666 7.63965 26.5097V17.1992Z" stroke="black" stroke-width="1.41876" mask="url(#path-3-inside-1_2340_2440)"/>
            <mask id="path-4-inside-2_2340_2440" fill="white">
                <path d="M14.9395 17.1992C14.9395 16.9231 15.1633 16.6992 15.4395 16.6992H22.9395V26.5097C22.9395 27.1666 22.4069 27.6992 21.7499 27.6992H16.129C15.472 27.6992 14.9395 27.1666 14.9395 26.5097V17.1992Z"/>
            </mask>
            <path d="M14.9395 17.1992C14.9395 16.9231 15.1633 16.6992 15.4395 16.6992H22.9395V26.5097C22.9395 27.1666 22.4069 27.6992 21.7499 27.6992H16.129C15.472 27.6992 14.9395 27.1666 14.9395 26.5097V17.1992Z" stroke="black" stroke-width="1.41876" mask="url(#path-4-inside-2_2340_2440)"/>
            <mask id="path-5-inside-3_2340_2440" fill="white">
                <path d="M22.2397 17.1992C22.2397 16.9231 22.4636 16.6992 22.7397 16.6992H30.2397V26.5097C30.2397 27.1666 29.7072 27.6992 29.0502 27.6992H23.4293C22.7723 27.6992 22.2397 27.1666 22.2397 26.5097V17.1992Z"/>
            </mask>
            <path d="M22.2397 17.1992C22.2397 16.9231 22.4636 16.6992 22.7397 16.6992H30.2397V26.5097C30.2397 27.1666 29.7072 27.6992 29.0502 27.6992H23.4293C22.7723 27.6992 22.2397 27.1666 22.2397 26.5097V17.1992Z" stroke="black" stroke-width="1.41876" mask="url(#path-5-inside-3_2340_2440)"/>
            <mask id="path-6-inside-4_2340_2440" fill="white">
                <path d="M29.5396 17.1992C29.5396 16.9231 29.7634 16.6992 30.0396 16.6992H37.5396V26.5097C37.5396 27.1666 37.007 27.6992 36.35 27.6992H30.7291C30.0721 27.6992 29.5396 27.1666 29.5396 26.5097V17.1992Z"/>
            </mask>
            <path d="M29.5396 17.1992C29.5396 16.9231 29.7634 16.6992 30.0396 16.6992H37.5396V26.5097C37.5396 27.1666 37.007 27.6992 36.35 27.6992H30.7291C30.0721 27.6992 29.5396 27.1666 29.5396 26.5097V17.1992Z" stroke="black" stroke-width="1.41876" mask="url(#path-6-inside-4_2340_2440)"/>
            <line x1="7.83984" y1="21.1453" x2="36.8398" y2="21.1453" stroke="black" stroke-width="0.709381"/>
            </svg>
                        `
                    },
                    'sofa-kloo': {
                        src: `
                            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.75 17.3799H4.32715V27.1758H2.75C2.28898 27.1757 1.91506 26.8018 1.91504 26.3408V18.2148C1.91508 17.7538 2.28899 17.3799 2.75 17.3799Z" stroke="black" stroke-width="0.709381"/>
            <path d="M43.3594 17.3799H41.7822V27.1758H43.3594C43.8204 27.1757 44.1943 26.8018 44.1943 26.3408V18.2148C44.1943 17.7538 43.8204 17.3799 43.3594 17.3799Z" stroke="black" stroke-width="0.709381"/>
            <path d="M16.8223 17.3799V27.002C16.822 27.4628 16.4482 27.8359 15.9873 27.8359H5.16211C4.70124 27.8359 4.32741 27.4628 4.32715 27.002V17.3799H16.8223Z" stroke="black" stroke-width="0.709381"/>
            <path d="M29.2368 17.3799V26.998C29.2368 27.4607 28.8616 27.8359 28.3989 27.8359H17.647C17.1861 27.8359 16.8123 27.4628 16.812 27.002V17.3799H29.2368Z" stroke="black" stroke-width="0.709381"/>
            <path d="M41.7222 17.3799V26.998C41.7222 27.4607 41.347 27.8359 40.8843 27.8359H30.1323C29.6715 27.8359 29.2976 27.4628 29.2974 27.002V17.3799H41.7222Z" stroke="black" stroke-width="0.709381"/>
            <line x1="4.25635" y1="20.9266" x2="41.4279" y2="20.9266" stroke="black" stroke-width="0.709381"/>
            </svg>
                        `
                    },
                    'sofa-mini-kloo': {
                        src: `
                            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.29785 17.3955H9.89648V27.334H8.29785C7.83726 27.334 7.4639 26.9606 7.46387 26.5V18.2295C7.46387 17.7689 7.83724 17.3955 8.29785 17.3955Z" stroke="black" stroke-width="0.739685"/>
            <path d="M36.7739 17.3955H35.1753V27.334H36.7739C37.2345 27.334 37.6079 26.9606 37.6079 26.5V18.2295C37.6079 17.7689 37.2345 17.3955 36.7739 17.3955Z" stroke="black" stroke-width="0.739685"/>
            <path d="M22.5835 17.3955V27.1719C22.5833 27.6323 22.21 28.0059 21.7495 28.0059H10.7349C10.2744 28.0059 9.90106 27.6323 9.90088 27.1719V17.3955H22.5835Z" stroke="black" stroke-width="0.739685"/>
            <path d="M35.2163 17.3955V27.1689C35.2161 27.631 34.8415 28.0059 34.3794 28.0059H23.4399C22.9794 28.0059 22.6061 27.6323 22.606 27.1719V17.3955H35.2163Z" stroke="black" stroke-width="0.739685"/>
            <line x1="10.2432" y1="20.5914" x2="35.3308" y2="20.5914" stroke="black" stroke-width="0.854336"/>
            </svg>
                        `
                    },
                    'sofa-moodu': {
                        src: `
                            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.75098 17.3799H4.32812V27.1758H2.75098C2.28995 27.1757 1.91604 26.8018 1.91602 26.3408V18.2148C1.91606 17.7538 2.28997 17.3799 2.75098 17.3799Z" stroke="black" stroke-width="0.709381"/>
  <path d="M43.3594 17.3799H41.7822V27.1758H43.3594C43.8204 27.1757 44.1943 26.8018 44.1943 26.3408V18.2148C44.1943 17.7538 43.8204 17.3799 43.3594 17.3799Z" stroke="black" stroke-width="0.709381"/>
  <path d="M16.8223 17.3799V27.002C16.822 27.4628 16.4482 27.8359 15.9873 27.8359H5.16211C4.70124 27.8359 4.32741 27.4628 4.32715 27.002V17.3799H16.8223Z" stroke="black" stroke-width="0.709381"/>
  <path d="M29.2373 17.3799V26.998C29.2373 27.4607 28.8621 27.8359 28.3994 27.8359H17.6475C17.1866 27.8359 16.8128 27.4628 16.8125 27.002V17.3799H29.2373Z" stroke="black" stroke-width="0.709381"/>
  <path d="M41.7227 17.3799V26.998C41.7227 27.4607 41.3475 27.8359 40.8848 27.8359H30.1328C29.6719 27.8359 29.2981 27.4628 29.2979 27.002V17.3799H41.7227Z" stroke="black" stroke-width="0.709381"/>
  <line x1="4.25684" y1="20.927" x2="41.4284" y2="20.927" stroke="black" stroke-width="0.709381"/>
</svg>
                        `
                    },
                    'sofa-mini-moodu': {
                        src: `
                            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.29785 17.3955H9.89648V27.334H8.29785C7.83726 27.334 7.4639 26.9606 7.46387 26.5V18.2295C7.46387 17.7689 7.83724 17.3955 8.29785 17.3955Z" stroke="black" stroke-width="0.739685"/>
  <path d="M36.7744 17.3955H35.1758V27.334H36.7744C37.235 27.334 37.6084 26.9606 37.6084 26.5V18.2295C37.6084 17.7689 37.235 17.3955 36.7744 17.3955Z" stroke="black" stroke-width="0.739685"/>
  <path d="M22.584 17.3955V27.1719C22.5838 27.6323 22.2105 28.0059 21.75 28.0059H10.7354C10.2749 28.0059 9.90155 27.6323 9.90137 27.1719V17.3955H22.584Z" stroke="black" stroke-width="0.739685"/>
  <path d="M35.2168 17.3955V27.1689C35.2165 27.631 34.842 28.0059 34.3799 28.0059H23.4404C22.9799 28.0059 22.6066 27.6323 22.6064 27.1719V17.3955H35.2168Z" stroke="black" stroke-width="0.739685"/>
  <line x1="10.2432" y1="20.5914" x2="35.3308" y2="20.5914" stroke="black" stroke-width="0.854336"/>
</svg>
                        `
                    },
                    'naroznik-kloo-duzy': {
                        src: `
                            <svg width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M43.8887 12.356C44.376 12.356 44.7714 12.7505 44.7715 13.2378V32.2026C44.7714 32.691 44.3751 33.0864 43.8867 33.0864H42.2891V12.356H43.8887Z" stroke="black" stroke-width="0.71"/>
  <path d="M1.65527 12.3555H3.30957V22.5732H1.65527C1.16798 22.5732 0.773438 22.1777 0.773438 21.6904V13.2373C0.773523 12.7501 1.16803 12.3556 1.65527 12.3555Z" stroke="black" stroke-width="0.71"/>
  <path d="M29.334 12.356V22.3784C29.334 22.8658 28.9385 23.2612 28.4512 23.2612H17.1895C16.7022 23.2611 16.3076 22.8657 16.3076 22.3784V12.356H29.334Z" stroke="black" stroke-width="0.71"/>
  <path d="M16.3096 12.356V22.3784C16.3096 22.8658 15.9141 23.2612 15.4268 23.2612H4.16504C3.67774 23.2611 3.2832 22.8657 3.2832 22.3784V12.356H16.3096Z" stroke="black" stroke-width="0.71"/>
  <path d="M42.1953 12.3608V33.0825H30.1963C29.709 33.0824 29.3145 32.687 29.3145 32.1997V12.3608H42.1953Z" stroke="black" stroke-width="0.71"/>
  <line x1="3.13672" y1="15.0478" x2="42.6549" y2="15.0478" stroke="black" stroke-width="0.71"/>
</svg>
                        `
                    },
                    'naroznik-mini-kloo': {
                        src: `
                            <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M37.457 12.356C38.1801 12.356 38.7664 12.9415 38.7666 13.6646V31.8159C38.7666 32.5404 38.1796 33.1283 37.4551 33.1284H36.2783V12.356H37.457Z" stroke="black" stroke-width="0.71"/>
  <path d="M8.66406 12.3555H9.89746V22.5938H8.66406C7.9412 22.5935 7.35572 22.008 7.35547 21.2852V13.6641C7.35572 12.9412 7.9412 12.3557 8.66406 12.3555Z" stroke="black" stroke-width="0.71"/>
  <path d="M23.0898 12.356V21.9741C23.0897 22.6972 22.5034 23.2837 21.7803 23.2837H11.3457C10.6228 23.2834 10.0373 22.6971 10.0371 21.9741V12.356H23.0898Z" stroke="black" stroke-width="0.71"/>
  <path d="M36.1855 12.3604V33.123H24.5879C23.8649 33.1228 23.2793 32.5366 23.2793 31.8135V12.3604H36.1855Z" stroke="black" stroke-width="0.71"/>
  <line x1="9.9707" y1="15.0542" x2="36.5066" y2="15.0542" stroke="black" stroke-width="0.71"/>
</svg>
                        `
                    },
                    'naroznik-mellven': {
                        src: `
                            <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 14.3545H3.7666V24.1504H3C2.09132 24.1504 1.35449 23.4136 1.35449 22.5049V16C1.35449 15.0913 2.09132 14.3545 3 14.3545Z" stroke="black" stroke-width="0.709381"/>
  <path d="M41.1602 14.3545H40.3936V24.1504H41.1602C42.0688 24.1504 42.8057 23.4136 42.8057 22.5049V16C42.8057 15.0913 42.0688 14.3545 41.1602 14.3545Z" stroke="black" stroke-width="0.709381"/>
  <mask id="path-3-inside-1_3089_3392" fill="white">
    <path d="M3.43945 14.5C3.43945 14.2239 3.66331 14 3.93945 14H11.4395V23.8105C11.4395 24.4674 10.9069 25 10.2499 25H4.62899C3.97203 25 3.43945 24.4674 3.43945 23.8105V14.5Z"/>
  </mask>
  <path d="M3.43945 14.5C3.43945 14.2239 3.66331 14 3.93945 14H11.4395V23.8105C11.4395 24.4674 10.9069 25 10.2499 25H4.62899C3.97203 25 3.43945 24.4674 3.43945 23.8105V14.5Z" stroke="black" stroke-width="1.41876" mask="url(#path-3-inside-1_3089_3392)"/>
  <mask id="path-4-inside-2_3089_3392" fill="white">
    <path d="M10.7393 14.5C10.7393 14.2239 10.9631 14 11.2393 14H18.7393V23.8105C18.7393 24.4674 18.2067 25 17.5497 25H11.9288C11.2718 25 10.7393 24.4674 10.7393 23.8105V14.5Z"/>
  </mask>
  <path d="M10.7393 14.5C10.7393 14.2239 10.9631 14 11.2393 14H18.7393V23.8105C18.7393 24.4674 18.2067 25 17.5497 25H11.9288C11.2718 25 10.7393 24.4674 10.7393 23.8105V14.5Z" stroke="black" stroke-width="1.41876" mask="url(#path-4-inside-2_3089_3392)"/>
  <mask id="path-5-inside-3_3089_3392" fill="white">
    <path d="M18.0391 14.5C18.0391 14.2239 18.2629 14 18.5391 14H26.0391V23.8105C26.0391 24.4674 25.5065 25 24.8495 25H19.2286C18.5716 25 18.0391 24.4674 18.0391 23.8105V14.5Z"/>
  </mask>
  <path d="M18.0391 14.5C18.0391 14.2239 18.2629 14 18.5391 14H26.0391V23.8105C26.0391 24.4674 25.5065 25 24.8495 25H19.2286C18.5716 25 18.0391 24.4674 18.0391 23.8105V14.5Z" stroke="black" stroke-width="1.41876" mask="url(#path-5-inside-3_3089_3392)"/>
  <mask id="path-6-inside-4_3089_3392" fill="white">
    <path d="M25.3398 14.5C25.3398 14.2239 25.5637 14 25.8398 14H33.3398V30.0605C33.3398 30.7174 32.8073 31.25 32.1503 31.25H26.5294C25.8724 31.25 25.3398 30.7174 25.3398 30.0605V14.5Z"/>
  </mask>
  <path d="M25.3398 14.5C25.3398 14.2239 25.5637 14 25.8398 14H33.3398V30.0605C33.3398 30.7174 32.8073 31.25 32.1503 31.25H26.5294C25.8724 31.25 25.3398 30.7174 25.3398 30.0605V14.5Z" stroke="black" stroke-width="1.41876" mask="url(#path-6-inside-4_3089_3392)"/>
  <mask id="path-7-inside-5_3089_3392" fill="white">
    <path d="M32.6895 14.5C32.6895 14.2239 32.9133 14 33.1895 14H40.6895V30.0605C40.6895 30.7174 40.1569 31.25 39.4999 31.25H33.879C33.222 31.25 32.6895 30.7174 32.6895 30.0605V14.5Z"/>
  </mask>
  <path d="M32.6895 14.5C32.6895 14.2239 32.9133 14 33.1895 14H40.6895V30.0605C40.6895 30.7174 40.1569 31.25 39.4999 31.25H33.879C33.222 31.25 32.6895 30.7174 32.6895 30.0605V14.5Z" stroke="black" stroke-width="1.41876" mask="url(#path-7-inside-5_3089_3392)"/>
  <line x1="3.93945" y1="18.4451" x2="40.2395" y2="18.4451" stroke="black" stroke-width="0.709381"/>
  <line x1="25.4395" y1="24.6453" x2="40.4395" y2="24.6453" stroke="black" stroke-width="0.709381"/>
</svg>
                        `
                    },
                    'naroznik-moodu': {
                        src: `
                            <svg width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M43.8887 12.356C44.376 12.356 44.7714 12.7505 44.7715 13.2378V32.2026C44.7714 32.691 44.3751 33.0864 43.8867 33.0864H42.2891V12.356H43.8887Z" stroke="black" stroke-width="0.71"/>
  <path d="M1.65527 12.3555H3.30957V22.5732H1.65527C1.16798 22.5732 0.773438 22.1777 0.773438 21.6904V13.2373C0.773523 12.7501 1.16803 12.3556 1.65527 12.3555Z" stroke="black" stroke-width="0.71"/>
  <path d="M29.334 12.356V22.3784C29.334 22.8658 28.9385 23.2612 28.4512 23.2612H17.1895C16.7022 23.2611 16.3076 22.8657 16.3076 22.3784V12.356H29.334Z" stroke="black" stroke-width="0.71"/>
  <path d="M16.3096 12.356V22.3784C16.3096 22.8658 15.9141 23.2612 15.4268 23.2612H4.16504C3.67774 23.2611 3.2832 22.8657 3.2832 22.3784V12.356H16.3096Z" stroke="black" stroke-width="0.71"/>
  <path d="M42.1953 12.3608V33.0825H30.1963C29.709 33.0824 29.3145 32.687 29.3145 32.1997V12.3608H42.1953Z" stroke="black" stroke-width="0.71"/>
  <line x1="3.13672" y1="15.0478" x2="42.6549" y2="15.0478" stroke="black" stroke-width="0.71"/>
</svg>
                        `
                    },
                    'naroznik-mini-moodu': {
                        src: `
                            <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M37.457 12.356C38.1801 12.356 38.7664 12.9415 38.7666 13.6646V31.8159C38.7666 32.5404 38.1796 33.1283 37.4551 33.1284H36.2783V12.356H37.457Z" stroke="black" stroke-width="0.71"/>
  <path d="M8.66406 12.3555H9.89746V22.5938H8.66406C7.9412 22.5935 7.35572 22.008 7.35547 21.2852V13.6641C7.35572 12.9412 7.9412 12.3557 8.66406 12.3555Z" stroke="black" stroke-width="0.71"/>
  <path d="M23.0898 12.356V21.9741C23.0897 22.6972 22.5034 23.2837 21.7803 23.2837H11.3457C10.6228 23.2834 10.0373 22.6971 10.0371 21.9741V12.356H23.0898Z" stroke="black" stroke-width="0.71"/>
  <path d="M36.1855 12.3604V33.123H24.5879C23.8649 33.1228 23.2793 32.5366 23.2793 31.8135V12.3604H36.1855Z" stroke="black" stroke-width="0.71"/>
  <line x1="9.9707" y1="15.0542" x2="36.5066" y2="15.0542" stroke="black" stroke-width="0.71"/>
</svg>
                        `
                    }
                };

                const urlParams = new URLSearchParams(window.location.search);
                const currentVariantID = urlParams.get('variant');

                if (!currentVariantID) return;

                const currentVariantIDString = currentVariantID.toString().trim();

                const getCustomIcon = (handle) => {
                    return customIcons[handle] || customIcons['default'];
                };

                const getTotalWidthValue = (productData) => {
                    return `${productData.total_width.value} ${productData.total_width.unit}`;
                };

                const isValidProductData = (productData) => {
                    return !!productData &&
                        !!productData.total_width &&
                        !!productData.variants?.length;
                };

                const normal = {
                    productData: normalProductData,
                    isAvailable: isValidProductData(normalProductData),
                    variantData: null,
                    matchedVariantData: null,
                    isCurrent: false,
                    totalWidth: '',
                    customIcon: customIcons['default'],
                    html: ''
                };

                const mini = {
                    productData: miniProductData,
                    isAvailable: isValidProductData(miniProductData),
                    variantData: null,
                    matchedVariantData: null,
                    isCurrent: false,
                    totalWidth: '',
                    customIcon: customIcons['default'],
                    html: ''
                };

                if (!normal.isAvailable) return;

                normal.variantData = normal.productData.variants.find(obj =>
                    obj.id.toString().trim() === currentVariantIDString
                );

                normal.isCurrent = !!normal.variantData;
                normal.totalWidth = getTotalWidthValue(normal.productData);
                normal.customIcon = getCustomIcon(normal.productData.handle);

                if (mini.isAvailable) {
                    mini.variantData = mini.productData.variants.find(obj =>
                        obj.id.toString().trim() === currentVariantIDString
                    );

                    mini.isCurrent = !!mini.variantData;
                    mini.totalWidth = getTotalWidthValue(mini.productData);
                    mini.customIcon = getCustomIcon(mini.productData.handle);
                }

                if (normal.isCurrent) {
                    normal.matchedVariantData = normal.variantData;

                    if (mini.isAvailable) {
                        mini.matchedVariantData = mini.productData.variants.find(obj =>
                            obj.title.trim() === normal.variantData.title.trim()
                        );
                    }
                }

                if (mini.isCurrent) {
                    mini.matchedVariantData = mini.variantData;

                    normal.matchedVariantData = normal.productData.variants.find(obj =>
                        obj.title.trim() === mini.variantData.title.trim()
                    );
                }

                if (!mini.isAvailable) {
                    if (!normal.isCurrent) return;

                    normal.html = `
                        <label 
                            class='digi-box-label digi-checked' 
                            data-value='${normal.totalWidth}' 
                            data-name='custom-total-width'
                            data-product-handle='${normal.productData.handle}'
                            data-variant-id='${normal.variantData.id}'
                            data-variant-type='normal'
                        >
                            <input 
                                type='radio' 
                                value='${normal.totalWidth}'
                                data-size='${normal.productData.total_width.value}'
                                name='custom-total-width'
                                checked
                            >
                            <div class='icon'>${normal.customIcon.src}</div>
                            <div class='details'>
                                <div class='value'>${normal.totalWidth}</div>
                                <div class='price-difference'></div>
                            </div>
                        </label>
                    `;

                    content = `${normal.html}`;
                };

                if (mini.isAvailable) {
                    if (!normal.isCurrent && !mini.isCurrent) return;

                    if (!normal.matchedVariantData) return;
                    if (!mini.matchedVariantData) return;

                    _custom_handle.current = normal.isCurrent
                        ? normal.productData.handle
                        : mini.productData.handle;

                    _custom_handle.new = normal.isCurrent
                        ? mini.productData.handle
                        : normal.productData.handle;

                    newVariantID = normal.isCurrent
                        ? mini.matchedVariantData.id
                        : normal.matchedVariantData.id;

                    normal.html = `
                        <label 
                            class='digi-box-label ${normal.isCurrent ? 'digi-checked' : 'digi-custom-link'}' 
                            data-value='${normal.totalWidth}' 
                            data-name='custom-total-width'
                            data-product-handle='${normal.productData.handle}'
                            data-variant-id='${normal.matchedVariantData.id}'
                            data-variant-type='normal'
                        >
                            <input 
                                type='radio' 
                                value='${normal.totalWidth}'
                                data-size='${normal.productData.total_width.value}'
                                name='custom-total-width'
                                ${normal.isCurrent ? 'checked' : ''}
                            >
                            <div class='icon'>${normal.customIcon.src}</div>
                            <div class='details'>
                                <div class='value'>${normal.totalWidth}</div>
                                <div class='price-difference'></div>
                            </div>
                        </label>
                    `;

                    mini.html = `
                        <label 
                            class='digi-box-label ${mini.isCurrent ? 'digi-checked' : 'digi-custom-link'}' 
                            data-value='${mini.totalWidth}' 
                            data-name='custom-total-width'
                            data-product-handle='${mini.productData.handle}'
                            data-variant-id='${mini.matchedVariantData.id}'
                            data-variant-type='mini'
                        >
                            <input 
                                type='radio' 
                                value='${mini.totalWidth}'
                                data-size='${mini.productData.total_width.value}'
                                name='custom-total-width'
                                ${mini.isCurrent ? 'checked' : ''}
                            >
                            <div class='icon'>${mini.customIcon.src}</div>
                            <div class='details'>
                                <div class='value'>${mini.totalWidth}</div>
                                <div class='price-difference'></div>
                            </div>
                        </label>
                    `;

                    content = `
                        ${normal.html}
                        ${mini.html}
                    `;
                };

                if (!content) return;

                order = 0;

                box = `
                    <div class='digi-config__box' box-name='custom-total-width'>
                        <div class='box-title'>
                            <strong>${TRANSLATE.box__width.width}</strong>
                            <span class='digi-config__aside-panel-open' for='custom-total-width'>${TRANSLATE.box__width.full_size}</span>
                        </div>
                        
                        <div class='box-content'>
                            ${content}
                        </div>
                    </div>
                `;

                if (!normal.isCurrent && !mini.isCurrent) return;

                if (normal.isCurrent) {
                    CURRENT_INPUTS_DATA['width'] = normal.totalWidth;
                } else if (mini.isCurrent) {
                    CURRENT_INPUTS_DATA['width'] = mini.totalWidth;
                };
            }


            keysForEvents.push('custom-total-width');
            FRONT_CONTENT_DATA.push({
                order: order,
                content: box
            });
        };

        __customSections('total-width');
        __customCSS();

        let FRONT_CONTENT = ``;
        FRONT_CONTENT_DATA.sort((a, b) => a.order - b.order);
        FRONT_CONTENT_DATA.forEach(obj => {
            FRONT_CONTENT += obj.content;
        });

        document.querySelector('#digi-new-configurator')?.remove();
        productParams.insertAdjacentHTML('beforebegin', `
        	<div id='digi-new-configurator'>
            	${FRONT_CONTENT}
            </div>
        `);

        productParams.classList.add('digi-hidden');

        const digiConfigurator = document.querySelector('#digi-new-configurator');

        const __priceDifferenceUpdate = (customBox) => {
            const setPriceDifferenceText = (label, value) => {
                const target = label.querySelector('.price-difference');
                if (!target) return;

                const numberValue = Number(value);

                if (value === null || Number.isNaN(numberValue)) {
                    target.innerHTML = '';
                    return;
                }

                const prefix = numberValue >= 0 ? '+' : '';
                target.innerHTML = `${prefix}${formatPrice(numberValue)} ${CURRENCY}`;
            };

            if (customBox === 'custom-total-width') {
                const localBox = digiConfigurator.querySelector('.digi-config__box[box-name="custom-total-width"]');
                if (!localBox) return;

                const inputLabels = Array.from(localBox.querySelectorAll('.box-content label.digi-box-label'));
                if (!inputLabels.length) return;

                const normalProductData = CUSTOM_TOTAL_WIDTH?.normal?.product_data || null;
                const miniProductData = CUSTOM_TOTAL_WIDTH?.mini?.product_data || null;

                const isValidProductData = (productData) => {
                    return !!productData &&
                        !!productData.variants?.length &&
                        !!productData.total_width;
                };

                const hasNormalData = isValidProductData(normalProductData);
                const hasMiniData = isValidProductData(miniProductData);

                if (!hasNormalData) return;

                const urlParams = new URLSearchParams(window.location.search);
                const currentVariantID = urlParams.get('variant');

                if (!currentVariantID) return;

                const currentVariantIDString = currentVariantID.toString().trim();

                const normalLabel = inputLabels.find(label => label.dataset.variantType === 'normal');
                const miniLabel = inputLabels.find(label => label.dataset.variantType === 'mini');

                if (!hasMiniData) {
                    if (!normalLabel) return;

                    const currentNormalVariantData = normalProductData.variants.find(obj =>
                        obj.id.toString().trim() === currentVariantIDString
                    );

                    if (!currentNormalVariantData) return;

                    setPriceDifferenceText(normalLabel, 0);

                    return;
                }

                const isCurrentNormal = _custom_handle.current === normalProductData.handle;
                const isCurrentMini = _custom_handle.current === miniProductData.handle;

                if (!isCurrentNormal && !isCurrentMini) return;

                let currentVariantData = null;
                let targetVariantData = null;

                if (isCurrentNormal) {
                    currentVariantData = normalProductData.variants.find(obj =>
                        obj.id.toString().trim() === currentVariantIDString
                    );

                    if (!currentVariantData) return;

                    targetVariantData = miniProductData.variants.find(obj =>
                        obj.title.trim() === currentVariantData.title.trim()
                    );

                    if (!targetVariantData) return;

                    if (normalLabel) {
                        setPriceDifferenceText(normalLabel, 0);
                    }

                    if (!miniLabel) return;

                    if (!currentVariantData?.price) return;
                    if (!targetVariantData?.price) return;

                    const priceDifferenceValue = (targetVariantData.price - currentVariantData.price) / 100;

                    setPriceDifferenceText(miniLabel, priceDifferenceValue.toFixed(2));

                    return;
                }

                if (isCurrentMini) {
                    currentVariantData = miniProductData.variants.find(obj =>
                        obj.id.toString().trim() === currentVariantIDString
                    );

                    if (!currentVariantData) return;

                    targetVariantData = normalProductData.variants.find(obj =>
                        obj.title.trim() === currentVariantData.title.trim()
                    );

                    if (!targetVariantData) return;

                    if (miniLabel) {
                        setPriceDifferenceText(miniLabel, 0);
                    }

                    if (!normalLabel) return;

                    if (!currentVariantData?.price) return;
                    if (!targetVariantData?.price) return;

                    const priceDifferenceValue = (targetVariantData.price - currentVariantData.price) / 100;

                    setPriceDifferenceText(normalLabel, priceDifferenceValue.toFixed(2));

                    return;
                }

                return;
            }


            const inputData = {
                size: CURRENT_INPUTS_DATA?.sleepSize || '',
                material: MATERIAL_GROUPS[CURRENT_INPUTS_DATA?.material] || '',
                mattress: CURRENT_INPUTS_DATA?.mattress || '',
                sleepFunction: CURRENT_INPUTS_DATA?.sleepFunction || '',
                width: CURRENT_INPUTS_DATA?.width || ''
            };

            const variants = meta?.product?.variants || [];
            if (!variants.length) return;

            let boxName = '';
            let currentMatchData = null;

            if (inputData.size && inputData.material && inputData.mattress) {
                boxName = 'sleepSize';
                currentMatchData = {
                    part1: inputData.size,
                    part2: inputData.material,
                    part3: inputData.mattress
                };
            } else if (!inputData.size && inputData.sleepFunction && inputData.material) {
                boxName = 'sleepFunction';
                currentMatchData = {
                    part1: inputData.material,
                    part2: inputData.sleepFunction,
                    part3: ''
                };
            } else if( inputData.width && inputData.material) {
                boxName = 'width';
                currentMatchData = {
                    part1: inputData.width,
                    part2: inputData.material,
                    part3: ''
                }
            };

            if (!boxName || !currentMatchData) return;

            const optionLabels = Array.from(
                digiConfigurator.querySelectorAll(
                    `.digi-config__box[box-name='${boxName}'] .box-content label.digi-box-label[data-value]`
                )
            );

            if (!optionLabels.length) return;

            const selectedVariantLabel = optionLabels.find(label =>
                label.classList.contains('digi-checked')
            );

            const unselectedVariantLabels = optionLabels.filter(
                label => !label.classList.contains('digi-checked')
            );

            if (!selectedVariantLabel) return;

            const normalizeTitleParts = (title) => {
                return (title || '')
                    .split(' / ')
                    .map(part => part.trim())
                    .filter(Boolean);
            };

            const findVariantByParts = ({ part1 = '', part2 = '', part3 = '' }) => {
                return variants.find(item => {
                    const parts = normalizeTitleParts(item.public_title);

                    const checks = [
                        part1 ? parts.includes(part1) : true,
                        part2 ? parts.includes(part2) : true,
                        part3 ? parts.includes(part3) : true
                    ];

                    return checks.every(Boolean);
                }) || null;
            };

            const getVariantPrice = (matchData) => {
                const foundItem = findVariantByParts(matchData);
                return foundItem ? foundItem.price / 100 : null;
            };

            const currentPrice = getVariantPrice(currentMatchData);
            if (currentPrice === null) return;

            unselectedVariantLabels.forEach(label => {
                const variantValue = label.dataset.value || '';

                let variantMatchData;

                if (boxName === 'sleepSize') {
                    variantMatchData = {
                        part1: variantValue,
                        part2: inputData.material,
                        part3: inputData.mattress
                    };
                } else if( boxName === 'width' ) {
                    variantMatchData = {
                        part1: variantValue,
                        part2: inputData.material,
                        part3: ''
                    };
                } else {
                    variantMatchData = {
                        part1: inputData.material,
                        part2: variantValue,
                        part3: ''
                    };
                }

                const variantPrice = getVariantPrice(variantMatchData);

                if (variantPrice === null) {
                    setPriceDifferenceText(label, null);
                    return;
                }

                const priceDifference = variantPrice - currentPrice;
                setPriceDifferenceText(label, priceDifference.toFixed(2));
            });

            setPriceDifferenceText(selectedVariantLabel, 0);
        };

        const __customSelectInstances = new Set();
        const __customSelectInit = (selectElement, options = {}) => {
            if (!selectElement) return;

            const selectName = selectElement.querySelector('._select-name');
            const selectList = selectElement.querySelector('._select-list');
            const numberEl = selectName?.querySelector('._number');

            const {
                onChange = null,
                selectedFiltersContent = null,
                filterType = ''
            } = options;

            if (!selectName || !selectList || !numberEl) return;

            const labels = Array.from(selectList.querySelectorAll('label'));

            const getInputs = () => {
                return labels
                    .map(label => label.querySelector('input'))
                    .filter(Boolean);
            };

            const getSelectedValues = () => {
                return getInputs()
                    .filter(input => input.checked)
                    .map(input => input.value);
            };

            const updateClearButton = () => {
                if (!selectedFiltersContent) return;

                const hasAnySelectedChip = selectedFiltersContent.querySelector('._selected-filter-chip');
                let clearButton = selectedFiltersContent.querySelector('._clear-selected-filters');

                if (hasAnySelectedChip) {
                    if (!clearButton) {
                        selectedFiltersContent.insertAdjacentHTML('beforeend', `
                            <button type="button" class="_clear-selected-filters">
                                ${TRANSLATE.box__material.aside_panel_content.filters.reset_filters}
                            </button>
                        `);

                        clearButton = selectedFiltersContent.querySelector('._clear-selected-filters');

                        clearButton.addEventListener('click', () => {
                            __customSelectInstances.forEach(instance => {
                                instance.clear();
                            });
                        });
                    }

                    selectedFiltersContent.appendChild(clearButton);
                }

                if (!hasAnySelectedChip && clearButton) {
                    clearButton.remove();
                }
            };

            const renderSelectedFilters = () => {
                if (!selectedFiltersContent) return;

                selectedFiltersContent
                    .querySelectorAll(`._selected-filter-chip[data-filter-type="${filterType}"]`)
                    .forEach(el => el.remove());

                const selectedValues = getSelectedValues();

                selectedValues.forEach(value => {
                    selectedFiltersContent.insertAdjacentHTML('beforeend', `
                        <button type="button" class="_selected-filter-chip" data-filter-type="${filterType}" data-filter-value="${value}">
                            <span>${filterType}: ${value}</span>
                            <span aria-hidden="true">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 4L4 12M4 4L12 12" stroke="#353535" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </button>
                    `);
                });

                selectedFiltersContent
                    .querySelectorAll(`._selected-filter-chip[data-filter-type="${filterType}"]`)
                    .forEach(chip => {
                        chip.addEventListener('click', () => {
                            const value = chip.dataset.filterValue;

                            const inputToUncheck = getInputs().find(input => input.value === value);
                            if (!inputToUncheck) return;

                            inputToUncheck.checked = false;
                            updateSelectedState();
                        });
                    });

                updateClearButton();
            };

            const updateSelectedState = () => {
                const selectedValues = getSelectedValues();

                numberEl.textContent = selectedValues.length === 0 ? '' : selectedValues.length;
                renderSelectedFilters();

                if (typeof onChange === 'function') {
                    onChange(selectedValues, selectElement);
                }
            };

            const clear = () => {
                getInputs().forEach(input => {
                    input.checked = false;
                });

                updateSelectedState();
            };

            __customSelectInstances.add({
                selectElement,
                clear
            });

            options.bottomSheetData['selectListNode'] = selectList;

            selectName.addEventListener('click', function () {
                if (isMobile()) {
                    __createBottomSheet(options.bottomSheetData);
                } else {
                    selectElement.classList.toggle('_digi-open');
                };
            });

            document.addEventListener('click', function (event) {
                if (!selectElement.contains(event.target)) {
                    selectElement.classList.remove('_digi-open');
                }
            });

            labels.forEach(label => {
                const input = label.querySelector('input');
                if (!input) return;

                input.addEventListener('change', function () {
                    updateSelectedState();
                });
            });

            updateSelectedState();
        };


        const __createBottomSheet = (data) => {
            const key = data.key;
            const title = data.title;

            if (!key || !title) return;
            if (document.querySelector(`div[id='digi-bottom-sheet__${key}']`)) return;

            const bottomSheetData = {
                title: title,
                content: ``
            };

            if (key === 'filters') {
                if (!data.selectListNode) return;

                const labels = data.selectListNode.querySelectorAll('label');
                if (!labels.length) return;

                labels.forEach(label => {
                    const clonedLabel = label.cloneNode(true);

                    clonedLabel.querySelectorAll('input').forEach(input => {
                        if (input.type === 'checkbox' || input.type === 'radio') {
                            if (input.checked) {
                                input.setAttribute('checked', 'checked');
                            } else {
                                input.removeAttribute('checked');
                            }
                        }
                    });

                    bottomSheetData.content += clonedLabel.outerHTML;
                });
            }

            const bottomSheetTemp = `
                <div class='_digi-bottom-sheet' id='digi-bottom-sheet__${key}'>
                    <span class='__digi-bs-drag-el' id='digi-bs-drag-el__${key}'></span>

                    <div class='_header'>
                        <div class='_title'>${bottomSheetData.title}</div>

                        <span class='_btn-close'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/>
                            </svg>
                        </span>
                    </div>

                    <div class='_content'>
                        ${bottomSheetData.content}
                    </div>
                </div>

                <div class='__digi-bottom-sheet-overlay' id='digi-bottom-sheet-overlay__${key}'></div>
            `;

            document.body.insertAdjacentHTML('beforeend', bottomSheetTemp);

            const bottomSheetElement = document.querySelector(`._digi-bottom-sheet#digi-bottom-sheet__${key}`);
            const bottomSheetOverlay = document.querySelector(`.__digi-bottom-sheet-overlay#digi-bottom-sheet-overlay__${key}`);

            if (!bottomSheetElement || !bottomSheetOverlay) return;

            let isClosing = false;

            const __removeBottomSheet = () => {
                if (!document.querySelector('.digi-configurator__aside-panel')) {
                    document.body.classList.remove('__digi-configurator__fixed-view');
                }

                bottomSheetElement.remove();
                bottomSheetOverlay.remove();
            };

            const __openBottomSheet = () => {
                document.body.classList.add('__digi-configurator__fixed-view');

                bottomSheetElement.classList.remove('is-open');
                bottomSheetOverlay.classList.remove('is-open');

                bottomSheetElement.style.transition = 'none';
                bottomSheetOverlay.style.transition = 'none';

                bottomSheetElement.style.transform = 'translate3d(0, 100%, 0)';
                bottomSheetOverlay.style.opacity = '0';

                bottomSheetElement.getBoundingClientRect();

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        bottomSheetElement.style.transition = '';
                        bottomSheetOverlay.style.transition = '';

                        bottomSheetElement.classList.add('is-open');
                        bottomSheetOverlay.classList.add('is-open');

                        bottomSheetElement.style.transform = '';
                        bottomSheetOverlay.style.opacity = '';
                    });
                });
            };

            const __closeBottomSheet = () => {
                if (isClosing) return;
                isClosing = true;

                bottomSheetElement.style.transition = '';
                bottomSheetOverlay.style.transition = '';

                bottomSheetElement.classList.remove('is-open');
                bottomSheetOverlay.classList.remove('is-open');

                bottomSheetElement.style.transform = 'translate3d(0, 100%, 0)';
                bottomSheetOverlay.style.opacity = '0';

                const onTransitionEnd = (e) => {
                    if (e.target !== bottomSheetElement) return;
                    if (e.propertyName !== 'transform') return;

                    bottomSheetElement.removeEventListener('transitionend', onTransitionEnd);
                    __removeBottomSheet();
                };

                bottomSheetElement.addEventListener('transitionend', onTransitionEnd);

                setTimeout(() => {
                    if (document.body.contains(bottomSheetElement)) {
                        bottomSheetElement.removeEventListener('transitionend', onTransitionEnd);
                        __removeBottomSheet();
                    }
                }, 500);
            };

            bottomSheetElement.querySelector('._btn-close')?.addEventListener('click', () => {
                __closeBottomSheet();
            });

            bottomSheetOverlay.addEventListener('click', () => {
                __closeBottomSheet();
            });

            const __drag = () => {
                const bottomSheetHeader = bottomSheetElement.querySelector('._header');

                if (!bottomSheetHeader) return;

                let startY = 0;
                let currentY = 0;
                let isDragging = false;
                let startTime = 0;

                const CLOSE_THRESHOLD = 120;
                const VELOCITY_THRESHOLD = 0.6;

                const onDragStart = (e) => {
                    if (!isMobile()) return;
                    if (isClosing) return;

                    isDragging = true;
                    startY = e.clientY;
                    currentY = 0;
                    startTime = Date.now();

                    bottomSheetElement.style.transition = 'none';
                    bottomSheetOverlay.style.transition = 'none';

                    document.addEventListener('pointermove', onDragMove, {
                        passive: false
                    });

                    document.addEventListener('pointerup', onDragEnd);
                    document.addEventListener('pointercancel', onDragEnd);
                };

                const onDragMove = (e) => {
                    if (!isDragging) return;

                    e.preventDefault();

                    const diffY = e.clientY - startY;

                    if (diffY <= 0) {
                        currentY = 0;
                        bottomSheetElement.style.transform = 'translate3d(0, 0, 0)';
                        bottomSheetOverlay.style.opacity = '1';
                        return;
                    }

                    currentY = diffY;

                    bottomSheetElement.style.transform = `translate3d(0, ${currentY}px, 0)`;

                    const opacity = Math.max(0, 1 - currentY / 300);
                    bottomSheetOverlay.style.opacity = opacity;
                };

                const onDragEnd = () => {
                    if (!isDragging) return;

                    isDragging = false;

                    const elapsed = Date.now() - startTime;
                    const velocity = elapsed > 0 ? currentY / elapsed : 0;

                    const shouldClose =
                        currentY > CLOSE_THRESHOLD ||
                        velocity > VELOCITY_THRESHOLD;

                    bottomSheetElement.style.transition = '';
                    bottomSheetOverlay.style.transition = '';

                    if (shouldClose) {
                        __closeBottomSheet();
                    } else {
                        bottomSheetElement.style.transform = 'translate3d(0, 0, 0)';
                        bottomSheetOverlay.style.opacity = '1';

                        bottomSheetElement.classList.add('is-open');
                        bottomSheetOverlay.classList.add('is-open');
                    }

                    document.removeEventListener('pointermove', onDragMove);
                    document.removeEventListener('pointerup', onDragEnd);
                    document.removeEventListener('pointercancel', onDragEnd);
                };

                const dragAreas = bottomSheetElement.querySelectorAll('._header, .__digi-bs-drag-el');

                dragAreas.forEach((area) => {
                    area.addEventListener('pointerdown', onDragStart);
                });
            };

            const __bottomSheetLogic = (keyName) => {
                if (!keyName) return;

                if (keyName === 'filters') {
                    const labelElements = Array.from(bottomSheetElement.querySelectorAll('._content label'));
                    if (!labelElements.length) return;

                    labelElements.forEach(label => {
                        const input = label.querySelector('input');
                        if (!input) return;

                        input.addEventListener('change', function () {
                            if (!data.selectListNode) return;

                            const selectedLabel = data.selectListNode.querySelector(
                                `label[index='${label.getAttribute('index')}'] input`
                            );

                            if (!selectedLabel) return;

                            selectedLabel.click();
                        });
                    });
                }
            };

            __drag();
            __bottomSheetLogic(key);
            __openBottomSheet();
        };

        const __logic = (keyName) => {
            if (!keyName) return;
            const newKeyName = findKeyPath(attrKeys, keyName) || keyName;

            const box = document.querySelector(`#digi-new-configurator .digi-config__box[box-name='${newKeyName}']`);
            if (!box) return;

            if (attrKeys.sleepSize.includes(keyName) || attrKeys.sleepFunction.sectionName.includes(keyName) || attrKeys.layout.includes(keyName) || attrKeys.pillowFilling.includes(keyName) || attrKeys.width.includes(keyName)) {
                const inputs = Array.from(box.querySelectorAll(`.digi-box-label input[name='${keyName}']`));
                if (!inputs.length) return;

                const asideTrigger = box.querySelector('.box-title span.digi-config__aside-panel-open[for]:not([custom-open])');
                if (asideTrigger) {
                    if (attrKeys.sleepSize.includes(keyName) || attrKeys.width.includes(keyName)) {
                        // OR attrKeys.width.includes(keyName)
                        asideTrigger.addEventListener('click', function () {
                            __createAsidePanel(this.getAttribute('for'), true, {
                                etap: Array.prototype.indexOf.call(box.parentNode.children, box)
                            });
                        });
                    } else {
                        asideTrigger.addEventListener('click', function () {
                            __createAsidePanel(this.getAttribute('for'), false, {
                                etap: Array.prototype.indexOf.call(box.parentNode.children, box),
                            });
                        });
                    };
                };


                inputs.forEach(inputEl => {
                    inputEl.addEventListener('change', function () {
                        if (attrKeys.layout.includes(keyName)) {
                            clickedAttr.layout = true;
                        };

                        const configElement = configElements.find(el => el.dataset.type === inputEl.name);
                        if (!configElement) return;

                        const originalInput = configElement.querySelector(`fieldset input[name='${inputEl.name}'][value="${inputEl.value}"]`);
                        if (!originalInput) return;

                        originalInput.click();

                        box.querySelector('.digi-box-label.digi-checked')?.classList.remove('digi-checked');
                        inputEl.parentNode.classList.add('digi-checked');

                        CURRENT_INPUTS_DATA[newKeyName] = inputEl.value;
                        __priceDifferenceUpdate();
                        __priceDifferenceUpdate('custom-total-width');

                        let button_name = '-';
                        if (attrKeys.sleepSize.includes(keyName)) {
                            button_name = 'rozmiar_powierzchni_spania';
                        } else if (attrKeys.sleepFunction.sectionName.includes(keyName)) {
                            button_name = 'funkcja_spania';
                        } else if (attrKeys.layout.includes(keyName)) {
                            button_name = 'strona';
                        } else if (attrKeys.pillowFilling.includes(keyName)) {
                            button_name = 'rodzaj_wypelnienia_poduszek';
                        } else if (attrKeys.width.includes(keyName)) {
                            button_name = 'szerokosc_calkowita';
                        };


                        __EVENTS({
                            ecommerce: {
                                button_name: button_name,
                                button_type: "detail",
                                option: inputEl.value,
                                view: 0,
                                etap: Array.prototype.indexOf.call(box.parentNode.children, box),
                            }
                        });
                    });
                });

                if (attrKeys.layout.includes(keyName)) {
                    const checkCheckedLayout = (attempt = 1, maxAttempts = 10) => {
                        if (clickedAttr.layout) return;

                        const foundCheckedLayoutInput = Array.from(layoutAttr?.layout || []).find(inputLayout => inputLayout.checked);

                        if (foundCheckedLayoutInput) {
                            CURRENT_INPUTS_DATA['layout'] = foundCheckedLayoutInput.value;

                            box.querySelectorAll('.box-content .digi-box-label').forEach(l => {
                                l.classList.remove('digi-checked');

                                if (l.querySelector('input').value === foundCheckedLayoutInput.value) {
                                    l.classList.add('digi-checked');
                                };
                            });
                        };

                        if (attempt < maxAttempts) {
                            setTimeout(() => {
                                checkCheckedLayout(attempt + 1, maxAttempts);
                            }, 500);
                        };
                    };

                    checkCheckedLayout();
                };
            } else if (attrKeys.material.includes(keyName)) {
                const asideTriggers = Array.from(box.querySelectorAll('.digi-config__aside-panel-open[for]'));

                if (asideTriggers.length > 0) {
                    asideTriggers.forEach(trigger => {
                        trigger.addEventListener('click', function () {
                            __createAsidePanel(this.getAttribute('for'), false, {
                                etap: Array.prototype.indexOf.call(box.parentNode.children, box)
                            });
                        });
                    })
                };

                const inputs = Array.from(box.querySelectorAll(`.digi-box-label input[name='${keyName}']`));
                if (!inputs.length) return;

                inputs.forEach(inputEl => {
                    inputEl.addEventListener('change', function () {
                        clickedAttr.material = true;
                        const configElement__material = configElements.find(el => el.dataset.type === inputEl.name);
                        if (!configElement__material) return;

                        const originalMaterialInput = configElement__material.querySelector(`fieldset input[name='${inputEl.name}'][data-tech-name="${inputEl.value}"]`);
                        if (!originalMaterialInput) return;

                        originalMaterialInput.click();

                        const configElement__color = configElements.find(el => el.dataset.type === 'color');
                        const originalColorInput = configElement__color?.querySelector(`fieldset input[name='color'][data-tech-name='${this.parentNode.dataset.color}']`);


                        if (box.querySelector('.digi-box-label.digi-checked')) {
                            box.querySelector('.digi-box-label.digi-checked').classList.remove('digi-checked');
                        };
                        inputEl.parentNode.classList.add('digi-checked');

                        box.querySelector('.box-summary-content .s-el[summary-name="material"] .s-v').innerHTML = originalMaterialInput.value.charAt(0).toUpperCase() + originalMaterialInput.value.slice(1);

                        if (originalColorInput) {
                            const colorName = originalColorInput.value.trim().replaceAll('-', ' ');
                            box.querySelector('.box-summary-content .s-el[summary-name="color"] .s-v').innerHTML = colorName.charAt(0).toUpperCase() + colorName.slice(1);
                            CURRENT_INPUTS_DATA['color'] = originalColorInput.value;

                            originalColorInput.click();
                            //inputEl.parentNode.setAttribute('data-color', originalColorInput.value);
                        } else {
                            CURRENT_INPUTS_DATA['color'] = null;
                        };

                        CURRENT_INPUTS_DATA['material'] = inputEl.value;
                        __priceDifferenceUpdate();
                        __priceDifferenceUpdate('custom-total-width');

                        if (this.parentNode.classList.contains('open-mobile-only')) {
                            if (isMobile()) {
                                __createAsidePanel(this.parentNode.getAttribute('custom-for'), false, {
                                    etap: Array.prototype.indexOf.call(box.parentNode.children, box)
                                });
                            };
                        } else {
                            __createAsidePanel(this.parentNode.getAttribute('custom-for'), false, {
                                etap: Array.prototype.indexOf.call(box.parentNode.children, box)
                            });
                        };

                        __EVENTS({
                            ecommerce: {
                                button_name: "tkanina_i_kolor",
                                button_type: "main",
                                material: CURRENT_INPUTS_DATA['material'],
                                option: CURRENT_INPUTS_DATA['color'],
                                view: 0,
                                etap: Array.prototype.indexOf.call(box.parentNode.children, box)
                            }
                        });
                    });
                });

                // Auto-select for color
                const checkCheckedColor = (attempt = 1, maxAttempts = 10) => {
                    if (clickedAttr.material) return;

                    const foundCheckedColorInput = Array.from(colorAttr?.color || []).find(
                        inputColor => inputColor.checked
                    );

                    if (foundCheckedColorInput) {
                        const colorName =
                            foundCheckedColorInput.value.charAt(0).toUpperCase() +
                            foundCheckedColorInput.value.slice(1);

                        CURRENT_INPUTS_DATA['color'] = foundCheckedColorInput.value;

                        const foundMaterialsArray = AVAILABLE_MATERIALS[foundCheckedColorInput.dataset.group.trim().toLowerCase().replaceAll(' ', '-')];

                        if (foundMaterialsArray.length > 0) {
                            const foundMaterialInput = foundMaterialsArray.find(m => m.value.toLowerCase().trim() === foundCheckedColorInput.value.toLowerCase().trim());

                            if (foundMaterialInput) {
                                const materalName = foundMaterialInput.dataset.group;

                                box.querySelector(
                                    '.box-summary-content .s-el[summary-name="material"] .s-v'
                                ).innerHTML = materalName.trim();
                            };
                        };

                        box.querySelector(
                            '.box-summary-content .s-el[summary-name="color"] .s-v'
                        ).innerHTML = colorName.trim().replaceAll('-', ' ');


                        if (box.querySelector('.digi-box-label.digi-checked')) {
                            box.querySelector('.digi-box-label.digi-checked').classList.remove('digi-checked');
                        };

                        const foundFrontColorBox = box.querySelector(`label.digi-box-label[data-value='${foundCheckedColorInput.dataset.group.toLowerCase().trim()}'][data-color='${foundCheckedColorInput.dataset.techName}']`);
                        if (foundFrontColorBox) {
                            foundFrontColorBox.classList.add('digi-checked');
                        } else {
                            const firstFrontColorBox = box.querySelector(`label.digi-box-label`);
                            if (firstFrontColorBox) {
                                firstFrontColorBox.dataset.value = foundCheckedColorInput.dataset.group.toLowerCase().trim();
                                firstFrontColorBox.dataset.color = CURRENT_INPUTS_DATA['color'];
                                firstFrontColorBox.querySelector('input').value = foundCheckedColorInput.dataset.group.toLowerCase().trim();
                                firstFrontColorBox.querySelector('.value').innerHTML = __getMaterialData({ color: CURRENT_INPUTS_DATA['color'] }).basic.color.image;
                                firstFrontColorBox.classList.add('digi-checked');
                            };
                        };
                    };

                    if (attempt < maxAttempts) {
                        setTimeout(() => {
                            checkCheckedColor(attempt + 1, maxAttempts);
                        }, 500);
                    };
                };

                checkCheckedColor();

            } else if (attrKeys.mattress.includes(keyName)) {
                let asideTrigger = '';
                let asideTrigger2 = box.querySelector('.digi-config__aside-panel-open[for][custom-open]');

                if (box.classList.contains('digi-config__aside-panel-open')) {
                    asideTrigger = box;
                } else {
                    asideTrigger = box.querySelector('.digi-config__aside-panel-open[for]:not([custom-open])');
                };

                if (asideTrigger) {
                    asideTrigger.addEventListener('click', function () {
                        __createAsidePanel(this.getAttribute('for'), false, {
                            etap: Array.prototype.indexOf.call(box.parentNode.children, box)
                        });
                    });
                };

                if (asideTrigger2) {
                    asideTrigger2.addEventListener('click', function () {
                        __createAsidePanel(this.getAttribute('for'), false, {
                            etap: Array.prototype.indexOf.call(box.parentNode.children, box)
                        });
                    });
                };


                const mattressOpenAsidePanelBtn = box.querySelector('.digi-config__aside-panel-open[for="mattress"]:not([custom-open])');
                const changeMattressBtn = box.querySelector('.digi-config__aside-panel-open[for="mattress"][custom-open]');
                const noMattressBtn = box.querySelector('.digi-mattress-box.no-mattress-option');

                if (noMattressBtn) {
                    noMattressBtn.addEventListener('click', function () {
                        if (mattressOpenAsidePanelBtn) {
                            mattressOpenAsidePanelBtn.classList.remove('digi-checked');
                            changeMattressBtn.classList.add('digi-hidden');
                            box.querySelector('._title ._mattress-name[data-default-value]').textContent = box.querySelector('._title ._mattress-name[data-default-value]').dataset.defaultValue;
                            box.querySelector('._title ._mattress-price[data-default-value]').textContent = box.querySelector('._title ._mattress-price[data-default-value]').dataset.defaultValue;
                            box.querySelector('.img img[src][data-default-value]').src = box.querySelector('.img img[src][data-default-value]').dataset.defaultValue;
                        };


                        if (!this.classList.contains('digi-checked')) {
                            const configElement = configElements.find(el => attrKeys.mattress.includes(el.dataset.type));
                            if (!configElement) return;

                            const originalInput__mattress = configElement.querySelector(`fieldset input[name][value='${this.dataset.value}']`);
                            if (originalInput__mattress) {
                                originalInput__mattress.click();
                                this.classList.add('digi-checked');

                                CURRENT_INPUTS_DATA['mattress'] = this.dataset.value;
                                CURRENT_INPUTS_DATA['hardness'] = null;

                                __EVENTS({
                                    ecommerce: {
                                        button_name: "wybierz_material",
                                        button_type: "main",
                                        option: MATTRESS_TECH_NAME_MAP['brak-materaca']['pl'][0],
                                        view: 0,
                                        etap: Array.prototype.indexOf.call(box.parentNode.children, box)
                                    }
                                });
                            };
                        };
                    });
                }
            } else if (keyName === 'custom-total-width') {
                __priceDifferenceUpdate('custom-total-width');
                box.querySelector('label.digi-custom-link')?.addEventListener('click', function (event) {
                    event.preventDefault();

                    if (!_custom_handle.current) return;
                    if (!_custom_handle.new) return;

                    const urlParams = new URLSearchParams(window.location.search);
                    const currentVariantID = urlParams.get('variant');

                    if (!currentVariantID) return;

                    const currentVariantIDString = currentVariantID.toString().trim();

                    const isCurrentNormal = _custom_handle.current === CUSTOM_TOTAL_WIDTH.normal.product_data.handle;
                    const isCurrentMini = _custom_handle.current === CUSTOM_TOTAL_WIDTH.mini.product_data.handle;

                    if (!isCurrentNormal && !isCurrentMini) return;

                    let currentVariantData = null;
                    let targetVariantData = null;
                    let targetHandle = null;

                    if (isCurrentNormal) {
                        currentVariantData = CUSTOM_TOTAL_WIDTH.normal.product_data.variants.find(obj =>
                            obj.id.toString().trim() === currentVariantIDString
                        );

                        if (!currentVariantData) return;

                        targetVariantData = CUSTOM_TOTAL_WIDTH.mini.product_data.variants.find(obj =>
                            obj.title.trim() === currentVariantData.title.trim()
                        );

                        targetHandle = CUSTOM_TOTAL_WIDTH.mini.product_data.handle;
                    }

                    if (isCurrentMini) {
                        currentVariantData = CUSTOM_TOTAL_WIDTH.mini.product_data.variants.find(obj =>
                            obj.id.toString().trim() === currentVariantIDString
                        );

                        if (!currentVariantData) return;

                        targetVariantData = CUSTOM_TOTAL_WIDTH.normal.product_data.variants.find(obj =>
                            obj.title.trim() === currentVariantData.title.trim()
                        );

                        targetHandle = CUSTOM_TOTAL_WIDTH.normal.product_data.handle;
                    }

                    if (!targetVariantData) return;
                    if (!targetHandle) return;

                    const newURL = new URL(window.location.href);

                    newURL.pathname = newURL.pathname.replace(
                        /\/products\/[^/?#]+/,
                        `/products/${targetHandle}`
                    );

                    __EVENTS({
                        ecommerce: {
                            button_name: "pelne_wymiary",
                            button_type: "detail",
                            section_name: "szerokosc_calkowita_custom",
                            option: '-',
                            view: 0,
                            etap: Array.prototype.indexOf.call(box.parentNode.children, box)
                        }
                    }, true);

                    setTimeout(() => {
                        newURL.searchParams.set('variant', targetVariantData.id);
                        window.location.href = newURL.toString();
                    }, 100);
                });


                const input = box.querySelector(`.digi-box-label:not(.digi-custom-link) input[name="${keyName}"]`);
                if (!input) return;

                const asideTrigger = box.querySelector('.box-title span.digi-config__aside-panel-open[for]:not([custom-open])');
                if (asideTrigger) {
                    asideTrigger.addEventListener('click', function () {
                        __createAsidePanel(this.getAttribute('for'), false, {
                            size: input.dataset.size,
                            variantType: input.parentNode.dataset.variantType.toLowerCase().trim(),
                            etap: Array.prototype.indexOf.call(box.parentNode.children, box)
                        });
                    });
                };
            }
        };

        const __createAsidePanel = (key, isBed, customData) => {
            if (!key) return;
            if (document.querySelector(`aside[id='digi-aside-panel__${key}']`)) return;

            const asidePanelData = {
                title: '',
                content: '',
                config: {
                    autoscroll: false
                }
            };

            let closeBtnCopy = TRANSLATE.aside_panel.header.close;
            let PRODUCT_GALLERY_ARRAY = [];

            const getSizeTableContent = (params) => {
                const currentImgSrc = document.querySelector('.product .product__media-wrapper media-gallery ul li:nth-child(1) modal-opener .product__media img[src]').src;
                let newImgSrc = currentImgSrc;

                if (params.isMaterial) {
                    const materialDetails = __getMaterialData({ color: params.material }).fullDescriptionHtml;
                    const content = materialDetails;

                    return {
                        mask: null,
                        image: newImgSrc,
                        content: content,
                        currentImgSrc: currentImgSrc
                    };
                } else if (params.isSize) {
                    let content = ``;
                    const dimensions = __getProductData().dimensions;
                    const size = params.size.split('x')[0];


                    const imgType = currentImgSrc.split('?')[0].split('.').pop();
                    const newUrl = currentImgSrc.replace(/-(\d+)\.jpg(\?.*)?$/, `-${size}.${imgType}$2`)

                    newImgSrc = newUrl.replace('-lewa', '');

                    for (const [key, val] of Object.entries(dimensions)) {
                        let title = '';
                        const objVal = {
                            value: null,
                            unit: null
                        };

                        if (val) {
                            objVal.value = val.value;
                            objVal.unit = val.unit;
                        };

                        if (key === 'sleeping_length') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.sleeping_length;
                        } else if (key === 'sleeping_width') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.sleeping_width;

                            if (params?.sleepingWidthOrTotalWidth && params?.sleepingWidthOrTotalWidth === 'sleeping') {
                                objVal.value = size;
                                objVal.unit = "cm";
                            };
                        } else if (key === 'total_length') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.total_length;
                        } else if (key === 'total_width') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.total_width;

                            if (params?.sleepingWidthOrTotalWidth && params?.sleepingWidthOrTotalWidth === 'sleeping') {
                                if (__getProductData().totalWidthMap) {
                                    const foundTotalWidthSize = __getProductData().totalWidthMap[size];
                                    if (foundTotalWidthSize) {
                                        objVal.value = foundTotalWidthSize;
                                        objVal.unit = "cm";
                                    };
                                };
                            } else if (params?.sleepingWidthOrTotalWidth && params?.sleepingWidthOrTotalWidth === 'total') {
                                objVal.value = size;
                                objVal.unit = "cm";
                            };
                        } else if (key === 'total_height') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.total_height;
                        } else if (key === 'seat_depth') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.seat_depth;
                        } else if (key === 'seat_height') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.seat_height;
                        } else if (key === 'backrest_width') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.backrest_width;
                        } else if (key === 'side_width') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.side_width;
                        } else if (key === 'side_height') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.side_height;
                        } else if (key === 'depth') {
                            title = TRANSLATE.box__sleep_size.aside_panel_content.dimensions.depth;
                        }

                        if (objVal.value || objVal.unit) {
                            content += `
                                <div class='digi-row' data-key='${key}'>
                                    <div class='digi-col _d-title'>${title}</div>
                                    <div class='digi-col _d-value'>${objVal.value} ${objVal.unit}</div>
                                </div>
                            `;
                        };
                    };

                    const masks = __getProductData().masks;
                    let foundMask = null;

                    if (params?.customParams?.variantType === 'normal' || params?.customParams?.variantType === 'mini') {
                        foundMask = masks[0];
                    } else {
                        foundMask = masks.find(m => m.includes(`wymiary-${PRODUCT_DATA.name}-${size}.svg`));
                    };

                    let mask_dynamicUrl = null;

                    if (foundMask) {
                        mask_dynamicUrl = foundMask;
                    };

                    return {
                        mask: mask_dynamicUrl,
                        image: newImgSrc,
                        content: content,
                        currentImgSrc: currentImgSrc
                    };
                } else {
                    return {
                        mask: null,
                        image: newImgSrc,
                        content: ``,
                        currentImgSrc: currentImgSrc
                    };
                };
            };

            const getMattressSpecTableContent = (params) => {
                if (!params.rawContent) return { content: '' };
                if (!params.rawContent?.children) return { content: '' };

                let contentRow = ``;
                params.rawContent?.children.forEach(childObj => {
                    let contentCol = ``;

                    childObj.children.forEach(tableObj => {
                        contentCol += `
                            <div class='digi-col'>${tableObj.value}</div>
                        `;
                    });

                    contentRow += `
                        <div class='digi-row'>
                            ${contentCol}
                        </div>
                    `;
                });

                return {
                    content: contentRow
                }
            };

            const returnProductGallery = () => {
                PRODUCT_GALLERY_ARRAY = [];
                const imgLimit = 3;

                for (let i = 1; i <= imgLimit; i++) {
                    const imgEl = document.querySelector(`media-gallery ul li.product__media-item:nth-child(${i}) modal-opener .product__media img[src]`);

                    if (imgEl) {
                        PRODUCT_GALLERY_ARRAY.push({
                            src: imgEl.src,
                            imgKey: i
                        });
                    };
                };

                if (!PRODUCT_GALLERY_ARRAY.length) return;

                const slidesHTML = PRODUCT_GALLERY_ARRAY.map((item, index) => {
                    return `
                        <div class="_product-gallery__slide" data-slide-index="${index}">
                            <img 
                                class="_product-gallery__image" 
                                src="${item.src}" 
                                alt=""
                                data-img-key="${item.imgKey}"
                                loading="${index === 0 ? 'eager' : 'lazy'}"
                            >
                        </div>
                    `;
                }).join('');

                const productGalleryContentBox = `
                    <div class="_product-gallery__track">
                        ${slidesHTML}
                    </div>

                    <div class="_product-gallery__controls">
                        <button 
                            class="_product-gallery__arrow _product-gallery__arrow--prev" 
                            type="button" 
                            aria-label="Poprzednie zdjęcie"
                        >
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.3188 11.0412C6.37376 10.9864 6.41737 10.9213 6.44712 10.8496C6.47687 10.7779 6.49219 10.701 6.49219 10.6234C6.49219 10.5457 6.47687 10.4689 6.44712 10.3972C6.41737 10.3255 6.37376 10.2604 6.3188 10.2055L2.01415 5.90206L6.3188 1.59859C6.42962 1.48777 6.49188 1.33747 6.49188 1.18075C6.49188 1.02403 6.42962 0.873734 6.3188 0.762917C6.20799 0.6521 6.05769 0.589844 5.90097 0.589844C5.74425 0.589844 5.59395 0.6521 5.48313 0.762917L0.761821 5.48423C0.706861 5.53905 0.663256 5.60418 0.633504 5.67587C0.603753 5.74757 0.588439 5.82444 0.588439 5.90206C0.588439 5.97969 0.603753 6.05656 0.633504 6.12826C0.663256 6.19995 0.706861 6.26508 0.761821 6.3199L5.48313 11.0412C5.53795 11.0962 5.60308 11.1398 5.67478 11.1695C5.74648 11.1993 5.82334 11.2146 5.90097 11.2146C5.9786 11.2146 6.05546 11.1993 6.12716 11.1695C6.19886 11.1398 6.26398 11.0962 6.3188 11.0412Z" fill="#353535"/>
                            </svg>
                        </button>

                        <div class="_product-gallery__counter">
                            <span class="_product-gallery__current">1</span> / 
                            <span class="_product-gallery__total">${PRODUCT_GALLERY_ARRAY.length}</span>
                        </div>

                        <button 
                            class="_product-gallery__arrow _product-gallery__arrow--next" 
                            type="button" 
                            aria-label="Następne zdjęcie"
                        >
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.763227 0.762067C0.708267 0.816888 0.664662 0.882013 0.63491 0.953712C0.605158 1.02541 0.589844 1.10228 0.589844 1.1799C0.589844 1.25753 0.605158 1.33439 0.63491 1.40609C0.664662 1.47779 0.708267 1.54292 0.763227 1.59774L5.06788 5.90121L0.763227 10.2047C0.65241 10.3155 0.590153 10.4658 0.590153 10.6225C0.590153 10.7792 0.65241 10.9295 0.763227 11.0404C0.874044 11.1512 1.02434 11.2134 1.18106 11.2134C1.33778 11.2134 1.48808 11.1512 1.5989 11.0404L6.32021 6.31905C6.37517 6.26423 6.41878 6.1991 6.44853 6.1274C6.47828 6.05571 6.49359 5.97884 6.49359 5.90121C6.49359 5.82359 6.47828 5.74672 6.44853 5.67502C6.41878 5.60332 6.37517 5.5382 6.32021 5.48338L1.5989 0.762067C1.54408 0.707107 1.47895 0.663503 1.40725 0.633751C1.33555 0.603999 1.25869 0.588684 1.18106 0.588684C1.10344 0.588684 1.02657 0.603999 0.954872 0.633751C0.883173 0.663503 0.818048 0.707107 0.763227 0.762067Z" fill="#353535"/>
                            </svg>
                        </button>
                    </div>
                `;

                return productGalleryContentBox;
            };


            const freeFabricSamplesBarContent = `
                <a href='/collections/probki-tkanin' class='digi-free-fabric-samples' target='_blank'>
                    <div class='icon'>
                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.59961 0.400391V11.5C6.59961 13.2121 5.21208 14.5996 3.5 14.5996C1.78792 14.5996 0.400391 13.2121 0.400391 11.5V0.400391H6.59961Z" stroke="black" stroke-width="0.8"/>
                            <path d="M4.7002 14.2998L14.7002 8.2998" stroke="black" stroke-width="0.8"/>
                            <path d="M6.7002 5.7998L11.5423 3.2998L14.7002 8.2998V14.2998H4.7002" stroke="black" stroke-width="0.8"/>
                            <circle cx="3.5" cy="11.7998" r="0.5" fill="black"/>
                        </svg>
                    </div>

                    <div class='text'>${TRANSLATE.box__material.aside_panel_content.free_fabric_samples__bar.cta}</div>

                    <div>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.64592 14.3541C4.59935 14.3076 4.56241 14.2525 4.5372 14.1917C4.512 14.131 4.49902 14.0659 4.49902 14.0001C4.49902 13.9343 4.512 13.8692 4.5372 13.8084C4.56241 13.7477 4.59935 13.6925 4.64592 13.6461L10.2929 8.00008L4.64592 2.35408C4.59943 2.3076 4.56255 2.25241 4.53739 2.19167C4.51223 2.13093 4.49928 2.06583 4.49928 2.00008C4.49928 1.93434 4.51223 1.86924 4.53739 1.8085C4.56255 1.74776 4.59943 1.69257 4.64592 1.64608C4.6924 1.5996 4.74759 1.56272 4.80833 1.53756C4.86907 1.5124 4.93417 1.49945 4.99992 1.49945C5.06566 1.49945 5.13076 1.5124 5.1915 1.53756C5.25224 1.56272 5.30743 1.5996 5.35392 1.64608L11.3539 7.64608C11.4005 7.69253 11.4374 7.7477 11.4626 7.80845C11.4878 7.8692 11.5008 7.93432 11.5008 8.00008C11.5008 8.06585 11.4878 8.13097 11.4626 8.19172C11.4374 8.25246 11.4005 8.30764 11.3539 8.35408L5.35392 14.3541C5.30747 14.4006 5.2523 14.4376 5.19155 14.4628C5.13081 14.488 5.06568 14.501 4.99992 14.501C4.93415 14.501 4.86903 14.488 4.80828 14.4628C4.74754 14.4376 4.69236 14.4006 4.64592 14.3541Z" fill="#707070"/>
                        </svg>
                    </div>
                </a>
            `;


            if (key === 'size-table' || key === 'width' || key === 'custom-total-width') {
                let sizeData = null;
                let titleContent = ``;
                let sleepingWidthOrTotalWidth = '';
                let selectedSize = '';
                const customParams = {};

                if (key === 'size-table') {
                    sleepingWidthOrTotalWidth = 'sleeping';
                    asidePanelData.title = TRANSLATE.box__sleep_size.size_table;

                    if (isBed) {
                        sizeData = FRONT_PANEL.attributes.find(el => attrKeys.sleepSize.includes(Object.keys(el)[0]));
                        titleContent = `
                            <div class='digi-size-select-title'>${TRANSLATE.box__sleep_size.aside_panel_content.dimensions_for_selected_sleeping_surface}</div>
                        `;
                    };

                    __EVENTS({
                        ecommerce: {
                            button_name: "pelne_wymiary",
                            button_type: "main",
                            section_name: "rozmiar_powierzchni_spania",
                            option: '-',
                            view: 0,
                            etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                        }
                    });
                } else if (key === 'width') {
                    sleepingWidthOrTotalWidth = 'total';
                    asidePanelData.title = TRANSLATE.box__width.full_size;

                    if (isBed) {
                        sizeData = FRONT_PANEL.attributes.find(el => attrKeys.width.includes(Object.keys(el)[0]));
                    };

                    __EVENTS({
                        ecommerce: {
                            button_name: "pelne_wymiary",
                            button_type: "main",
                            section_name: "szerokosc_calkowita",
                            option: '-',
                            view: 0,
                            etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                        }
                    });
                } else if (key === 'custom-total-width') {
                    sleepingWidthOrTotalWidth = 'total';
                    asidePanelData.title = TRANSLATE.box__width.full_size;
                    selectedSize = customData.size;
                    customParams.isCustomTotalWidth = true;
                    customParams.variantType = customData.variantType;

                    __EVENTS({
                        ecommerce: {
                            button_name: "pelne_wymiary",
                            button_type: "main",
                            section_name: "szerokosc_calkowita_custom",
                            option: '-',
                            view: 0,
                            etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                        }
                    });
                };

                let sizeSelectContent = ``;

                if (isBed) {
                    if (!sizeData) return;

                    let sizeContent = ``;
                    let CM = '';
                    if( key === 'width' ) {
                        CM = ' cm';
                    };

                    sizeData[Object.keys(sizeData)].forEach(el => {
                        sizeContent += `
                            <label class='digi-box-label ${el.checked ? "digi-checked" : ""}' data-value='${el.value}' data-name='${el.name}'>
                                <div class='value'>${el.value}${CM}</div>
                            </label>
                        `;

                        if (el.checked) {
                            selectedSize = el.value;
                        };
                    });

                    sizeSelectContent = `
                        <div class='digi-size-select'>
                            ${titleContent}
                            <div class='digi-size-select-content'>${sizeContent}</div>
                        </div>
                    `;
                };

                const sizeTableContent = getSizeTableContent({
                    isSize: true,
                    size: selectedSize,
                    sleepingWidthOrTotalWidth: sleepingWidthOrTotalWidth,
                    customParams: customParams
                });

                let maskContent = ``;
                if (sizeTableContent.mask) {
                    maskContent = `<img src='${sizeTableContent.mask}' alt='' class='sizeMask-img'>`;
                };

                let currentImgSrc = sizeTableContent.image;

                asidePanelData.content = `
                    ${sizeSelectContent}
                    
                    <div class='img-mask'>
                    	${maskContent}
                    	<img
                            src='${currentImgSrc}'
                            data-fallback='${sizeTableContent.currentImgSrc}'
                            onerror="this.onerror=null; this.src=this.dataset.fallback;"
                            alt=''
                            class='background-img'>
                    </div>
                    
                    <div class='digi-size-table'>
                    	${sizeTableContent.content}
                    </div>
                `;
            } else if (key === 'sleep_details') {
                asidePanelData.title = TRANSLATE.box__sleep_function.sleep_function;

                const videoData = PRODUCT_DATA?.sleep_function?.video;
                const imageUrl = PRODUCT_DATA?.sleep_function?.image;
                const desc = PRODUCT_DATA?.sleep_function?.desc;

                let videoContent = ``;
                let sizeContent = ``;
                let descContent = ``;

                if (videoData) {
                    const videoSource = videoData.sources.find(obj => obj.height === 720);
                    if (!videoSource) return;

                    videoContent = `
                        <div>
                            <video
                                class='digi-video'
                                playsinline="playsinline"
                                controls="controls"
                                preload="metadata"
                                poster="${videoData.preview_image.src}">
                                    <source src="${videoSource.url}" type="${videoSource.mime_type}">
                                    <img src="${videoData.preview_image.src}">
                            </video>
                        </div>
                    `;
                };

                if (imageUrl) {
                    sizeContent = `
                        <div class='_sleep-function--size'>
                            <p class='digi-title'>${TRANSLATE.box__sleep_function.aside_panel_content.sizes}</p>
                            <img src='${imageUrl}' alt=''>
                        </div>
                    `;
                };

                if( desc ) {
                    descContent = `
                        <div>
                            <p data-value='${desc}'>${desc}</p>
                        </div>
                    `;
                };

                asidePanelData.content = `
                	${descContent}

                    ${videoContent}

					<div>
                        <p class='digi-title'>${TRANSLATE.box__sleep_function.aside_panel_content.why_is_it_worth_it.title}</p>
                        <ul>
                            <li>${TRANSLATE.box__sleep_function.aside_panel_content.why_is_it_worth_it.content.li_1}</li>
                            <li>${TRANSLATE.box__sleep_function.aside_panel_content.why_is_it_worth_it.content.li_2}</li>
                            <li>${TRANSLATE.box__sleep_function.aside_panel_content.why_is_it_worth_it.content.li_3}</li>
                            <li>${TRANSLATE.box__sleep_function.aside_panel_content.why_is_it_worth_it.content.li_4}</li>
                        </ul>
                    </div>
                    
					${sizeContent}
                `;

                __EVENTS({
                    ecommerce: {
                        button_name: "funkcja_spania",
                        button_type: "main",
                        option: '-',
                        view: 0,
                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                    }
                });
            } else if (key === 'more-about-this-material') {
                asidePanelData.title = TRANSLATE.box__material.more_about_this_material;

                let selectedMaterialName = null;
                let selectedMaterialColor = null;

                if (customData?.materialKey && customData?.materialColorKey) {
                    selectedMaterialName = customData.materialKey;
                    selectedMaterialColor = customData.materialColorKey;
                } else {
                    selectedMaterialName = CURRENT_INPUTS_DATA.material;
                    selectedMaterialColor = CURRENT_INPUTS_DATA.color;
                };

                if (!selectedMaterialName || !selectedMaterialColor) return;

                const materialData = __getMaterialData({ name: selectedMaterialName, color: selectedMaterialColor });

                asidePanelData.content = `
                    ${freeFabricSamplesBarContent}

                    <div class='images'>
                        ${materialData.basic.image}
                        ${materialData.basic.video}
                    </div>
                    
                    <div>
                        <p class='digi-title'>${TRANSLATE.box__material.material} ${selectedMaterialName.charAt(0).toUpperCase() + selectedMaterialName.slice(1)}</p>
                        <ul class='digi-ul'>
                            ${materialData.basic.attributes}
                        </ul>
                    </div>

                    <div>
                    	${getSizeTableContent({ isMaterial: true, material: selectedMaterialColor }).content}
                    </div>
                `;

                __EVENTS({
                    ecommerce: {
                        button_name: "wiecej_o_tej_tkaninie",
                        button_type: "main",
                        option: '-',
                        view: 0,
                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                    }
                });
            } else if (key === 'all-materials') {
                asidePanelData.title = TRANSLATE.box__material.aside_panel_content.choose_material_and_color;
                closeBtnCopy = TRANSLATE.aside_panel.header.save_and_close;

                if (isMobile()) {
                    asidePanelData.config.autoscroll = true;
                } else {
                    asidePanelData.config.autoscroll = false;
                };


                let materialsContent = ``;
                const filters = {
                    spec: [],
                    color: []
                };


                // Materials
                for (const [key, value] of Object.entries(AVAILABLE_MATERIALS)) {
                    const materialData = __getMaterialData({ name: key });
                    let colorsContent = ``;

                    const boxFilters = {
                        spec: [],
                        colors: []
                    };

                    const attrParser = (rawHTML) => {
                        if (!rawHTML) return;

                        const html = String(rawHTML)
                            .trim()
                            .replace(/^['"]+|['"]+$/g, '');

                        const parser = new DOMParser();
                        const doc = parser.parseFromString(`<ul>${html}</ul>`, 'text/html');

                        const items = [...doc.querySelectorAll('li')];

                        items.forEach((li) => {
                            const name = li.querySelector('.name')?.textContent?.trim() || '';
                            const icon = li.querySelector('img')?.getAttribute('src') || '';

                            if (!name) return;

                            if (!filters.spec.includes(name)) {
                                filters.spec.push(name);
                            }

                            if (!boxFilters.spec.includes(name)) {
                                boxFilters.spec.push(name);
                            }
                        });
                    };


                    // Colors
                    const sortedColorsNodes = Array.from(value).sort((a, b) => {
                        const nameA = a.dataset.techName;
                        const nameB = b.dataset.techName;

                        const numberA = Number(nameA.match(/\d+$/)?.[0] ?? 0);
                        const numberB = Number(nameB.match(/\d+$/)?.[0] ?? 0);

                        return numberA - numberB;
                    });

                    sortedColorsNodes.forEach(colorInput => {
                        const colorData = {
                            name: colorInput.value.replaceAll('-', ' '),
                            img: __getMaterialData({ color: colorInput.dataset.techName, returnAsNode: true }).basic.color.image,
                            color: __getMaterialData({ color: colorInput.dataset.techName }).basic.color.color
                        };
                        colorData.name = colorData.name.charAt(0).toUpperCase() + colorData.name.slice(1);

                        if (!filters.color.includes(colorData.color)) {
                            filters.color.push(colorData.color);
                        };

                        if( !boxFilters.colors.includes(colorData.color) ) {
                            boxFilters.colors.push(colorData.color);
                        };

                        let isChecked = false;

                        if (CURRENT_INPUTS_DATA['material'] === key && CURRENT_INPUTS_DATA['color'] === colorData.name.replaceAll(' ', '-').toLowerCase().trim()) {
                            isChecked = true;
                        };

                        const imgNode = colorData.img;

                        colorsContent += `
                            <label class='_color-box ${isChecked ? "digi-checked" : ""}' data-tech-name='${colorInput.dataset.techName}' data-color='${colorData.color}'>
                                <input type='radio' name='config-color' value='${colorInput.dataset.techName}' data-material='${key}' ${isChecked ? "checked" : ""}>
                                <div class='_img'>
                                    <button class='digi-config__aside-panel-open' for='material-preview' data-color-tech-name='${colorInput.dataset.techName}'>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 11.0769V6.23077H0.692308V9.90796L9.90796 0.692308H6.23077V0H11.0769V4.84615H10.3846V1.16896L1.16896 10.3846H4.84615V11.0769H0Z" fill="#353535"/>
                                        </svg>
                                    </button>
                                    
                                    <img data-src='${imgNode.src}' src='' alt='${imgNode.alt}'>
                                </div>
                                <div class='_name'>${colorData.name}</div>
                            </label>
                        `;
                    });


                    // Attributes
                    attrParser(materialData.basic.attributes);


                    // Properties
                    let propertiesContent = ``;
                    if (MATERIALS_GROUP_DATA.length > 0) {
                        const foundGroup = MATERIALS_GROUP_DATA.find(item => item.name.toLowerCase().trim().replaceAll(' ', '-') === key.toLowerCase().trim().replaceAll(' ', '-'));
                        let propertiesBox = ``;

                        if (foundGroup) {
                            foundGroup.properties.forEach(p => {
                                propertiesBox += `
                                    <div class='_properties'>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.041 8.60517L9.30517 4.341L8.83333 3.86917L5.041 7.6615L3.141 5.7615L2.66917 6.23333L5.041 8.60517ZM6.00217 12C5.1725 12 4.39244 11.8426 3.662 11.5277C2.93167 11.2128 2.29633 10.7854 1.756 10.2457C1.21567 9.70589 0.787944 9.07111 0.472833 8.34133C0.157611 7.61167 0 6.83194 0 6.00217C0 5.1725 0.157444 4.39244 0.472333 3.662C0.787222 2.93167 1.21456 2.29633 1.75433 1.756C2.29411 1.21567 2.92889 0.787944 3.65867 0.472833C4.38833 0.157611 5.16806 0 5.99783 0C6.8275 0 7.60756 0.157445 8.338 0.472334C9.06833 0.787223 9.70367 1.21456 10.244 1.75433C10.7843 2.29411 11.2121 2.92889 11.5272 3.65867C11.8424 4.38833 12 5.16806 12 5.99783C12 6.8275 11.8426 7.60756 11.5277 8.338C11.2128 9.06833 10.7854 9.70367 10.2457 10.244C9.70589 10.7843 9.07111 11.2121 8.34133 11.5272C7.61167 11.8424 6.83194 12 6.00217 12ZM6 11.3333C7.48889 11.3333 8.75 10.8167 9.78333 9.78333C10.8167 8.75 11.3333 7.48889 11.3333 6C11.3333 4.51111 10.8167 3.25 9.78333 2.21667C8.75 1.18333 7.48889 0.666667 6 0.666667C4.51111 0.666667 3.25 1.18333 2.21667 2.21667C1.18333 3.25 0.666667 4.51111 0.666667 6C0.666667 7.48889 1.18333 8.75 2.21667 9.78333C3.25 10.8167 4.51111 11.3333 6 11.3333Z" fill="#BEAA8A"/>
                                        </svg>

                                        ${p.toLowerCase().trim()}
                                    </div>
                                `;
                            });

                            propertiesContent = `
                                <div class='_material-properties'>
                                    ${propertiesBox}
                                </div>
                            `;
                        };
                    };

                    let videoSamplerText = TRANSLATE.box__material.aside_panel_content.material_box.video_sampler__version.desktop;
                    if (isMobile()) {
                        videoSamplerText = TRANSLATE.box__material.aside_panel_content.material_box.video_sampler__version.mobile;
                    };


                    materialsContent += `
                        <div class='_material-box' data-group='${key}' data-spec="${boxFilters.spec.join('|')}" data-colors="${boxFilters.colors.join('|')}">
                            <div class='_material-details'>
                                <div class='_material-name'>
                                    <div class='_title'>
                                        ${TRANSLATE.box__material.aside_panel_content.material_box.fabric} ${key.charAt(0).toUpperCase() + key.slice(1)}
                                    </div>

                                    <div class='_spec'>
                                        ${materialData.basic.attributes}
                                    </div>

                                    <div class='digi-config__aside-panel-open' for='material-video-sampler' data-material-key='${key}'>
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14 9L6.5 13.3301L6.5 4.66987L14 9Z" fill="black"/>
                                            <circle cx="9" cy="9" r="8.5" stroke="black"/>
                                        </svg>
                                        ${videoSamplerText}
                                    </div>
                                </div>

                                ${propertiesContent}

                                <div class='digi-config__aside-panel-open' for='more-about-this-material' data-material-key='${key}' data-material-color-key='${value[0].dataset.techName}'>${TRANSLATE.box__material.more_about_this_material}</div>
                            </div>

                            <div class='_material-colors-list'>
                                ${colorsContent}
                            </div>
                        </div>
                    `;
                };


                // Filters
                let filtersContent = ``;
                let fSpecContent = ``;
                let fColorContent = ``;
                const arrowIcon = `
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.7684 6.84646L8.02392 11.5909L3.27946 6.84646L3.9121 6.21383L8.02392 10.3256L12.1357 6.21383L12.7684 6.84646Z" fill="#656363"/>
                    </svg>
                `;

                filters.spec.forEach((fSPEC, index) => {
                    fSpecContent += `
                        <label index='${index}'>
                            <input type='checkbox' name='properties' value='${fSPEC}'>
                            ${fSPEC}
                        </label>
                    `;
                });

                filters.color.forEach((fCOLOR, index) => {
                    fColorContent += `
                        <label index='${index}'>
                            <input type='checkbox' name='config-color' value='${fCOLOR}'>
                            ${fCOLOR}
                        </label>
                    `;
                });


                if (fSpecContent !== ``) {
                    filtersContent += `
                        <div class='_digi-select' id='digi_filters-spec'>
                            <div class='_select-name'>
                                ${TRANSLATE.box__material.aside_panel_content.filters.fabric_properties.title}
                                <span class='_number'></span>
                                <span class='_arrow'>${arrowIcon}</span>
                            </div>
                            <div class='_select-list'>${fSpecContent}</div>
                        </div>
                    `;
                };

                if (fColorContent !== ``) {
                    filtersContent += `
                        <div class='_digi-select' id='digi_filters-colors'>
                            <div class='_select-name'>
                                ${TRANSLATE.box__material.aside_panel_content.filters.colors.title}
                                <span class='_number'></span>
                                <span class='_arrow'>${arrowIcon}</span>
                            </div>
                            <div class='_select-list'>${fColorContent}</div>
                        </div>
                    `;
                };


                // Product Gallery
                let productGalleryBox = '';
                let isProdGallery = false;

                if (isMobile()) {
                    const prodGallery = returnProductGallery();

                    if (prodGallery) {
                        productGalleryBox = `
                            <div class='_product-gallery digi-pg-loading'>${prodGallery}</div>
                        `;
                        isProdGallery = true;
                    };
                };


                asidePanelData.content = `
                    ${freeFabricSamplesBarContent}
                    
                    <div class='_filters ${isProdGallery ? "_pg-top-cut" : ""}'>
                        ${productGalleryBox}
                        <div class='_selects'>
                            ${filtersContent}
                        </div>
                        <div class='_selected-filters'></div>
                    </div>

                    <div class='_material-content'>
                        ${materialsContent}
                    </div>
                `;

                __EVENTS({
                    ecommerce: {
                        button_name: "wszystkie_tkaniny",
                        button_type: "main",
                        option: '-',
                        view: 0,
                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                    }
                });
            } else if (key === 'pillow_filling') {
                asidePanelData.title = TRANSLATE.box__pillow_filling.aside_panel_content.title;

                asidePanelData.content = `
                    <div>
                        <p>${TRANSLATE.box__pillow_filling.aside_panel_content.description}</p>
                    </div>

                    <div class='desc-content'>
                        <div class='el'>
                            <div class='icon'>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.2547 1.65C20.1469 2.07188 20.0156 2.50313 19.9594 2.61094C19.725 3.10781 19.0312 3.51563 17.2969 4.17188C15.6047 4.80938 14.7281 5.28281 14.0719 5.89688C13.9078 6.04688 13.7625 6.15 13.7484 6.12656C13.7016 6.05156 12.8063 6.13125 12.3047 6.25313C11.9906 6.33281 11.6484 6.46875 11.2734 6.65625C10.3359 7.12969 9.63281 7.77188 8.99063 8.74219C8.83594 8.97188 8.70469 9.16875 8.69531 9.17813C8.68594 9.1875 8.53594 9.21094 8.3625 9.23906C6.95156 9.43125 6.05156 10.2234 5.47031 11.7891C5.08125 12.8297 4.79531 14.2922 4.54688 16.5188L4.45313 17.3578L4.10625 17.7844C3.74063 18.2391 3.38906 18.75 3.15469 19.1719C2.80313 19.8047 2.53125 20.7094 2.53125 21.2344V21.4688H3.02344H3.51563V21.2438C3.51563 20.4656 4.19531 19.125 5.07656 18.1594L5.27344 17.9484L6.10313 17.8969C6.78281 17.8547 7.26562 17.8594 8.84063 17.925C9.975 17.9766 10.95 17.9953 11.2453 17.9766C13.05 17.8594 14.0625 17.3063 14.775 16.0453C14.8922 15.8344 14.9438 15.7922 15.1078 15.75C15.8766 15.5578 16.6641 15.225 17.1469 14.8969C17.4656 14.6813 18.0234 14.1281 18.2578 13.8047C18.7547 13.1109 19.125 11.9719 19.125 11.1328C19.125 10.8891 19.1297 10.8844 19.4578 10.5656C20.1703 9.87656 20.7984 8.86406 21.1125 7.90313C21.3609 7.15781 21.4266 6.69844 21.4547 5.67188C21.4922 4.18125 21.3516 3.33281 20.8031 1.78125C20.6438 1.33125 20.5031 0.942188 20.4844 0.923439C20.4656 0.904688 20.3625 1.23281 20.2547 1.65ZM20.4328 4.28906C20.5078 4.88906 20.4984 6.08438 20.4141 6.58594C20.0813 8.63438 18.9281 10.1391 17.0016 11.0391C16.725 11.1703 16.5 11.2922 16.5 11.3203C16.5 11.3813 16.7859 12.1031 16.8328 12.1594C16.8516 12.1828 17.1375 12.0703 17.4656 11.9109C17.7938 11.7516 18.0703 11.6297 18.0797 11.6391C18.1172 11.6813 17.8922 12.4266 17.7469 12.7266C17.0859 14.1141 15.6 14.8781 13.35 14.9859L12.75 15.0141V15.5016V15.9844H13.2094L13.6641 15.9891L13.3828 16.2469C12.9047 16.6875 12.3844 16.8797 11.4188 16.9734C10.9734 17.0203 10.4766 17.0109 8.91094 16.95C7.8375 16.9078 6.825 16.8656 6.65625 16.8609L6.35156 16.8516L7.00781 16.2938C8.24063 15.2484 9.58125 14.2828 12.6562 12.2063C15.7172 10.1391 16.5656 9.50625 17.4656 8.60625C18.1781 7.89844 18.525 7.34063 18.5672 6.82031L18.5859 6.63281L18.1078 6.61875L17.6297 6.60469L17.5781 6.79219C17.3906 7.48594 16.0453 8.70469 13.6406 10.3453C13.1906 10.6547 12.1266 11.3766 11.2734 11.9531C8.81719 13.6125 7.3875 14.6625 6.1875 15.6938C5.77031 16.0547 5.57813 16.1953 5.57813 16.1391C5.57813 16.0922 5.62969 15.6844 5.69531 15.2344C6.075 12.6047 6.59063 11.2078 7.40156 10.6125C7.61719 10.4531 8.1 10.2422 8.14688 10.2844C8.15625 10.2984 8.11406 10.4578 8.04375 10.6406C7.97813 10.8234 7.92188 11.0016 7.92188 11.0297C7.92188 11.0813 8.79375 11.3813 8.82656 11.3391C8.83594 11.3297 8.925 11.1094 9.02344 10.8516C9.36094 9.95625 9.83438 9.15 10.3688 8.55938C11.0297 7.81875 12.0094 7.27031 12.9047 7.13438C13.1719 7.09219 13.1766 7.09219 13.1484 7.19063C13.0172 7.63594 12.9 8.18906 12.8719 8.47031L12.8438 8.8125H13.3313H13.8234L13.8516 8.5875C13.9641 7.70625 14.1797 7.19531 14.6625 6.70781C15.2344 6.12656 15.975 5.72813 17.7188 5.0625C18.9422 4.59844 19.5563 4.30781 19.9922 3.99844C20.2031 3.84375 20.3297 3.78281 20.3531 3.81563C20.3672 3.84375 20.4047 4.05469 20.4328 4.28906Z" fill="black"/>
                                </svg>
                            </div>

                            <div class='details'>
                                <div class='d-title'>${TRANSLATE.box__pillow_filling.aside_panel_content.option1.title}</div>
                                <div class='d-content'>${TRANSLATE.box__pillow_filling.aside_panel_content.option1.description}</div>
                            </div>
                        </div>

                        <div class='el'>
                            <div class='icon'>
                                <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.3735 1.41211C11.0395 1.54336 10.6176 1.94961 10.4301 2.33711C10.2133 2.78086 10.2016 3.51211 10.4125 3.96211C11.0688 5.37461 12.9321 5.37461 13.5883 3.96211C13.7993 3.51211 13.7875 2.78086 13.5707 2.33711C13.3715 1.93711 12.9555 1.53711 12.6039 1.41211C12.27 1.28711 11.7016 1.29336 11.3735 1.41211ZM12.4692 2.32461C12.9204 2.65586 13.0551 3.19336 12.809 3.65586C12.6625 3.92461 12.2641 4.18711 12.0004 4.18711C11.7368 4.18711 11.3383 3.92461 11.1918 3.65586C10.8461 3.01211 11.2973 2.18711 12.0004 2.18711C12.1879 2.18711 12.3344 2.23086 12.4692 2.32461Z" fill="black"/>
                                    <path d="M15.3464 4.25612C14.7605 4.38112 14.2859 4.78112 14.0339 5.36862C13.8582 5.76862 13.8582 6.48112 14.0281 6.88112C14.3035 7.52487 14.9539 7.99987 15.5457 7.99987H15.8504L15.8796 8.36237C15.9382 9.03737 16.3367 9.64362 16.9109 9.94987C17.2976 10.1499 18.1296 10.1561 18.4812 9.95612C19.0261 9.64362 19.3601 9.18112 19.4773 8.56237L19.5418 8.21862L19.8582 8.18112C20.4851 8.10612 20.948 7.69987 21.1179 7.07487C21.3171 6.35612 21.0007 5.59362 20.3679 5.24362C19.6472 4.84987 18.7156 5.20612 18.3816 6.00612C18.2703 6.26237 18.2234 6.31237 18.1238 6.28737C18.0593 6.26862 17.8836 6.24987 17.7371 6.24987H17.4675L17.4324 5.91237C17.3738 5.31862 16.9754 4.69362 16.4714 4.41237C16.3425 4.34362 15.6277 4.16237 15.6101 4.19362C15.6043 4.19987 15.4871 4.22487 15.3464 4.25612ZM16.2136 5.29362C16.5066 5.53112 16.6004 5.73737 16.6004 6.12487C16.6004 6.53737 16.4949 6.74362 16.1609 6.98112C15.8972 7.18112 15.4343 7.17487 15.1589 6.98112C14.866 6.78112 14.6726 6.32487 14.7195 5.96862C14.825 5.23112 15.657 4.85612 16.2136 5.29362ZM20.0046 6.03112C20.2507 6.13737 20.4089 6.47487 20.3504 6.78737C20.239 7.44362 19.2605 7.49987 19.1023 6.85612C18.991 6.41237 19.2898 5.95612 19.6941 5.94362C19.7527 5.93737 19.8875 5.98112 20.0046 6.03112ZM18.2996 7.33737C18.8328 7.77487 18.8152 8.64362 18.2586 9.08112C18.0183 9.26862 17.532 9.29362 17.2332 9.13112C16.5535 8.76237 16.5242 7.70612 17.1746 7.28112C17.5144 7.05612 17.9832 7.08112 18.2996 7.33737Z" fill="black"/>
                                    <path d="M7.68194 4.35C7.11944 4.56875 6.63311 5.25625 6.56866 5.9125L6.5335 6.25H6.31671C6.19366 6.25 6.01788 6.26875 5.92413 6.2875C5.76007 6.31875 5.74249 6.30625 5.6546 6.075C5.43194 5.475 4.86358 5.0625 4.26593 5.0625C3.00616 5.0625 2.33819 6.65 3.17022 7.6625C3.46319 8.01875 3.67999 8.1375 4.11944 8.18125L4.471 8.21875L4.50616 8.50625C4.58233 9.08125 4.93975 9.60625 5.44952 9.9125C5.73077 10.075 5.8128 10.0938 6.28741 10.0938C6.72686 10.0938 6.86163 10.0687 7.10186 9.94375C7.67608 9.64375 8.0628 9.0375 8.1214 8.3625L8.15069 8H8.45538C9.04718 8 9.69757 7.525 9.97296 6.88125C10.1429 6.48125 10.1429 5.76875 9.9671 5.36875C9.80304 4.975 9.48663 4.61875 9.14679 4.4375C8.79522 4.24375 8.0628 4.2 7.68194 4.35ZM8.8421 5.26875C9.05889 5.41875 9.30499 5.875 9.30499 6.125C9.30499 6.375 9.05889 6.83125 8.8421 6.98125C8.56671 7.18125 8.10968 7.18125 7.84015 6.98125C7.50616 6.74375 7.40069 6.5375 7.40069 6.125C7.40069 5.7125 7.50616 5.50625 7.84015 5.2625C8.10968 5.06875 8.56671 5.06875 8.8421 5.26875ZM4.7171 6.1375C5.14483 6.56875 4.88116 7.3125 4.29522 7.3125C3.79718 7.3125 3.51007 6.84375 3.70343 6.35C3.86163 5.94375 4.40655 5.825 4.7171 6.1375ZM6.78546 7.26875C7.08429 7.4375 7.3128 7.83125 7.3128 8.175C7.3128 8.53125 7.10186 8.91875 6.8089 9.1C6.58624 9.2375 6.49249 9.2625 6.22296 9.2375C5.71319 9.19375 5.38507 8.85625 5.33233 8.325C5.30304 7.95625 5.39093 7.63125 5.57257 7.45C5.92413 7.1 6.36944 7.03125 6.78546 7.26875Z" fill="black"/>
                                    <path d="M11.4322 9.23721C9.96153 9.79971 9.83849 11.9372 11.2272 12.6685C11.7018 12.9185 12.2994 12.9185 12.774 12.6685C13.401 12.3372 13.7291 11.7685 13.7291 10.9997C13.7291 10.4685 13.6061 10.1122 13.2955 9.73096C12.8736 9.22471 12.0475 8.99971 11.4322 9.23721ZM12.3697 10.0872C12.9791 10.356 13.1197 11.181 12.6451 11.6872C12.2584 12.0997 11.7311 12.106 11.3502 11.6935C10.6236 10.9247 11.4264 9.66221 12.3697 10.0872Z" fill="black"/>
                                    <path d="M5.72522 11.9563C5.06311 12.2188 4.60022 12.8063 4.50647 13.4938L4.47131 13.7813L4.14905 13.8188C3.51623 13.8938 3.05334 14.2938 2.88342 14.925C2.56116 16.1 3.58655 17.1938 4.68811 16.85C5.09241 16.725 5.44983 16.3938 5.61975 15.9938C5.74866 15.7 5.76623 15.6813 5.92444 15.7125C6.01819 15.7313 6.19397 15.75 6.31701 15.75H6.53381L6.56897 16.0875C6.65686 17.0313 7.44201 17.775 8.3385 17.7625C9.87366 17.75 10.6764 15.8438 9.66272 14.6063C9.39319 14.2813 8.83655 14 8.45569 14H8.151L8.1217 13.6375C8.06311 12.9625 7.67053 12.3563 7.10217 12.0563C6.75647 11.875 6.0592 11.825 5.72522 11.9563ZM6.8092 12.8938C7.07873 13.0563 7.31311 13.475 7.31311 13.8C7.31311 14.575 6.52209 15.1063 5.86584 14.775C5.14514 14.4063 5.14514 13.175 5.87756 12.8375C6.15295 12.7063 6.54553 12.7313 6.8092 12.8938ZM4.7467 14.85C5.09826 15.1938 4.89319 15.9375 4.41272 16.0375C3.59826 16.2 3.32873 14.925 4.12561 14.6938C4.32483 14.6375 4.5885 14.7063 4.7467 14.85ZM8.84241 15.0188C9.13537 15.2188 9.32873 15.675 9.28186 16.0313C9.15295 16.9438 8.05725 17.1875 7.52405 16.4188C7.4303 16.2875 7.401 16.15 7.401 15.875C7.401 15.4625 7.50647 15.2563 7.84045 15.0125C8.10412 14.8188 8.56701 14.825 8.84241 15.0188Z" fill="black"/>
                                    <path d="M17.0046 11.9996C16.407 12.2496 15.9441 12.9308 15.8796 13.6371L15.8504 13.9996H15.5457C14.9539 13.9996 14.3035 14.4746 14.0281 15.1183C13.8582 15.5183 13.8582 16.2308 14.0339 16.6308C14.198 17.0246 14.5144 17.3808 14.8543 17.5621C15.2234 17.7621 15.8562 17.8058 16.2664 17.6621C16.8699 17.4496 17.3679 16.7746 17.4324 16.0871L17.4675 15.7496L17.7488 15.7371C17.907 15.7308 18.0945 15.7246 18.1648 15.7246C18.2644 15.7183 18.3113 15.7683 18.3523 15.9371C18.3875 16.0558 18.5339 16.2871 18.6863 16.4496C19.7527 17.5871 21.5398 16.4683 21.1238 14.9308C20.948 14.2871 20.4793 13.8808 19.8523 13.8121L19.53 13.7808L19.4949 13.4933C19.4187 12.9183 19.0613 12.3871 18.5515 12.0933C18.1355 11.8496 17.4558 11.8121 17.0046 11.9996ZM18.2937 12.9621C18.5691 13.1808 18.6804 13.4246 18.6804 13.7808C18.6804 14.3871 18.323 14.8121 17.7722 14.8621C17.5086 14.8871 17.4089 14.8621 17.1921 14.7246C16.8992 14.5433 16.6882 14.1558 16.6882 13.7996C16.6882 13.4808 16.9226 13.0558 17.1921 12.8871C17.5144 12.6871 17.9949 12.7183 18.2937 12.9621ZM20.1804 14.8808C20.6199 15.3183 20.1921 16.1558 19.5945 16.0371C19.2371 15.9621 19.0027 15.5371 19.0964 15.1496C19.2254 14.6558 19.8113 14.5121 20.1804 14.8808ZM16.1609 15.0121C16.4949 15.2558 16.6004 15.4621 16.6004 15.8746C16.6004 16.2871 16.4949 16.4933 16.1609 16.7308C15.9324 16.8996 15.4812 16.9246 15.2293 16.7808C14.9656 16.6371 14.7664 16.3371 14.7195 16.0308C14.6726 15.6746 14.866 15.2183 15.1589 15.0183C15.4343 14.8246 15.8972 14.8183 16.1609 15.0121Z" fill="black"/>
                                    <path d="M11.5311 17.1186C11.0272 17.2936 10.6522 17.6311 10.4119 18.1248C10.2244 18.5123 10.2186 19.2748 10.4002 19.6936C10.5584 20.0686 10.9041 20.4311 11.2674 20.6248C11.6776 20.8373 12.3221 20.8373 12.7323 20.6248C13.3826 20.2873 13.7283 19.7061 13.7283 18.9373C13.7283 17.8873 13.0604 17.1311 12.0877 17.0873C11.8651 17.0748 11.6131 17.0873 11.5311 17.1186ZM12.369 18.0248C12.7674 18.1998 12.9959 18.6748 12.9139 19.1561C12.8612 19.4436 12.5506 19.7811 12.2459 19.8748C11.9178 19.9811 11.5721 19.8748 11.3143 19.5873C10.6405 18.8186 11.4549 17.6123 12.369 18.0248Z" fill="black"/>
                                </svg>
                            </div>

                            <div class='details'>
                                <div class='d-title'>${TRANSLATE.box__pillow_filling.aside_panel_content.option2.title}</div>
                                <div class='d-content'>${TRANSLATE.box__pillow_filling.aside_panel_content.option2.description}</div>
                            </div>
                        </div>
                    </div>
                `;

                __EVENTS({
                    ecommerce: {
                        button_name: "wypełnienie_poduszek",
                        button_type: "main",
                        option: '-',
                        view: 0,
                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                    }
                });
            } else if (key === 'mattress') {
                asidePanelData.title = TRANSLATE.box__mattress.choose_mattress;
                closeBtnCopy = TRANSLATE.aside_panel.header.save_and_close;

                const mattressInputs = FRONT_PANEL.attributes.find(el => attrKeys.mattress.includes(Object.keys(el)[0]));
                let mattressContent = ``;

                mattressInputs[Object.keys(mattressInputs)[0]].forEach(mattressInput => {
                    let foundMattressData = MATTRESS_DATA.find(el => MATTRESS_TECH_NAME_MAP[el.handle][WEB_LANG].includes(mattressInput.value));
                    if (!foundMattressData) {
                        foundMattressData = MATTRESS_DATA.find(el => el.name.trim().toLowerCase() === mattressInput.value.trim().toLowerCase());
                    };

                    if (!foundMattressData) return;

                    let price = foundMattressData.price;
                    price = formatPrice(price);

                    let image = '';
                    if (foundMattressData.image) {
                        image = `
                            <div class='_image'>
                                <img src='${foundMattressData.image}' alt=''>
                            </div>
                        `;
                    };

                    let hardnessSelect = ``;
                    const specOptions = [];

                    if (foundMattressData.height) {
                        specOptions.push({
                            icon: `
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 4L12 20M12 4L9 8M12 4L15 8M12 20L15 16M12 20L9 16" stroke="#2B2D53" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            `,
                            name: `${foundMattressData.height} cm ${TRANSLATE.box__mattress.aside_panel_content.X_cm_height}`,
                        });
                    };

                    if (foundMattressData.hardnesses?.length > 0) {
                        let hardenssOptions = ``;

                        const langRules = returnLangRules(foundMattressData?.hardnesses?.length, TRANSLATE.box__mattress.aside_panel_content.X_types_of_hardness_to_choose);
                        specOptions.push({
                            icon: `
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="2.36963" y1="18.6367" x2="21.6303" y2="18.6367" stroke="#2B2D53" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M2.84082 13.8271C9.79968 15.0756 13.8554 15.0292 21.1591 13.8271" stroke="#2B2D53" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M4.06207 9.19434C10.2636 12.2259 13.7396 12.0983 19.9379 9.19434" stroke="#2B2D53" stroke-width="1.5" stroke-linecap="round"/>
                                    <circle cx="11.9999" cy="5.44609" r="1.83183" fill="#2B2D53"/>
                                </svg>
                            `,
                            name: `${foundMattressData?.hardnesses?.length} ${langRules}`
                        });

                        foundMattressData.hardnesses.forEach((h, index) => {
                            let isSelected = index === 0 ? true : false;

                            if (mattressInput.checked) {
                                if (CURRENT_INPUTS_DATA['hardness'] && CURRENT_INPUTS_DATA['hardness'] === h.handle) {
                                    isSelected = true;
                                } else {
                                    isSelected = index === 0 ? true : false;
                                };
                            };

                            hardenssOptions += `
                                <option ${isSelected ? 'selected' : ''} value='${h.handle}'>${h.name}</option>
                            `;
                        });

                        hardnessSelect = `
                            <select>
                                ${hardenssOptions}
                            </select>
                        `;
                    };

                    let specOptionsContent = ``;
                    if (specOptions.length > 0) {
                        let specOption = ``;
                        specOptions.forEach(so => {
                            specOption += `
                                <div class='_spec-single-option'>
                                    <div class='_icon'>${so.icon}</div>
                                    <div class='_name'>${so.name}</div>
                                </div>
                            `;
                        });

                        specOptionsContent = `
                            <div class='_spec-options'>
                                ${specOption}
                            </div>
                        `;
                    };

                    let descriptionContent = ``;
                    if (foundMattressData.description?.short?.children) {
                        let shortDescContent = ``;

                        foundMattressData.description?.short?.children.forEach(textObj => {
                            shortDescContent += textObj.value;
                        });

                        descriptionContent = `
                            <div class='_short-description'>
                                ${shortDescContent}
                            </div>

                            <button class='_read-more digi-config__aside-panel-open' for='more-about-mattress' data-mattress-key='${foundMattressData.handle}'>${TRANSLATE.box__mattress.aside_panel_content.read_more}</button>
                        `;
                    };

                    mattressContent += `
                        <label class='digi__mattress ${mattressInput.checked ? "digi-checked" : ""}' data-tech-name='${foundMattressData.handle}'>
                            <input type='radio' name='${mattressInput.name}' value='${mattressInput.value}' data-price='${price}'>

                            ${image}
                            <div class='_details'>
                                <div class='_name'>
                                    <div class='_title'>${foundMattressData.name}</div>
                                    <div class='_price'>+${price} ${CURRENCY}</div>
                                </div>

                                ${specOptionsContent}

                                ${hardnessSelect}

                                ${descriptionContent}
                            </div>
                        </label>
                    `;
                });

                asidePanelData.content = `
                    <div class='mattress-help-bar'>
                        <div class='_title'>${TRANSLATE.box__mattress.mattress}</div>
                        <div class='digi-config__aside-panel-open' for='mattress-help'>${TRANSLATE.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.cta}</div>
                    </div>
                    ${mattressContent}
                `;

                __EVENTS({
                    ecommerce: {
                        button_name: "wybierz_materac",
                        button_type: "main",
                        option: '-',
                        view: 0,
                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                    }
                });
            } else if (key === 'more-about-mattress') {
                const foundMattressData = MATTRESS_DATA.find(el => el.handle.trim().toLowerCase() === customData.mattressKey.trim().toLowerCase());

                asidePanelData.title = foundMattressData.name;

                let descriptionContent = ``;
                if (foundMattressData.description?.short?.children) {
                    let shortDescContent = ``;

                    foundMattressData.description?.short?.children.forEach(textObj => {
                        shortDescContent += textObj.value;
                    });

                    descriptionContent = `
                        <div class='_short-description'>
                            ${shortDescContent}
                        </div>
                    `;
                };

                let attrsContent = ``;
                if (foundMattressData.attrs) {
                    foundMattressData.attrs.forEach(attr => {
                        attrsContent += `
                            <div class='_attr'>
                                <div class='_icon'>
                                    <img src='${attr.icon}' alt=''>
                                </div>

                                <div class='_details'>
                                    <div class='_name'>${attr.name}</div>
                                    <div class='_desc'>${attr.desc}</div>
                                </div>
                            </div>
                        `;
                    });

                    attrsContent = `
                        <div class='_attrs'>
                            ${attrsContent}
                        </div>
                    `;
                };

                asidePanelData.content = `
                    ${descriptionContent}

                    <div class='_image-and-attrs'>
                        <div class='_image'>
                            <img src='${foundMattressData.image}' alt=''>
                        </div>

                        ${attrsContent}
                    </div>

                    <div class='digi-size-table'>
                        ${getMattressSpecTableContent({ rawContent: foundMattressData.description.tableArray }).content}
                    </div>
                `;

                __EVENTS({
                    ecommerce: {
                        button_name: "wiece_o_tym_materacu__czytaj_wiecej",
                        button_type: "main",
                        mattress_name: foundMattressData.name,
                        option: '-',
                        view: 1,
                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                    }
                });
            } else if (key === 'mattress-help') {
                asidePanelData.title = TRANSLATE.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.cta;

                const firmnessTable = {
                    unit: {
                        columns: 'kg',
                        rows: 'cm'
                    },
                    female: {
                        columns: ['50', '60', '70', '80', '90', '100', '>100'],
                        rows: ['150', '160', '170', '180', '190', '200', '>200'],
                        data: [
                            ['H2', 'H3', 'H3', 'H3', 'H4', 'H4', 'H4'],
                            ['H2', 'H3', 'H3', 'H3', 'H3', 'H4', 'H4'],
                            ['H2', 'H2', 'H3', 'H3', 'H3', 'H4', 'H4'],
                            ['H2', 'H2', 'H2', 'H3', 'H3', 'H3', 'H4'],
                            ['H2', 'H2', 'H2', 'H2', 'H3', 'H3', 'H4'],
                            ['H2', 'H2', 'H2', 'H2', 'H2', 'H3', 'H4'],
                            ['H2', 'H2', 'H2', 'H2', 'H2', 'H2', 'H4']
                        ]
                    },
                    male: {
                        columns: ['50', '60', '70', '80', '90', '100', '>100'],
                        rows: ['150', '160', '170', '180', '190', '200', '>200'],
                        data: [
                            ['H2', 'H3', 'H3', 'H3', 'H4', 'H4', 'H4'],
                            ['H2', 'H3', 'H3', 'H3', 'H3', 'H4', 'H4'],
                            ['H2', 'H2', 'H3', 'H3', 'H3', 'H4', 'H4'],
                            ['H2', 'H2', 'H2', 'H3', 'H3', 'H3', 'H4'],
                            ['H2', 'H2', 'H2', 'H2', 'H3', 'H3', 'H4'],
                            ['H2', 'H2', 'H2', 'H2', 'H2', 'H3', 'H4'],
                            ['H2', 'H2', 'H2', 'H2', 'H2', 'H2', 'H4']
                        ]
                    }
                };

                const getFirmnessTableHTML = (variant) => {
                    if (!variant || !firmnessTable) return;

                    const tableData = firmnessTable?.[variant];
                    if (!tableData) return '';

                    const escapeHtml = (value) =>
                        String(value)
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;')
                            .replace(/'/g, '&#39;');

                    const columnUnit = firmnessTable?.unit?.columns ? ` ${escapeHtml(firmnessTable.unit.columns)}` : '';
                    const rowUnit = firmnessTable?.unit?.rows ? ` ${escapeHtml(firmnessTable.unit.rows)}` : '';

                    const headHtml = tableData.columns
                        .map(col => `<th>${escapeHtml(col)}${columnUnit}</th>`)
                        .join('');

                    const bodyHtml = tableData.rows
                        .map((row, rowIndex) => {
                            const cellsHtml = tableData.data[rowIndex]
                                .map(cell => `<td firmness="${String(cell).toLowerCase()}">${escapeHtml(cell)}</td>`)
                                .join('');

                            return `
                                <tr>
                                    <th>${escapeHtml(row)}${rowUnit}</th>
                                    ${cellsHtml}
                                </tr>
                            `;
                        })
                        .join('');

                    return `
                        <table class='_table'>
                            <thead>
                                <tr>
                                    <th></th>
                                    ${headHtml}
                                </tr>
                            </thead>
                            <tbody>
                                ${bodyHtml}
                            </tbody>
                        </table>
                    `;
                };

                asidePanelData.content = `
                    <div class='_short-description'>
                        <p>${TRANSLATE.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.description.p1}</p>
                        <p>${TRANSLATE.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.description.p2}</p>
                    </div>

                    <div class='_legend'>
                        <div class='_firmness' firmness='H2'>H2 - ${TRANSLATE.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.legend.firmness.h2}</div>
                        <div class='_firmness' firmness='H3'>H3 - ${TRANSLATE.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.legend.firmness.h3}</div>
                        <div class='_firmness' firmness='H4'>H4 - ${TRANSLATE.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.legend.firmness.h4}</div>
                    </div>

                    <div class='_firmness-table'>
                        <div class='_name'>${TRANSLATE.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.firmnessTable.title.female}</div>
                        ${getFirmnessTableHTML('female')}
                    </div>

                    <div class='_firmness-table'>
                        <div class='_name'>${TRANSLATE.box__mattress.aside_panel_content.how_to_choose_a_mattress_and_firmness.firmnessTable.title.male}</div>
                        ${getFirmnessTableHTML('male')}
                    </div>
                `;

                __EVENTS({
                    ecommerce: {
                        button_name: "jak_wybrac_materac_i_twardosc",
                        button_type: "main",
                        option: '-',
                        view: 1,
                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                    }
                });
            } else if (key === 'material-video-sampler') {
                asidePanelData.title = TRANSLATE.box__material.aside_panel_content.material_box.video_sampler__version.desktop;

                if (customData?.materialKey)

                    asidePanelData.content = `
                    ${freeFabricSamplesBarContent}

                    ${__getMaterialData({ name: customData.materialKey }).basic.video}
                `;

                __EVENTS({
                    ecommerce: {
                        button_name: "probnik_na_video",
                        button_type: "main",
                        option: '-',
                        view: 1,
                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                    }
                });
            } else if (key === 'material-preview') {
                asidePanelData.title = TRANSLATE.box__material.aside_panel_content.material_preview.title;

                asidePanelData.content = `
                    ${freeFabricSamplesBarContent}
                    
                    <div class='_material-preview'>
                        ${__getMaterialData({ color: customData.colorKey }).basic.color.image}
                    </div>
                `;

                __EVENTS({
                    ecommerce: {
                        button_name: "podglad_tkaniny",
                        button_type: "main",
                        option: '-',
                        view: 1,
                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                    }
                });
            }

            let asidePanelOverlay = ``;
            if (!document.querySelector('.digi-configurator__aside-panel-overlay')) {
                asidePanelOverlay = `
                    <div class='digi-configurator__aside-panel-overlay fade' id='digi-aside-panel-overlay__${key}'></div>
                `;
            };

            const asideTemp = `
            	<aside class='digi-configurator__aside-panel move' id='digi-aside-panel__${key}'>
                	<div class='digi-header'>
                    	<div class='digi-title'>${asidePanelData.title}</div>
                        <div class='digi-close-btn'>
                        	<span class='icon'>
                            	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                	<path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z"/>
                                </svg>
                            </span>
                            ${closeBtnCopy}
                        </div>
                    </div>
                    <div class='digi-content'>
                        ${asidePanelData.content}
                    </div>
                </aside>
                ${asidePanelOverlay}
            `;

            const placement = document.querySelector('section .page-width > .product');
            if (!placement) return;

            placement.insertAdjacentHTML('beforeend', asideTemp);
            const asideEl = document.querySelector(`#digi-aside-panel__${key}`);

            let customParams = {
                height: null,
                class: null
            };

            if (isWideWindow()) {
                const topDistance = asideEl.getBoundingClientRect().top + window.scrollY;
                const margin = 10;
                const height = window.innerHeight - topDistance - margin;

                customParams.height = `${height}px`;
                customParams.class = 'digi-wide-screen-style';
            };

            asideEl.style.height = customParams.height ? customParams.height : '100%';
            customParams.class ? asideEl.classList.add(customParams.class) : null;

            setTimeout(() => {
                document.querySelector(`#digi-aside-panel__${key}.move`).classList.remove('move');
                document.querySelector(`.digi-configurator__aside-panel-overlay#digi-aside-panel-overlay__${key}`)?.classList.remove('fade');
            }, 100);

            const removeAsidePanel = (removeAll) => {
                const elementsToRemove = {
                    panels: [],
                    overlays: []
                };

                if (removeAll) {
                    elementsToRemove.panels = Array.from(document.querySelectorAll(`.digi-configurator__aside-panel`));
                    elementsToRemove.overlays = Array.from(document.querySelectorAll(`.digi-configurator__aside-panel-overlay`));
                } else {
                    elementsToRemove.panels = [document.querySelector(`#digi-aside-panel__${key}`)];
                    elementsToRemove.overlays = [document.querySelector(`.digi-configurator__aside-panel-overlay#digi-aside-panel-overlay__${key}`)];
                };

                elementsToRemove.panels.forEach(panel => {
                    panel?.classList.add('move');
                });

                elementsToRemove.overlays.forEach(overlay => {
                    overlay?.classList.add('fade');
                });

                setTimeout(() => {
                    elementsToRemove.panels.forEach(panel => {
                        panel?.remove();
                    });

                    elementsToRemove.overlays.forEach(overlay => {
                        overlay?.remove();
                    });

                    if (!document.querySelector('.digi-configurator__aside-panel')) {
                        document.body.classList.remove('__digi-configurator__fixed-view');
                        __webBadges(false);
                    };
                }, 400);


                __EVENTS({
                    ecommerce: {
                        button_name: "zamknij",
                        button_type: "detail",
                        option: '-',
                        closed_by_overlay: removeAll ? true : false,
                        view: 1,
                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                    }
                });
            };

            document.querySelector(`#digi-aside-panel__${key} .digi-header .digi-close-btn`).addEventListener('click', function () {
                removeAsidePanel();
            });

            document.querySelector(`.digi-configurator__aside-panel-overlay#digi-aside-panel-overlay__${key}`)?.addEventListener('click', function () {
                removeAsidePanel(true);
            });


            const __asidePanelLogic = (keyName) => {
                if (!keyName) return;
                const box = document.querySelector(`#digi-aside-panel__${key}`);
                let isImgSrcError = false;

                const setImageWithFallback = (imgEl, targetSrc, fallbackSrc) => {
                    if (isImgSrcError) return;

                    imgEl.onerror = () => {
                        imgEl.onerror = null;
                        imgEl.src = fallbackSrc;
                        isImgSrcError = true;
                    };

                    imgEl.src = targetSrc;
                };

                if (keyName === 'size-table' || keyName === 'width') {
                    let sleepingWidthOrTotalWidth = null;

                    if (keyName === 'size-table') {
                        sleepingWidthOrTotalWidth = 'sleeping';
                    } else if (keyName === 'width') {
                        sleepingWidthOrTotalWidth = 'total';
                    };

                    const labels = Array.from(box.querySelectorAll(`.digi-size-select .digi-box-label`));
                    if (!labels.length) return;

                    const selectedSize = labels.find(l => l.classList.contains('digi-checked'))?.dataset.value;
                    if (selectedSize) {
                        const sizeTableContent__loaded = getSizeTableContent({ isSize: true, size: selectedSize, sleepingWidthOrTotalWidth: sleepingWidthOrTotalWidth });

                        setImageWithFallback(
                            box.querySelector('.img-mask img.background-img'),
                            sizeTableContent__loaded.image,
                            sizeTableContent__loaded.currentImgSrc
                        );
                    };

                    labels.forEach(labelEl => {
                        labelEl.addEventListener('click', function () {
                            box.querySelector('.digi-box-label.digi-checked').classList.remove('digi-checked');
                            labelEl.classList.add('digi-checked');

                            const newSizeTableContent = getSizeTableContent({ isSize: true, size: this.dataset.value, sleepingWidthOrTotalWidth: sleepingWidthOrTotalWidth });
                            if (box.querySelector('.img-mask img.sizeMask-img') && newSizeTableContent.mask) {
                                box.querySelector('.img-mask img.sizeMask-img').src = newSizeTableContent.mask;
                            };

                            setImageWithFallback(
                                box.querySelector('.img-mask img.background-img'),
                                newSizeTableContent.image,
                                newSizeTableContent.currentImgSrc
                            );

                            box.querySelector('.digi-size-table').innerHTML = newSizeTableContent.content;

                            __EVENTS({
                                ecommerce: {
                                    button_name: "pelne_wymiary",
                                    button_type: "detail",
                                    option: this.dataset.value,
                                    view: 1,
                                    etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                }
                            });
                        });
                    });
                } else if (keyName === 'mattress') {
                    // Firmness Table
                    const mattressHelpBtn = box.querySelector('.digi-config__aside-panel-open[for="mattress-help"]');
                    if (mattressHelpBtn) {
                        mattressHelpBtn.addEventListener('click', function () {
                            __createAsidePanel(this.getAttribute('for'), false, {
                                etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                            });
                        });
                    };

                    const inputs = Array.from(box.querySelectorAll(`.digi__mattress input[type='radio']`));
                    if (!inputs.length) return;

                    const mattressOpenAsidePanelBtn = document.querySelector('#digi-new-configurator .digi-config__box .digi-config__aside-panel-open[for="mattress"]:not([custom-open])');
                    const changeMattressBtn = document.querySelector('#digi-new-configurator .digi-config__box .digi-config__aside-panel-open[for="mattress"][custom-open]');


                    inputs.forEach(inputEl => {
                        let mattressName = null;

                        // Mattress
                        inputEl.addEventListener('change', function () {
                            const configElement = configElements.find(el => el.dataset.type === inputEl.name);
                            if (!configElement) return;

                            const originalInput__mattress = configElement.querySelector(`fieldset input[name='${inputEl.name}'][value='${inputEl.value}']`);
                            if (!originalInput__mattress) return;

                            originalInput__mattress.click();

                            const noMattressBox = document.querySelector('#digi-new-configurator .digi-mattress-box.no-mattress-option');

                            const foundEntry = Object.entries(MATTRESS_TECH_NAME_MAP).find(([key, translations]) => {
                                return translations[WEB_LANG.toLowerCase().trim()]?.includes(inputEl.value);
                            });
                            const mattressPolishName = foundEntry?.[1]?.pl?.[0];
                            mattressName = mattressPolishName;

                            if (noMattressBox) {
                                if (noMattressBox.dataset.value.trim().toLowerCase() === inputEl.value.trim().toLowerCase()) {
                                    noMattressBox.classList.add('digi-checked');


                                    if (mattressOpenAsidePanelBtn) {
                                        mattressOpenAsidePanelBtn.classList.remove('digi-checked');
                                        mattressOpenAsidePanelBtn.querySelector('._title ._mattress-name[data-default-value]').textContent = mattressOpenAsidePanelBtn.querySelector('._title ._mattress-name[data-default-value]').dataset.defaultValue;
                                        mattressOpenAsidePanelBtn.querySelector('._title ._mattress-price[data-default-value]').textContent = mattressOpenAsidePanelBtn.querySelector('._title ._mattress-price[data-default-value]').dataset.defaultValue;
                                        mattressOpenAsidePanelBtn.querySelector('.img img[src][data-default-value]').src = mattressOpenAsidePanelBtn.querySelector('.img img[src][data-default-value]').dataset.defaultValue;
                                    };

                                    if (changeMattressBtn) {
                                        changeMattressBtn.classList.add('digi-hidden');
                                    };

                                    CURRENT_INPUTS_DATA['hardness'] = null;

                                    __EVENTS({
                                        ecommerce: {
                                            button_name: "wybierz_material",
                                            button_type: "detail",
                                            option: MATTRESS_TECH_NAME_MAP['brak-materaca']['pl'][0],
                                            view: 1,
                                            etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                        }
                                    });
                                } else {
                                    noMattressBox.classList.remove('digi-checked');

                                    if (mattressOpenAsidePanelBtn) {
                                        mattressOpenAsidePanelBtn.classList.add('digi-checked');
                                        const newMattressName = removeWords(inputEl.value, attrKeys.mattress).trim();
                                        mattressOpenAsidePanelBtn.querySelector('._title ._mattress-name[data-default-value]').textContent = newMattressName.charAt(0).toUpperCase() + newMattressName.slice(1);
                                        mattressOpenAsidePanelBtn.querySelector('._title ._mattress-price[data-default-value]').textContent = `+${inputEl.dataset.price} ${CURRENCY}`;
                                        mattressOpenAsidePanelBtn.querySelector('.img img[src][data-default-value]').src = inputEl.parentNode.querySelector('._image img').src;
                                    };

                                    if (changeMattressBtn) {
                                        changeMattressBtn.classList.remove('digi-hidden');
                                    };

                                    __EVENTS({
                                        ecommerce: {
                                            button_name: "wybierz_material",
                                            button_type: "detail",
                                            option: mattressPolishName,
                                            view: 1,
                                            etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                        }
                                    });
                                };
                            };


                            // Auto Select For Hardness
                            const hardnessSelect = inputEl.parentNode.querySelector('select');
                            if (hardnessSelect) {
                                const configElement = configPanel;
                                if (!configElement) return;

                                const originalInput__hardness = configElement.querySelector(`fieldset input[name][type='radio'][data-tech-name='${hardnessSelect.querySelectorAll('option')[hardnessSelect.selectedIndex].value}']`);
                                if (!originalInput__hardness) return;

                                originalInput__hardness.click();
                                CURRENT_INPUTS_DATA['hardness'] = originalInput__hardness.dataset.techName;
                            };

                            box.querySelector('.digi__mattress.digi-checked').classList.remove('digi-checked');
                            inputEl.parentNode.classList.add('digi-checked');

                            CURRENT_INPUTS_DATA[keyName] = inputEl.value;
                            CURRENT_INPUTS_DATA['mattress-price'] = inputEl.dataset.price;
                        });

                        // Manual Box Hardness
                        inputEl.parentNode.querySelector('select')?.addEventListener('change', function () {
                            if (inputEl.parentNode.classList.contains('digi-checked')) {
                                const configElement = configPanel;
                                if (!configElement) return;

                                const originalInput__hardness = configElement.querySelector(`fieldset input[name][type='radio'][data-tech-name='${this.querySelectorAll('option')[this.selectedIndex].value}']`);
                                if (!originalInput__hardness) return;

                                originalInput__hardness.click();
                                CURRENT_INPUTS_DATA['hardness'] = this.value;

                                __EVENTS({
                                    ecommerce: {
                                        button_name: "twardosc_materaca",
                                        button_type: "detail",
                                        mattress: mattressName,
                                        option: CURRENT_INPUTS_DATA['hardness'],
                                        view: 1,
                                        etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                    }
                                });
                            };
                        });
                    });


                    // Read More
                    const readMoreBtns = Array.from(box.querySelectorAll('.digi-config__aside-panel-open[for="more-about-mattress"]'));
                    if (readMoreBtns.length > 0) {
                        readMoreBtns.forEach(btn => {
                            btn.addEventListener('click', function () {
                                if (!this.dataset.mattressKey) return;

                                __createAsidePanel(this.getAttribute('for'), false, {
                                    mattressKey: this.dataset.mattressKey,
                                    etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                });
                            });
                        });
                    };
                } else if (keyName === 'all-materials') {
                    // Product Gallery
                    const filtersBox = box.querySelector('._filters');
                    const prodGalleryBox = filtersBox?.querySelector('._product-gallery');
                    if (prodGalleryBox) {
                        setTimeout(() => {
                            const gallery = returnProductGallery();

                            if (gallery) {
                                filtersBox.classList.add("_pg-top-cut");
                                prodGalleryBox.classList.remove('digi-pg-loading');
                                prodGalleryBox.innerHTML = gallery;
                                initProductGallerySlider(box);
                            };
                        }, 1000);
                    };

                    // Image loading
                    const imgRows = Array.from(box.querySelectorAll('._material-box ._material-colors-list'));
                    if (imgRows.length > 0) {
                        const scrollRoot = box.querySelector('.digi-content') || box;

                        const rowObserver = new IntersectionObserver((entries, observer) => {
                            entries.forEach(entry => {
                                if (!entry.isIntersecting) return;

                                const row = entry.target;
                                const images = Array.from(row.querySelectorAll('img[data-src]'));

                                images.forEach(image => {
                                    const src = image.dataset.src;
                                    if (!src) return;

                                    image.src = src;
                                    image.removeAttribute('data-src');
                                });

                                observer.unobserve(row);
                            });
                        }, {
                            root: scrollRoot,
                            rootMargin: '0px',
                            threshold: 0.01
                        });

                        imgRows.forEach(row => {
                            rowObserver.observe(row);
                        });
                    }

                    // More about this material - button
                    const moreAboutThisMaterialBtn = Array.from(box.querySelectorAll('.digi-config__aside-panel-open[for="more-about-this-material"]'));
                    if (moreAboutThisMaterialBtn.length > 0) {
                        moreAboutThisMaterialBtn.forEach(btn => {
                            btn.addEventListener('click', function () {
                                if (!this.dataset.materialKey || !this.dataset.materialColorKey) return;

                                __createAsidePanel(this.getAttribute('for'), false, {
                                    materialKey: this.dataset.materialKey,
                                    materialColorKey: this.dataset.materialColorKey,
                                    etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                });
                            });
                        });
                    };


                    // Material preview - button
                    const materialPreviewBtn = Array.from(box.querySelectorAll('.digi-config__aside-panel-open[for="material-preview"]'));
                    if (materialPreviewBtn.length > 0) {
                        materialPreviewBtn.forEach(btn => {
                            btn.addEventListener('click', function () {
                                if (!this.dataset.colorTechName) return;

                                __createAsidePanel(this.getAttribute('for'), false, {
                                    colorKey: this.dataset.colorTechName,
                                    etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                });
                            });
                        });
                    };


                    // Video sampler
                    const videoSamplerBtn = Array.from(box.querySelectorAll('.digi-config__aside-panel-open[for="material-video-sampler"]'));
                    if (videoSamplerBtn.length > 0) {
                        videoSamplerBtn.forEach(btn => {
                            btn.addEventListener('click', function () {
                                if (!this.dataset.materialKey) return;

                                __createAsidePanel(this.getAttribute('for'), false, {
                                    materialKey: this.dataset.materialKey,
                                    etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                });
                            });
                        })
                    };


                    // Filters
                    const materialsContent = box.querySelector('._material-content');
                    const applyFilters = () => {
                        const materialBoxes = Array.from(
                            materialsContent.querySelectorAll('._material-box')
                        );

                        materialBoxes.forEach(box => {
                            const specData = (box.dataset.spec || '').split('|').filter(Boolean);
                            const colorsData = (box.dataset.colors || '').split('|').filter(Boolean);

                            const matchesSpec =
                                activeFilters.spec.length === 0 ||
                                activeFilters.spec.some(value => specData.includes(value));

                            const matchesColors =
                                activeFilters.colors.length === 0 ||
                                activeFilters.colors.some(value => colorsData.includes(value));

                            const shouldShow = matchesSpec && matchesColors;

                            box.classList.toggle('digi-hidden', !shouldShow);

                            const colorBoxes = Array.from(
                                box.querySelectorAll('._color-box')
                            );

                            colorBoxes.forEach(cBox => {
                                const colorsBoxData = (cBox.dataset.color || '').split('|').filter(Boolean);

                                const matchesCBoxes =
                                    activeFilters.colors.length === 0 ||
                                    activeFilters.colors.some(value => colorsBoxData.includes(value));

                                cBox.classList.toggle('digi-hidden', !matchesCBoxes);
                            });
                        });

                        const noResultsEl = materialsContent.querySelector('._no-results-wrapper');
                        const hasVisibleItems = materialsContent.querySelector('._material-box:not(.digi-hidden)');

                        if (!hasVisibleItems) {
                            if (!noResultsEl) {
                                materialsContent.insertAdjacentHTML('beforeend', `
                                    <div class='_no-results-wrapper'>
                                        <div class='_title'>${TRANSLATE.box__material.aside_panel_content.filters.no_results.title}</div>
                                        <div class='_subtitle'>${TRANSLATE.box__material.aside_panel_content.filters.no_results.subtitle}</div>
                                        <button type="button" class="_clear_all_filters">
                                            ${TRANSLATE.box__material.aside_panel_content.filters.reset_filters}
                                        </button>
                                    </div>
                                `);

                                const clearBtn = box.querySelector('._no-results-wrapper ._clear_all_filters');
                                if (clearBtn) {
                                    clearBtn.addEventListener('click', () => {
                                        __customSelectInstances.forEach(instance => {
                                            instance.clear();
                                        });
                                    });
                                };
                            }
                        } else {
                            noResultsEl?.remove();
                        };
                    };

                    const properties = box.querySelector('#digi_filters-spec');
                    const colors = box.querySelector('#digi_filters-colors');
                    const selectedFiltersContent = box.querySelector('._selected-filters');

                    const activeFilters = {
                        spec: [],
                        colors: []
                    };

                    let isFirstInit = {
                        properties: true,
                        colors: true
                    };

                    if (properties) {
                        __customSelectInit(properties, {
                            selectedFiltersContent,
                            filterType: TRANSLATE.box__material.aside_panel_content.filters.fabric_properties.single_selected_filter,
                            onChange: (selectedValues) => {
                                activeFilters.spec = selectedValues;
                                applyFilters();

                                if (isFirstInit.properties) {
                                    isFirstInit.properties = false;
                                } else {
                                    __EVENTS({
                                        ecommerce: {
                                            button_name: "filtry",
                                            button_type: "detail",
                                            section_name: "tkanina_i_kolor",
                                            option: '-',
                                            selected: selectedValues,
                                            filter_box: "wlasciwosci",
                                            view: 1,
                                            etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                        }
                                    }, true);
                                };
                            },
                            bottomSheetData: {
                                key: 'filters',
                                title: TRANSLATE.box__material.aside_panel_content.filters.fabric_properties.title
                            }
                        });
                    }

                    if (colors) {
                        __customSelectInit(colors, {
                            selectedFiltersContent,
                            filterType: TRANSLATE.box__material.aside_panel_content.filters.colors.single_selected_filter,
                            onChange: (selectedValues) => {
                                activeFilters.colors = selectedValues;
                                applyFilters();

                                if (!isFirstInit.colors) {
                                    isFirstInit.colors = false;
                                } else {
                                    __EVENTS({
                                        ecommerce: {
                                            button_name: "filtry",
                                            button_type: "detail",
                                            section_name: "tkanina_i_kolor",
                                            option: '-',
                                            selected: selectedValues,
                                            filter_box: "kolory",
                                            view: 1,
                                            etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                        }
                                    }, true);
                                };
                            },
                            bottomSheetData: {
                                key: 'filters',
                                title: TRANSLATE.box__material.aside_panel_content.filters.colors.title
                            }
                        });
                    }

                    applyFilters();
                    stickyElement(box.querySelector('._filters._pg-top-cut'));


                    // Material Select
                    const applyNewMatterial__Gallery = () => {
                        const gallery = box.querySelector('._product-gallery');
                        if (!gallery) return;

                        const slides = Array.from(gallery.querySelectorAll('._product-gallery__slide'));
                        if (!slides.length) return;

                        gallery.classList.add('digi-pg-loading');
                        setTimeout(() => {
                            slides.forEach(slide => {
                                const productNewImgSrc = document.querySelector(`media-gallery ul li.product__media-item:nth-child(${slide.querySelector('img[src]').dataset.imgKey}) modal-opener .product__media img[src]`)?.src;

                                if (productNewImgSrc) {
                                    slide.querySelector('img[src]').src = productNewImgSrc;
                                };
                            });

                            setTimeout(() => {
                                gallery.classList.remove('digi-pg-loading');
                            }, 250);
                        }, 250);
                    };

                    Array.from(materialsContent.querySelectorAll('._color-box input[type="radio"]')).forEach(colorBox => {
                        colorBox.addEventListener('change', function () {
                            materialsContent.querySelector('._color-box.digi-checked')?.classList.remove('digi-checked');

                            this.parentNode.classList.add('digi-checked');

                            CURRENT_INPUTS_DATA['material'] = this.dataset.material;
                            CURRENT_INPUTS_DATA['color'] = this.value;

                            const configElement = configPanel;
                            if (!configElement) return;

                            const originalMaterialInput = configElement.querySelector(`fieldset input[data-tech-name='${this.dataset.material}']:not([data-show-color])`);
                            if (!originalMaterialInput) return;

                            const colorGroup = this.dataset.material.replaceAll('-', ' ');
                            const originalColorInput = configElement.querySelector(`fieldset input[data-tech-name='${this.value}'][data-group='${colorGroup.charAt(0).toUpperCase() + colorGroup.slice(1)}']`);
                            if (!originalColorInput) return;

                            const frontMaterials = Array.from(document.querySelectorAll(`#digi-new-configurator .digi-config__box[box-static-name='material'] .box-content .digi-box-label`));
                            const foundCheckedMaterial = frontMaterials.find(el => el.classList.contains('digi-checked'));
                            const foundMaterial = frontMaterials.find(el => (el.dataset.value === this.dataset.material) && (el.dataset.color === CURRENT_INPUTS_DATA['color']));

                            if (foundCheckedMaterial) {
                                foundCheckedMaterial.classList.remove('digi-checked');
                            };

                            if (foundMaterial) {
                                foundMaterial.classList.add('digi-checked');
                            } else {
                                const firstClone = frontMaterials[0];
                                firstClone.dataset.value = this.dataset.material;
                                firstClone.dataset.color = this.value;
                                firstClone.querySelector('input').value = this.dataset.material;
                                firstClone.querySelector('.value').innerHTML = __getMaterialData({ color: this.value }).basic.color.image;
                                firstClone.classList.add('digi-checked');

                                frontMaterials[0].remove();
                                document.querySelector(`#digi-new-configurator .digi-config__box[box-static-name='material'] .box-content`).insertAdjacentElement('afterbegin', firstClone);
                            };


                            originalMaterialInput.click();
                            originalColorInput.click();

                            applyNewMatterial__Gallery();

                            originalColorInput.value = originalColorInput.value.trim().replaceAll('-', ' ');
                            document.querySelector(`#digi-new-configurator .digi-config__box[box-static-name='material'] .box-summary-content .s-el[summary-name="material"] .s-v`).innerHTML = originalMaterialInput.value.charAt(0).toUpperCase() + originalMaterialInput.value.slice(1);
                            document.querySelector(`#digi-new-configurator .digi-config__box[box-static-name='material'] .box-summary-content .s-el[summary-name="color"] .s-v`).innerHTML = originalColorInput.value.charAt(0).toUpperCase() + originalColorInput.value.slice(1);

                            __EVENTS({
                                ecommerce: {
                                    button_name: "tkanina_i_kolor",
                                    button_type: "detail",
                                    material: CURRENT_INPUTS_DATA['material'],
                                    option: CURRENT_INPUTS_DATA['color'],
                                    view: 1,
                                    etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                                }
                            });
                        });
                    });


                    // Autoscroll
                    setTimeout(() => {
                        if (asidePanelData.config.autoscroll) {
                            autoScrollToElement(
                                document.querySelector(`#digi-aside-panel__${key} .digi-content`),
                                document.querySelector(`#digi-aside-panel__${key} ._material-content ._color-box.digi-checked`)
                            );

                            setTimeout(() => {
                                autoScrollToElement(
                                    document.querySelector(`#digi-aside-panel__${key} .digi-content ._material-colors-list:has(.digi-checked)`),
                                    document.querySelector(`#digi-aside-panel__${key} ._material-content ._color-box.digi-checked`),
                                    'X'
                                );
                            }, 100);
                        };
                    }, 300);
                };


                const freeFabricSampleBar = box.querySelector('a.digi-free-fabric-samples');
                if (freeFabricSampleBar) {
                    freeFabricSampleBar.addEventListener('click', function (event) {
                        event.preventDefault();

                        __EVENTS({
                            ecommerce: {
                                button_name: "wybierz_darmowe_probki_tkanin",
                                button_type: "detail",
                                option: '-',
                                view: 1,
                                etap: typeof customData !== "undefined" ? customData?.etap ?? "-" : "-"
                            }
                        }, true);

                        setTimeout(() => {
                            window.location.href = this.href;
                        }, 100);
                    });
                };
            };

            __asidePanelLogic(key);
            __webBadges(true);
            document.body.classList.add('__digi-configurator__fixed-view');
        };

        __priceDifferenceUpdate();
        keysForEvents.forEach(key => {
            __logic(key);
        });

        const webButton_addToCart = '.product-form__buy-buttons .product-form__buttons';
        waitForElement(webButton_addToCart, (node) => {
            __saveConfiguration(node);
        });
    };

    const __changeWebConfiguratorTrigger = (webTrigger) => {
        const webBtnTrigger = webTrigger;
        if (!webBtnTrigger) return;

        const webBtnTriggerClone = webBtnTrigger.cloneNode(true);
        webBtnTrigger.insertAdjacentElement('beforebegin', webBtnTriggerClone);
        webBtnTrigger.remove();

        webBtnTriggerClone.addEventListener('click', function () {
            autoScrollToElement(
                window,
                document.querySelector('#digi-new-configurator')
            );
        });
    };

    const __init = () => {
        const webConfiguratorSelector = 'modal-dialog[id*="PopupModal-product_configurator"].product-popup-modal.product-popup-modal--configurator';
        waitForElement(webConfiguratorSelector, (node) => {
            __newConfigurator(node);
        });

        const webConfiguratorTrigger = '.digi-sticky-btn-container button#digi-config-product';
        waitForElement(webConfiguratorTrigger, (node) => {
            __changeWebConfiguratorTrigger(node);
        });
    };

    __init();

})();